(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("946Tx", function(module, exports) {

var $6OzBR = parcelRequire("6OzBR");
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        'navigation',
        'request',
        'process',
        'log',
        'user',
        'state',
        'error',
        'manual'
    ];
    // Array#reduce
    var _$reduce_17 = function _$reduce_17(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#filter
    var _$filter_12 = function _$filter_12(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#includes
    var _$includes_13 = function _$includes_13(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function _$isArray_14(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable('toString');
    var _dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    // Object#keys
    var _$keys_15 = function _$keys_15(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function _$intRange_24(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function _$listOfFunctions_25(value) {
        return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === 'function';
        }).length === value.length;
    };
    var _$stringWithLength_26 = function _$stringWithLength_26(value) {
        return typeof value === 'string' && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function defaultErrorTypes() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function defaultValue() {
                return null;
            },
            message: 'is required',
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function defaultValue() {
                return undefined;
            },
            message: 'should be a string',
            validate: function validate(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function defaultValue() {
                return undefined;
            },
            message: 'should be a string',
            validate: function validate(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function defaultValue() {
                return true;
            },
            message: 'should be true|false',
            validate: function validate(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function defaultValue() {
                return defaultErrorTypes();
            },
            message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
            allowPartialObject: true,
            validate: function validate(value) {
                // ensure we have an object
                if ((typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)) !== 'object' || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== 'boolean';
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function defaultValue() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function defaultValue() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function defaultValue() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function defaultValue() {
                return {
                    notify: 'https://notify.bugsnag.com',
                    sessions: 'https://sessions.bugsnag.com'
                };
            },
            message: 'should be an object containing endpoint URLs { notify, sessions }',
            validate: function validate(val) {
                return(// first, ensure it's an object
                val && (typeof val === "undefined" ? "undefined" : (0, $6OzBR._)(val)) === 'object' && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        'notify',
                        'sessions'
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function defaultValue(val) {
                return true;
            },
            message: 'should be true|false',
            validate: function validate(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function defaultValue() {
                return null;
            },
            message: 'should be an array of strings',
            validate: function validate(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === 'string';
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function defaultValue() {
                return 'production';
            },
            message: 'should be a string',
            validate: function validate(value) {
                return typeof value === 'string' && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function defaultValue() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function validate(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function defaultValue() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
            validate: function validate(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function defaultValue() {
                return undefined;
            },
            message: 'should be a string',
            validate: function validate(value) {
                return value === undefined || typeof value === 'string';
            }
        },
        user: {
            defaultValue: function defaultValue() {
                return {};
            },
            message: 'should be an object with { id, email, name } properties',
            validate: function validate(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        'id',
                        'email',
                        'name'
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function defaultValue() {
                return {};
            },
            message: 'should be an object',
            validate: function validate(value) {
                return (typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)) === 'object' && value !== null;
            }
        },
        logger: {
            defaultValue: function defaultValue() {
                return undefined;
            },
            message: 'should be null or an object with methods { debug, info, warn, error }',
            validate: function validate(value) {
                return !value || value && _$reduce_17([
                    'debug',
                    'info',
                    'warn',
                    'error'
                ], function(accum, method) {
                    return accum && typeof value[method] === 'function';
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function defaultValue() {
                return [
                    'password'
                ];
            },
            message: 'should be an array of strings|regexes',
            validate: function validate(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === 'string' || s && typeof s.test === 'function';
                }).length;
            }
        },
        plugins: {
            defaultValue: function defaultValue() {
                return [];
            },
            message: 'should be an array of plugin objects',
            validate: function validate(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && (typeof p === "undefined" ? "undefined" : (0, $6OzBR._)(p)) === 'object' && typeof p.load === 'function';
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function defaultValue() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function validate(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && (typeof feature === "undefined" ? "undefined" : (0, $6OzBR._)(feature)) === 'object' && typeof feature.name === 'string';
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function _$assign_11(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#map
    var _$map_16 = function _$map_16(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function defaultValue() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
                return 'production';
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function defaultValue() {
                return 'browser';
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function defaultValue() {
                return(// set logger based on browser capability
                typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function getPrefixedConsole() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            'debug',
            'info',
            'warn',
            'error'
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
        else if ((typeof _$stackframe_34 === "undefined" ? "undefined" : (0, $6OzBR._)(_$stackframe_34)) === 'object') _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        'use strict';
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            'isConstructor',
            'isEval',
            'isNative',
            'isToplevel'
        ];
        var numericProps = [
            'columnNumber',
            'lineNumber'
        ];
        var stringProps = [
            'fileName',
            'functionName',
            'source'
        ];
        var arrayProps = [
            'args'
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function getArgs() {
                return this.args;
            },
            setArgs: function setArgs(v) {
                if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
                this.args = v;
            },
            getEvalOrigin: function getEvalOrigin() {
                return this.evalOrigin;
            },
            setEvalOrigin: function setEvalOrigin(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError('Eval Origin must be an Object or StackFrame');
            },
            toString: function toString() {
                var functionName = this.getFunctionName() || '{anonymous}';
                var args = '(' + (this.getArgs() || []).join(',') + ')';
                var fileName = this.getFileName() ? '@' + this.getFileName() : '';
                var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
                var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype['set' + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + ' must be a Number');
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype['set' + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
            'stackframe'
        ], factory);
        else if ((typeof _$errorStackParser_31 === "undefined" ? "undefined" : (0, $6OzBR._)(_$errorStackParser_31)) === 'object') _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        'use strict';
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error('Cannot parse given Error object');
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(':') === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                    var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(' ') || undefined;
                    var fileName = [
                        'eval',
                        '<anonymous>'
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                    if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split('\n');
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split('\n');
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || '';
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                    var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function _$safeJsonStringify_30(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = '...';
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return '[Throws: ' + (err ? err.message : '?') + ']';
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, $6OzBR._)(obj)) !== 'object') return obj;
            if (find(seen, obj)) return '[Circular]';
            seen.push(obj);
            if (typeof obj.toJSON === 'function') try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat('[]')));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = '[REDACTED]';
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== 'string') return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== 'string') variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === 'number') {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || (typeof feature === "undefined" ? "undefined" : (0, $6OzBR._)(feature)) !== 'object') continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === 'string') flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === 'number') {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function _$hasStack_19(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case '[object Error]':
                return true;
            case '[object Exception]':
                return true;
            case '[object DOMException]':
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function __add_22(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section);
        // normalise the two supported input types into object form
        if ((typeof keyOrObj === "undefined" ? "undefined" : (0, $6OzBR._)(keyOrObj)) === 'object') updates = keyOrObj;
        if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function get(state, section, key) {
        if (typeof section !== 'string') return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function __clear_22(state, section, key) {
        if (typeof section !== 'string') return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stack-generator', [
            'stackframe'
        ], factory);
        else if ((typeof _$stackGenerator_33 === "undefined" ? "undefined" : (0, $6OzBR._)(_$stackGenerator_33)) === 'object') _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if ((typeof opts === "undefined" ? "undefined" : (0, $6OzBR._)(opts)) === 'object' && typeof opts.maxStackSize === 'number') maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr['arguments']){
                    // Allow V8 optimizations
                    var args = new Array(curr['arguments'].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr['arguments'][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    });
    function ___extends_6() {
        ___extends_6 = Object.assign ? Object.assign.bind() : function ___extends_6(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return ___extends_6.apply(this, arguments);
    } /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this._correlation = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        } /**
     * Associate this event with a specific trace. This is usually done automatically when
     * using bugsnag-js-performance, but can also be set manually if required.
     *
     * @param traceId the ID of the trace the event occurred within
     * @param spanId the ID of the span that the event occurred within
     */ ;
        _proto.setTraceCorrelation = function setTraceCorrelation(traceId, spanId) {
            if (typeof traceId === 'string') this._correlation = ___extends_6({
                traceId: traceId
            }, typeof spanId === 'string' ? {
                spanId: spanId
            } : {});
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: '4',
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags(),
                correlation: this._correlation
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function formatStackframe(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = 'global code';
        return f;
    };
    var normaliseFunctionName = function normaliseFunctionName(name) {
        return /^global code$/i.test(name) ? 'global code' : name;
    };
    var defaultHandledState = function defaultHandledState() {
        return {
            unhandled: false,
            severity: 'warning',
            severityReason: {
                type: 'handledException'
            }
        };
    };
    var ensureString = function ensureString(str) {
        return typeof str === 'string' ? str : '';
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === '{}') return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === 'InvalidError') event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, 'error cause'), error = _normaliseError2[0];
                if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function makeSerialisable(err) {
        if (err === null) return 'null';
        if (err === undefined) return 'undefined';
        return err;
    };
    var normaliseError = function normaliseError(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function createAndLogInputError(reason) {
            var verb = component === 'error cause' ? 'was' : 'received';
            if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
            var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
            err.name = 'InvalidError';
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError === "undefined" ? "undefined" : (0, $6OzBR._)(maybeError));
                internalFrames += 2;
            }
        } else switch(typeof maybeError === "undefined" ? "undefined" : (0, $6OzBR._)(maybeError)){
            case 'string':
            case 'number':
            case 'boolean':
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case 'function':
                error = createAndLogInputError('function');
                internalFrames += 2;
                break;
            case 'object':
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError('nothing');
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = 'browserjs';
    var hasNecessaryFields = function hasNecessaryFields(error) {
        return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function _$asyncEvery_7(arr, fn, cb) {
        var index = 0;
        var next = function next1() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function _$callbackRunner_9(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function runMaybeAsyncCallback(fn, cb) {
            if (typeof fn !== 'function') return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === 'function') return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function _$syncCallbackRunner_23(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = (typeof window === "undefined" ? "undefined" : (0, $6OzBR._)(window)) === 'object' ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function noop() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var _$self = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(_$self, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error('No Bugsnag API Key set');
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
            }
            // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);
            if (ignore) {
                this._logger.debug('Session not started due to onSession callback');
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === 'string' ? message : '';
            type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
            metadata = (typeof metadata === "undefined" ? "undefined" : (0, $6OzBR._)(metadata)) === 'object' && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);
            if (ignore) {
                this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function onCallbackError(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug('Event not sent due to onError callback');
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled('error')) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, 'error');
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: 'userCallbackSetSeverity'
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function generateConfigErrorMessage(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join('\n\n'));
        return er;
    };
    var stringify = function stringify(val) {
        switch(typeof val === "undefined" ? "undefined" : (0, $6OzBR._)(val)){
            case 'string':
            case 'number':
            case 'object':
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        'events.[].metaData',
        'events.[].breadcrumbs.[].metaData',
        'events.[].request'
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function _$delivery_36(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function sendEvent(event, cb) {
                if (cb === void 0) cb = function cb() {};
                var url = getApiUrl(client._config, 'notify', '4', win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error('Event failed to send');
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function sendSession(session, cb) {
                if (cb === void 0) cb = function cb() {};
                var url = getApiUrl(client._config, 'sessions', '1', win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function getApiUrl(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function matchPageProtocol(endpoint, pageProtocol) {
        return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function _$delivery_37(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function sendEvent(event, cb) {
                if (cb === void 0) cb = function cb() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '4');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function sendSession(session, cb) {
                if (cb === void 0) cb = function cb() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '1');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function reset() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: 'appDuration',
        load: function load(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function _$context_39(win) {
        if (win === void 0) win = window;
        return {
            load: function load(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = (typeof window === "undefined" ? "undefined" : (0, $6OzBR._)(window)) === 'object' ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';
    var getDeviceId = function getDeviceId(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function _$device_40(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function load(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? 'landscape' : 'portrait';
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function validate(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function defaultValue() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    var setDefaultUserId = function setDefaultUserId(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function _$request_44(win) {
        if (win === void 0) win = window;
        return {
            load: function load(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function load(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function startSession(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function resumeSession(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function pauseSession(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function load(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
                event._user = _$assign_11({
                    id: '[REDACTED]'
                }, event._user);
                event.request = _$assign_11({
                    clientIp: '[REDACTED]'
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function defaultValue() {
                    return true;
                },
                message: 'should be true|false',
                validate: function validate(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb('Console output', _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = '[Unknown value]';
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === '[object Object]') // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf('group') === 0 ? 'log' : method
                }), 'log');
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        'log',
        'debug',
        'info',
        'warn',
        'error'
    ], function(method) {
        return typeof console !== 'undefined' && typeof console[method] === 'function';
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function _$inlineScriptContent_48(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function load(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = '';
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';
                var getHtml = function getHtml() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === 'interactive') {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function updateLastScript(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function getCurrentScript() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName('script');
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function addSurroundingCode(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        '<!-- DOC START -->'
                    ].concat(html.split('\n'));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function cleanUrl(url) {
                        return url.replace(/#.*$/, '').replace(/\?.*$/, '');
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    'setTimeout',
                    'setInterval',
                    'setImmediate',
                    'requestAnimationFrame'
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function get() {
                                    return args[0];
                                },
                                replace: function replace(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    'EventTarget',
                    'Window',
                    'Node',
                    'ApplicationCache',
                    'AudioTrackList',
                    'ChannelMergerNode',
                    'CryptoOperation',
                    'EventSource',
                    'FileReader',
                    'HTMLUnknownElement',
                    'IDBDatabase',
                    'IDBRequest',
                    'IDBTransaction',
                    'KeyOperation',
                    'MediaController',
                    'MessagePort',
                    'ModalWindow',
                    'Notification',
                    'SVGElementInstance',
                    'Screen',
                    'TextTrack',
                    'TextTrackCue',
                    'TextTrackList',
                    'WebSocket',
                    'WebSocketWorker',
                    'Worker',
                    'XMLHttpRequest',
                    'XMLHttpRequestEventTarget',
                    'XMLHttpRequestUpload'
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;
                    __proxy(win[o].prototype, 'addEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, 'removeEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== 'function') return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function validate(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function defaultValue() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
        return {
            get: function get() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function replace(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function _$interactionBreadcrumbs_49(win) {
        if (win === void 0) win = window;
        return {
            load: function load(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('user')) return;
                win.addEventListener('click', function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = '[hidden]';
                        targetSelector = '[hidden]';
                        client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
                    }
                    client.leaveBreadcrumb('UI click', {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, 'user');
                }, true);
            }
        };
    };
    var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || '';
        if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
        text = text.replace(trim, '$1');
        if (text.length > 140) return text.slice(0, 135) + '(...)';
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push('#' + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.'));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');
        try {
            if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join('');
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
        return parts.join('');
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function _$navigationBreadcrumbs_50(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function load(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('navigation')) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function drop(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, 'navigation');
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener('pagehide', drop('Page hidden'), true);
                win.addEventListener('pageshow', drop('Page shown'), true);
                win.addEventListener('load', drop('Page loaded'), true);
                win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener('load', function() {
                    return win.addEventListener('popstate', drop('Navigated back'), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener('hashchange', function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function relativeLocation(url, win) {
        var a = win.document.createElement('A');
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function stateChangeToMetadata(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function wrapHistoryFn(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation');
            // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === 'function') client.resetEventCount();
            // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function getCurrentState(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = 'request'; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function _$networkBreadcrumbs_51(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function load(client) {
                if (!client._isBreadcrumbTypeEnabled('request')) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open;
                    // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function error() {
                            return handleXHRError(method, url);
                        };
                        var load = function load() {
                            return handleXHRLoad(method, url, _this.status);
                        };
                        // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener('load', load);
                            this.removeEventListener('error', error);
                        }
                        // attach load event listener
                        this.addEventListener('load', load);
                        // attach error event listener
                        this.addEventListener('error', error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb('XMLHttpRequest error', {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!('fetch' in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && (typeof urlOrRequest === "undefined" ? "undefined" : (0, $6OzBR._)(urlOrRequest)) === 'object') {
                            url = urlOrRequest.url;
                            if (options && 'method' in options) method = options.method;
                            else if (urlOrRequest && 'method' in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && 'method' in options) method = options.method;
                        }
                        if (method === undefined) method = 'GET';
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function handleFetchSuccess(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function handleFetchError(method, url) {
                    client.leaveBreadcrumb('fetch() error', {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function load(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function defaultValue() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function validate(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function load(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function strip(str) {
        return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function _$onerror_54(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = 'window onerror';
        return {
            load: function load(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: 'error',
                            unhandled: true,
                            severityReason: {
                                type: 'unhandledException'
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        (typeof messageOrEvent === "undefined" ? "undefined" : (0, $6OzBR._)(messageOrEvent)) === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error';
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || '';
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function decorateStack(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === 'string') culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function isActualNumber(n) {
        return typeof n === 'number' && String.call(n) !== 'NaN';
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function _$unhandledRejection_55(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function load(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function listener(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: 'error',
                        unhandled: true,
                        severityReason: {
                            type: 'unhandledPromiseRejection'
                        }
                    }, 'unhandledrejection handler', 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ('addEventListener' in win) win.addEventListener('unhandledrejection', listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function fixBluebirdStacktrace(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, '');
        };
    };
    var _$notifier_2 = {};
    var name = 'Bugsnag JavaScript';
    var version = '7.25.0';
    var url = 'https://github.com/bugsnag/bugsnag-js'; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    // extend the base config schema with some browser-specific options
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function createClient(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === 'string') opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_48()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug('Loaded!');
            bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function start(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function isStarted() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        'resetEventCount'
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});
parcelRegister("6OzBR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f6308f000d60ae0$export$71511d61b312f219; });
function $4f6308f000d60ae0$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


function $61e1cd97499a53aa$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $61e1cd97499a53aa$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $61e1cd97499a53aa$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $61e1cd97499a53aa$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $6b96e7964ace224b$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $12b282aa76ba0d84$export$71511d61b312f219(o) {
    $12b282aa76ba0d84$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $12b282aa76ba0d84$export$71511d61b312f219(o);
}


function $3cdc9f2cbdfc8580$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($3cdc9f2cbdfc8580$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $1c5bce6d45832ae5$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $6OzBR = parcelRequire("6OzBR");
function $5ccfbdd1e47dee78$export$71511d61b312f219(self, call) {
    if (call && ((0, $6OzBR._)(call) === "object" || typeof call === "function")) return call;
    return (0, $1c5bce6d45832ae5$export$71511d61b312f219)(self);
}


function $3722be982de5a689$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $12b282aa76ba0d84$export$71511d61b312f219)(derived);
    return (0, $5ccfbdd1e47dee78$export$71511d61b312f219)(_this, (0, $3cdc9f2cbdfc8580$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $12b282aa76ba0d84$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $66bb170d32c3ecf5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $6264c620e50e2a26$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6264c620e50e2a26$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $6264c620e50e2a26$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6264c620e50e2a26$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $45df9b60364921ae$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $39dd16d8ba159a7d$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $12b282aa76ba0d84$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $4795c936fe204129$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $4795c936fe204129$export$71511d61b312f219 = Reflect.get;
    else $4795c936fe204129$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $39dd16d8ba159a7d$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $4795c936fe204129$export$71511d61b312f219(target, property, receiver || target);
}



function $5d3240eb9d50460b$export$71511d61b312f219(o, p) {
    $5d3240eb9d50460b$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5d3240eb9d50460b$export$71511d61b312f219(o, p);
}


function $d480bdf13d98d111$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $5d3240eb9d50460b$export$71511d61b312f219)(subClass, superClass);
}



function $44df43b91545a470$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $45df9b60364921ae$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $0e36c637278130e7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0e36c637278130e7$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $0e36c637278130e7$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $6cde2b890d1b17d4$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $35a300d8f2969499$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $0a8da0611a1d198c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d2c77edd18b61b4a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $7a16c4068e830ebd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $d2c77edd18b61b4a$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $d2c77edd18b61b4a$export$71511d61b312f219)(o, minLen);
}


function $98582fd3a031d57f$export$71511d61b312f219(arr, i) {
    return (0, $6cde2b890d1b17d4$export$71511d61b312f219)(arr) || (0, $35a300d8f2969499$export$71511d61b312f219)(arr, i) || (0, $7a16c4068e830ebd$export$71511d61b312f219)(arr, i) || (0, $0a8da0611a1d198c$export$71511d61b312f219)();
}



function $e90b529d9c0c8447$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $d2c77edd18b61b4a$export$71511d61b312f219)(arr);
}


function $96a6cb5e765a671a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $c7bc622782b8db8b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $f3a38006ec5aeddb$export$71511d61b312f219(arr) {
    return (0, $e90b529d9c0c8447$export$71511d61b312f219)(arr) || (0, $96a6cb5e765a671a$export$71511d61b312f219)(arr) || (0, $7a16c4068e830ebd$export$71511d61b312f219)(arr) || (0, $c7bc622782b8db8b$export$71511d61b312f219)();
}



var $6OzBR = parcelRequire("6OzBR");
var $5dab71f46b3a9b19$exports = {};

$parcel$export($5dab71f46b3a9b19$exports, "popperGenerator", function () { return $3561709caead651b$export$ed5e13716264f202; });
$parcel$export($5dab71f46b3a9b19$exports, "detectOverflow", function () { return $941e1f366577403d$export$2e2bcd8739ae039; });
$parcel$export($5dab71f46b3a9b19$exports, "createPopperBase", function () { return $3561709caead651b$export$8f7491d57c8f97a9; });
$parcel$export($5dab71f46b3a9b19$exports, "createPopper", function () { return $f204bef4f3083f61$export$8f7491d57c8f97a9; });
$parcel$export($5dab71f46b3a9b19$exports, "createPopperLite", function () { return $eacfe047b821ceba$export$8f7491d57c8f97a9; });
var $678820a1db16104e$exports = {};

$parcel$export($678820a1db16104e$exports, "top", function () { return $678820a1db16104e$export$1e95b668f3b82d; });
$parcel$export($678820a1db16104e$exports, "bottom", function () { return $678820a1db16104e$export$40e543e69a8b3fbb; });
$parcel$export($678820a1db16104e$exports, "right", function () { return $678820a1db16104e$export$79ffe56a765070d2; });
$parcel$export($678820a1db16104e$exports, "left", function () { return $678820a1db16104e$export$eabcd2c8791e7bf4; });
$parcel$export($678820a1db16104e$exports, "auto", function () { return $678820a1db16104e$export$dfb5619354ba860; });
$parcel$export($678820a1db16104e$exports, "basePlacements", function () { return $678820a1db16104e$export$aec2ce47c367b8c3; });
$parcel$export($678820a1db16104e$exports, "start", function () { return $678820a1db16104e$export$b3571188c770cc5a; });
$parcel$export($678820a1db16104e$exports, "end", function () { return $678820a1db16104e$export$bd5df0f255a350f8; });
$parcel$export($678820a1db16104e$exports, "clippingParents", function () { return $678820a1db16104e$export$390fd549c5303b4d; });
$parcel$export($678820a1db16104e$exports, "viewport", function () { return $678820a1db16104e$export$d7b7311ec04a3e8f; });
$parcel$export($678820a1db16104e$exports, "popper", function () { return $678820a1db16104e$export$ae5ab1c730825774; });
$parcel$export($678820a1db16104e$exports, "reference", function () { return $678820a1db16104e$export$ca50aac9f3ba507f; });
$parcel$export($678820a1db16104e$exports, "variationPlacements", function () { return $678820a1db16104e$export$368f9a87e87fa4e1; });
$parcel$export($678820a1db16104e$exports, "placements", function () { return $678820a1db16104e$export$803cd8101b6c182b; });
$parcel$export($678820a1db16104e$exports, "beforeRead", function () { return $678820a1db16104e$export$421679a7c3d56e; });
$parcel$export($678820a1db16104e$exports, "read", function () { return $678820a1db16104e$export$aafa59e2e03f2942; });
$parcel$export($678820a1db16104e$exports, "afterRead", function () { return $678820a1db16104e$export$6964f6c886723980; });
$parcel$export($678820a1db16104e$exports, "beforeMain", function () { return $678820a1db16104e$export$c65e99957a05207c; });
$parcel$export($678820a1db16104e$exports, "main", function () { return $678820a1db16104e$export$f22da7240b7add18; });
$parcel$export($678820a1db16104e$exports, "afterMain", function () { return $678820a1db16104e$export$bab79516f2d662fe; });
$parcel$export($678820a1db16104e$exports, "beforeWrite", function () { return $678820a1db16104e$export$8d4d2d70e7d46032; });
$parcel$export($678820a1db16104e$exports, "write", function () { return $678820a1db16104e$export$68d8715fc104d294; });
$parcel$export($678820a1db16104e$exports, "afterWrite", function () { return $678820a1db16104e$export$70a6e5159acce2e6; });
$parcel$export($678820a1db16104e$exports, "modifierPhases", function () { return $678820a1db16104e$export$d087d3878fdf71d5; });
var $678820a1db16104e$export$1e95b668f3b82d = 'top';
var $678820a1db16104e$export$40e543e69a8b3fbb = 'bottom';
var $678820a1db16104e$export$79ffe56a765070d2 = 'right';
var $678820a1db16104e$export$eabcd2c8791e7bf4 = 'left';
var $678820a1db16104e$export$dfb5619354ba860 = 'auto';
var $678820a1db16104e$export$aec2ce47c367b8c3 = [
    $678820a1db16104e$export$1e95b668f3b82d,
    $678820a1db16104e$export$40e543e69a8b3fbb,
    $678820a1db16104e$export$79ffe56a765070d2,
    $678820a1db16104e$export$eabcd2c8791e7bf4
];
var $678820a1db16104e$export$b3571188c770cc5a = 'start';
var $678820a1db16104e$export$bd5df0f255a350f8 = 'end';
var $678820a1db16104e$export$390fd549c5303b4d = 'clippingParents';
var $678820a1db16104e$export$d7b7311ec04a3e8f = 'viewport';
var $678820a1db16104e$export$ae5ab1c730825774 = 'popper';
var $678820a1db16104e$export$ca50aac9f3ba507f = 'reference';
var $678820a1db16104e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $678820a1db16104e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $678820a1db16104e$export$b3571188c770cc5a,
        placement + "-" + $678820a1db16104e$export$bd5df0f255a350f8
    ]);
}, []);
var $678820a1db16104e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($678820a1db16104e$export$aec2ce47c367b8c3, [
    $678820a1db16104e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $678820a1db16104e$export$b3571188c770cc5a,
        placement + "-" + $678820a1db16104e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $678820a1db16104e$export$421679a7c3d56e = 'beforeRead';
var $678820a1db16104e$export$aafa59e2e03f2942 = 'read';
var $678820a1db16104e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $678820a1db16104e$export$c65e99957a05207c = 'beforeMain';
var $678820a1db16104e$export$f22da7240b7add18 = 'main';
var $678820a1db16104e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $678820a1db16104e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $678820a1db16104e$export$68d8715fc104d294 = 'write';
var $678820a1db16104e$export$70a6e5159acce2e6 = 'afterWrite';
var $678820a1db16104e$export$d087d3878fdf71d5 = [
    $678820a1db16104e$export$421679a7c3d56e,
    $678820a1db16104e$export$aafa59e2e03f2942,
    $678820a1db16104e$export$6964f6c886723980,
    $678820a1db16104e$export$c65e99957a05207c,
    $678820a1db16104e$export$f22da7240b7add18,
    $678820a1db16104e$export$bab79516f2d662fe,
    $678820a1db16104e$export$8d4d2d70e7d46032,
    $678820a1db16104e$export$68d8715fc104d294,
    $678820a1db16104e$export$70a6e5159acce2e6
];


var $72e4dec4fd94f70c$exports = {};

$parcel$export($72e4dec4fd94f70c$exports, "applyStyles", function () { return $07cf746255db163e$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "arrow", function () { return $0437a23232faf464$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "computeStyles", function () { return $debe056b400ee133$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "eventListeners", function () { return $419c8492b00b4ed3$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "flip", function () { return $dcd57645826343cf$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "hide", function () { return $2c21e337337ac3b2$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "offset", function () { return $651c35fbfd8810a7$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "popperOffsets", function () { return $ecca643d58f36331$export$2e2bcd8739ae039; });
$parcel$export($72e4dec4fd94f70c$exports, "preventOverflow", function () { return $67c4f2a526d56d6b$export$2e2bcd8739ae039; });
function $1709ef576a6963a2$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $e287ed19dcbcddd9$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $dafe54518ff7239b$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $dafe54518ff7239b$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $dafe54518ff7239b$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $07cf746255db163e$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element) || !(0, $1709ef576a6963a2$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $07cf746255db163e$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element) || !(0, $1709ef576a6963a2$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $07cf746255db163e$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $07cf746255db163e$var$applyStyles,
    effect: $07cf746255db163e$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $97647f8ba8d5aefc$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $7c55e6365210369c$export$8960430cfd85939f = Math.max;
var $7c55e6365210369c$export$96ec731ed4dcb222 = Math.min;
var $7c55e6365210369c$export$2077e0241d6afd3c = Math.round;



function $b258e7ff2d0c5d97$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b545f5a6cb61d10d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $b258e7ff2d0c5d97$export$2e2bcd8739ae039)());
}


function $84a09b52629e79b4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7c55e6365210369c$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7c55e6365210369c$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(element) ? (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b545f5a6cb61d10d$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $d8233bcf0a031991$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84a09b52629e79b4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $3661171459d24239$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $dafe54518ff7239b$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $e3e68d02473a3402$export$2e2bcd8739ae039(element) {
    return (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $7acbb790ffe7faed$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(element)) >= 0;
}




function $d5f13048fb1db5bc$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $b6d7c61797587d51$export$2e2bcd8739ae039(element) {
    if ((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $dafe54518ff7239b$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $e06dd0d94deff75d$var$getTrueOffsetParent(element) {
    if (!(0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e06dd0d94deff75d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $b258e7ff2d0c5d97$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $b258e7ff2d0c5d97$export$2e2bcd8739ae039)());
    if (isIE && (0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $b6d7c61797587d51$export$2e2bcd8739ae039)(element);
    if ((0, $dafe54518ff7239b$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e06dd0d94deff75d$export$2e2bcd8739ae039(element) {
    var window = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(element);
    var offsetParent = $e06dd0d94deff75d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7acbb790ffe7faed$export$2e2bcd8739ae039)(offsetParent) && (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $e06dd0d94deff75d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $1709ef576a6963a2$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $e06dd0d94deff75d$var$getContainingBlock(element) || window;
}


function $6bf55fb0fe836bb8$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $24f741f3ab0383ba$export$f28d906d67a997f3(min, value, max) {
    return (0, $7c55e6365210369c$export$8960430cfd85939f)(min, (0, $7c55e6365210369c$export$96ec731ed4dcb222)(value, max));
}
function $24f741f3ab0383ba$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $24f741f3ab0383ba$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f18966ae6389dbbf$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $9e742bf5ccf76ca6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f18966ae6389dbbf$export$2e2bcd8739ae039)(), paddingObject);
}


function $98eef75d7bbf8c07$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $0437a23232faf464$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9e742bf5ccf76ca6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $98eef75d7bbf8c07$export$2e2bcd8739ae039)(padding, (0, $678820a1db16104e$export$aec2ce47c367b8c3)));
};
function $0437a23232faf464$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $6bf55fb0fe836bb8$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $678820a1db16104e$export$eabcd2c8791e7bf4),
        (0, $678820a1db16104e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0437a23232faf464$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $d8233bcf0a031991$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $678820a1db16104e$export$1e95b668f3b82d) : (0, $678820a1db16104e$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $678820a1db16104e$export$40e543e69a8b3fbb) : (0, $678820a1db16104e$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $e06dd0d94deff75d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $24f741f3ab0383ba$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0437a23232faf464$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3661171459d24239$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0437a23232faf464$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0437a23232faf464$var$arrow,
    effect: $0437a23232faf464$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $0d1311ce5a1e1396$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $debe056b400ee133$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $debe056b400ee133$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7c55e6365210369c$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7c55e6365210369c$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $debe056b400ee133$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $678820a1db16104e$export$eabcd2c8791e7bf4);
    var sideY = (0, $678820a1db16104e$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $e06dd0d94deff75d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(popper);
            if ((0, $e3e68d02473a3402$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $678820a1db16104e$export$1e95b668f3b82d) || (placement === (0, $678820a1db16104e$export$eabcd2c8791e7bf4) || placement === (0, $678820a1db16104e$export$79ffe56a765070d2)) && variation === (0, $678820a1db16104e$export$bd5df0f255a350f8)) {
            sideY = (0, $678820a1db16104e$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $678820a1db16104e$export$eabcd2c8791e7bf4) || (placement === (0, $678820a1db16104e$export$1e95b668f3b82d) || placement === (0, $678820a1db16104e$export$40e543e69a8b3fbb)) && variation === (0, $678820a1db16104e$export$bd5df0f255a350f8)) {
            sideX = (0, $678820a1db16104e$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $debe056b400ee133$var$unsetSides);
    var _ref4 = roundOffsets === true ? $debe056b400ee133$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $debe056b400ee133$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $debe056b400ee133$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $debe056b400ee133$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $debe056b400ee133$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $debe056b400ee133$var$computeStyles,
    data: {}
};



var $419c8492b00b4ed3$var$passive = {
    passive: true
};
function $419c8492b00b4ed3$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $419c8492b00b4ed3$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $419c8492b00b4ed3$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $419c8492b00b4ed3$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $419c8492b00b4ed3$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $419c8492b00b4ed3$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $419c8492b00b4ed3$var$effect,
    data: {}
};


var $bde1f060ef00bb03$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $bde1f060ef00bb03$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $bde1f060ef00bb03$var$hash[matched];
    });
}



var $a1e0ead34ca7252c$var$hash = {
    start: 'end',
    end: 'start'
};
function $a1e0ead34ca7252c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $a1e0ead34ca7252c$var$hash[matched];
    });
}








function $8b14f0e42a83a44a$export$2e2bcd8739ae039(node) {
    var win = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $d1d81d05bdce31cc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84a09b52629e79b4$export$2e2bcd8739ae039)((0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(element)).left + (0, $8b14f0e42a83a44a$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $74ff5db2a587e884$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(element);
    var html = (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b545f5a6cb61d10d$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d1d81d05bdce31cc$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e40f72563733c2e9$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $8b14f0e42a83a44a$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7c55e6365210369c$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7c55e6365210369c$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d1d81d05bdce31cc$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $e3e68d02473a3402$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7c55e6365210369c$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $1fd79733563ce61b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $e3e68d02473a3402$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3fae7f363f9b1868$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(node) && (0, $1fd79733563ce61b$export$2e2bcd8739ae039)(node)) return node;
    return $3fae7f363f9b1868$export$2e2bcd8739ae039((0, $b6d7c61797587d51$export$2e2bcd8739ae039)(node));
}





function $09307dfb29015ecc$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3fae7f363f9b1868$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1fd79733563ce61b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($09307dfb29015ecc$export$2e2bcd8739ae039((0, $b6d7c61797587d51$export$2e2bcd8739ae039)(target)));
}










function $444d3d0a60858511$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3c9171489a8611fe$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84a09b52629e79b4$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3c9171489a8611fe$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $678820a1db16104e$export$d7b7311ec04a3e8f) ? (0, $444d3d0a60858511$export$2e2bcd8739ae039)((0, $74ff5db2a587e884$export$2e2bcd8739ae039)(element, strategy)) : (0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(clippingParent) ? $3c9171489a8611fe$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $444d3d0a60858511$export$2e2bcd8739ae039)((0, $e40f72563733c2e9$export$2e2bcd8739ae039)((0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3c9171489a8611fe$var$getClippingParents(element) {
    var clippingParents = (0, $09307dfb29015ecc$export$2e2bcd8739ae039)((0, $b6d7c61797587d51$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $e3e68d02473a3402$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(element) ? (0, $e06dd0d94deff75d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(clippingParent) && (0, $3661171459d24239$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $1709ef576a6963a2$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3c9171489a8611fe$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3c9171489a8611fe$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3c9171489a8611fe$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7c55e6365210369c$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7c55e6365210369c$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7c55e6365210369c$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7c55e6365210369c$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3c9171489a8611fe$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $76d813b4ccfecf43$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $678820a1db16104e$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $678820a1db16104e$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $678820a1db16104e$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $678820a1db16104e$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $6bf55fb0fe836bb8$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $678820a1db16104e$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $678820a1db16104e$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $941e1f366577403d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $678820a1db16104e$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $678820a1db16104e$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $678820a1db16104e$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9e742bf5ccf76ca6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $98eef75d7bbf8c07$export$2e2bcd8739ae039)(padding, (0, $678820a1db16104e$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $678820a1db16104e$export$ae5ab1c730825774) ? (0, $678820a1db16104e$export$ca50aac9f3ba507f) : (0, $678820a1db16104e$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3c9171489a8611fe$export$2e2bcd8739ae039)((0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84a09b52629e79b4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $76d813b4ccfecf43$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $444d3d0a60858511$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $678820a1db16104e$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $678820a1db16104e$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $678820a1db16104e$export$79ffe56a765070d2),
                (0, $678820a1db16104e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $678820a1db16104e$export$1e95b668f3b82d),
                (0, $678820a1db16104e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $29a6d880bd409476$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $678820a1db16104e$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $678820a1db16104e$export$368f9a87e87fa4e1) : (0, $678820a1db16104e$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $678820a1db16104e$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $941e1f366577403d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dcd57645826343cf$var$getExpandedFallbackPlacements(placement) {
    if ((0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement) === (0, $678820a1db16104e$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $bde1f060ef00bb03$export$2e2bcd8739ae039)(placement);
    return [
        (0, $a1e0ead34ca7252c$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $a1e0ead34ca7252c$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dcd57645826343cf$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bde1f060ef00bb03$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dcd57645826343cf$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement) === (0, $678820a1db16104e$export$dfb5619354ba860) ? (0, $29a6d880bd409476$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(placement) === (0, $678820a1db16104e$export$b3571188c770cc5a);
        var isVertical = [
            (0, $678820a1db16104e$export$1e95b668f3b82d),
            (0, $678820a1db16104e$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $941e1f366577403d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $678820a1db16104e$export$79ffe56a765070d2) : (0, $678820a1db16104e$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $678820a1db16104e$export$40e543e69a8b3fbb) : (0, $678820a1db16104e$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bde1f060ef00bb03$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $bde1f060ef00bb03$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dcd57645826343cf$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dcd57645826343cf$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $2c21e337337ac3b2$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2c21e337337ac3b2$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $678820a1db16104e$export$1e95b668f3b82d),
        (0, $678820a1db16104e$export$79ffe56a765070d2),
        (0, $678820a1db16104e$export$40e543e69a8b3fbb),
        (0, $678820a1db16104e$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2c21e337337ac3b2$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $941e1f366577403d$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $941e1f366577403d$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2c21e337337ac3b2$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2c21e337337ac3b2$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2c21e337337ac3b2$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2c21e337337ac3b2$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2c21e337337ac3b2$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $2c21e337337ac3b2$var$hide
};




function $651c35fbfd8810a7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $678820a1db16104e$export$eabcd2c8791e7bf4),
        (0, $678820a1db16104e$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $678820a1db16104e$export$eabcd2c8791e7bf4),
        (0, $678820a1db16104e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $651c35fbfd8810a7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $678820a1db16104e$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $651c35fbfd8810a7$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $651c35fbfd8810a7$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $651c35fbfd8810a7$var$offset
};



function $ecca643d58f36331$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $76d813b4ccfecf43$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ecca643d58f36331$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ecca643d58f36331$var$popperOffsets,
    data: {}
};





function $a998c8fe5838ae08$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $67c4f2a526d56d6b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $941e1f366577403d$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $97647f8ba8d5aefc$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $0d1311ce5a1e1396$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $6bf55fb0fe836bb8$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $a998c8fe5838ae08$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $678820a1db16104e$export$1e95b668f3b82d) : (0, $678820a1db16104e$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $678820a1db16104e$export$40e543e69a8b3fbb) : (0, $678820a1db16104e$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $678820a1db16104e$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $678820a1db16104e$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $d8233bcf0a031991$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $f18966ae6389dbbf$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $24f741f3ab0383ba$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $e06dd0d94deff75d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $24f741f3ab0383ba$export$f28d906d67a997f3)(tether ? (0, $7c55e6365210369c$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7c55e6365210369c$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $678820a1db16104e$export$1e95b668f3b82d) : (0, $678820a1db16104e$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $678820a1db16104e$export$40e543e69a8b3fbb) : (0, $678820a1db16104e$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $678820a1db16104e$export$1e95b668f3b82d),
            (0, $678820a1db16104e$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $24f741f3ab0383ba$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $24f741f3ab0383ba$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $67c4f2a526d56d6b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $67c4f2a526d56d6b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $6142718cb8ed0c9e$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $6f73bacfc61631f2$export$2e2bcd8739ae039(node) {
    if (node === (0, $e287ed19dcbcddd9$export$2e2bcd8739ae039)(node) || !(0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(node)) return (0, $8b14f0e42a83a44a$export$2e2bcd8739ae039)(node);
    else return (0, $6142718cb8ed0c9e$export$2e2bcd8739ae039)(node);
}








function $95da893612a891cd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7c55e6365210369c$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7c55e6365210369c$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $95da893612a891cd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(offsetParent) && $95da893612a891cd$var$isElementScaled(offsetParent);
    var documentElement = (0, $d5f13048fb1db5bc$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84a09b52629e79b4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1709ef576a6963a2$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1fd79733563ce61b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $6f73bacfc61631f2$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $dafe54518ff7239b$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84a09b52629e79b4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d1d81d05bdce31cc$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $c46efd8cb9c0f7da$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $c46efd8cb9c0f7da$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $c46efd8cb9c0f7da$var$order(modifiers); // order based on phase
    return (0, $678820a1db16104e$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $dccc0aff968e30b5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $6346ed722c7fe9ca$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $3561709caead651b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $3561709caead651b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $3561709caead651b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $3561709caead651b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $3561709caead651b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $dafe54518ff7239b$export$45a5e7f76e0caa8d)(reference) ? (0, $09307dfb29015ecc$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $09307dfb29015ecc$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $09307dfb29015ecc$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $c46efd8cb9c0f7da$export$2e2bcd8739ae039)((0, $6346ed722c7fe9ca$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$3561709caead651b$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $95da893612a891cd$export$2e2bcd8739ae039)(_$reference, (0, $e06dd0d94deff75d$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $d8233bcf0a031991$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dccc0aff968e30b5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$3561709caead651b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $3561709caead651b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $3561709caead651b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $f204bef4f3083f61$export$d34966752335dd47 = [
    (0, $419c8492b00b4ed3$export$2e2bcd8739ae039),
    (0, $ecca643d58f36331$export$2e2bcd8739ae039),
    (0, $debe056b400ee133$export$2e2bcd8739ae039),
    (0, $07cf746255db163e$export$2e2bcd8739ae039),
    (0, $651c35fbfd8810a7$export$2e2bcd8739ae039),
    (0, $dcd57645826343cf$export$2e2bcd8739ae039),
    (0, $67c4f2a526d56d6b$export$2e2bcd8739ae039),
    (0, $0437a23232faf464$export$2e2bcd8739ae039),
    (0, $2c21e337337ac3b2$export$2e2bcd8739ae039)
];
var $f204bef4f3083f61$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3561709caead651b$export$ed5e13716264f202)({
    defaultModifiers: $f204bef4f3083f61$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $eacfe047b821ceba$export$d34966752335dd47 = [
    (0, $419c8492b00b4ed3$export$2e2bcd8739ae039),
    (0, $ecca643d58f36331$export$2e2bcd8739ae039),
    (0, $debe056b400ee133$export$2e2bcd8739ae039),
    (0, $07cf746255db163e$export$2e2bcd8739ae039)
];
var $eacfe047b821ceba$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3561709caead651b$export$ed5e13716264f202)({
    defaultModifiers: $eacfe047b821ceba$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($5dab71f46b3a9b19$exports, $678820a1db16104e$exports);
$parcel$exportWildcard($5dab71f46b3a9b19$exports, $72e4dec4fd94f70c$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$elementMap = new Map();
var $2151b58506112de6$var$Data = {
    set: function(element, key, instance) {
        if (!$2151b58506112de6$var$elementMap.has(element)) $2151b58506112de6$var$elementMap.set(element, new Map());
        var instanceMap = $2151b58506112de6$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($2151b58506112de6$var$elementMap.has(element)) return $2151b58506112de6$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$2151b58506112de6$var$elementMap.has(element)) return;
        var instanceMap = $2151b58506112de6$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $2151b58506112de6$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $2151b58506112de6$var$MAX_UID = 1000000;
var $2151b58506112de6$var$MILLISECONDS_MULTIPLIER = 1000;
var $2151b58506112de6$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $2151b58506112de6$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $2151b58506112de6$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $2151b58506112de6$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $2151b58506112de6$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $2151b58506112de6$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $2151b58506112de6$var$MILLISECONDS_MULTIPLIER;
};
var $2151b58506112de6$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($2151b58506112de6$var$TRANSITION_END));
};
var $2151b58506112de6$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $6OzBR._)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $2151b58506112de6$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($2151b58506112de6$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($2151b58506112de6$var$parseSelector(object));
    return null;
};
var $2151b58506112de6$var$isVisible = function(element) {
    if (!$2151b58506112de6$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $2151b58506112de6$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $2151b58506112de6$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $2151b58506112de6$var$findShadowRoot(element.parentNode);
};
var $2151b58506112de6$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $2151b58506112de6$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $2151b58506112de6$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $2151b58506112de6$var$DOMContentLoadedCallbacks = [];
var $2151b58506112de6$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$2151b58506112de6$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $2151b58506112de6$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $2151b58506112de6$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $2151b58506112de6$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $2151b58506112de6$var$defineJQueryPlugin = function(plugin) {
    $2151b58506112de6$var$onDOMContentLoaded(function() {
        var $ = $2151b58506112de6$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $2151b58506112de6$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    var _possibleCallback;
    return typeof possibleCallback === 'function' ? (_possibleCallback = possibleCallback).call.apply(_possibleCallback, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(args)) : defaultValue;
};
var $2151b58506112de6$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $2151b58506112de6$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $2151b58506112de6$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($2151b58506112de6$var$TRANSITION_END, handler);
        $2151b58506112de6$var$execute(callback);
    };
    transitionElement.addEventListener($2151b58506112de6$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $2151b58506112de6$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $2151b58506112de6$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $2151b58506112de6$var$stripNameRegex = /\..*/;
var $2151b58506112de6$var$stripUidRegex = /::\d+$/;
var $2151b58506112de6$var$eventRegistry = {}; // Events storage
var $2151b58506112de6$var$uidEvent = 1;
var $2151b58506112de6$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $2151b58506112de6$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $2151b58506112de6$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($2151b58506112de6$var$uidEvent++) || element.uidEvent || $2151b58506112de6$var$uidEvent++;
}
function $2151b58506112de6$var$getElementEvents(element) {
    var uid = $2151b58506112de6$var$makeEventUid(element);
    element.uidEvent = uid;
    $2151b58506112de6$var$eventRegistry[uid] = $2151b58506112de6$var$eventRegistry[uid] || {};
    return $2151b58506112de6$var$eventRegistry[uid];
}
function $2151b58506112de6$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $2151b58506112de6$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $2151b58506112de6$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $2151b58506112de6$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $2151b58506112de6$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $2151b58506112de6$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $2151b58506112de6$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $2151b58506112de6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $2151b58506112de6$var$getTypeEvent(originalTypeEvent);
    if (!$2151b58506112de6$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $2151b58506112de6$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $98582fd3a031d57f$export$71511d61b312f219)($2151b58506112de6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $2151b58506112de6$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $2151b58506112de6$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $2151b58506112de6$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $2151b58506112de6$var$makeEventUid(callable, originalTypeEvent.replace($2151b58506112de6$var$namespaceRegex, ''));
    var fn = isDelegated ? $2151b58506112de6$var$bootstrapDelegationHandler(element, handler, callable) : $2151b58506112de6$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $2151b58506112de6$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $2151b58506112de6$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $2151b58506112de6$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $2151b58506112de6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $2151b58506112de6$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($2151b58506112de6$var$stripNameRegex, '');
    return $2151b58506112de6$var$customEvents[event] || event;
}
var $2151b58506112de6$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $2151b58506112de6$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $2151b58506112de6$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $98582fd3a031d57f$export$71511d61b312f219)($2151b58506112de6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $2151b58506112de6$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $2151b58506112de6$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $2151b58506112de6$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($2151b58506112de6$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $2151b58506112de6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $2151b58506112de6$var$getjQuery();
        var typeEvent = $2151b58506112de6$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $2151b58506112de6$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $2151b58506112de6$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $2151b58506112de6$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $2151b58506112de6$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $2151b58506112de6$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($2151b58506112de6$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($2151b58506112de6$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = $2151b58506112de6$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $2151b58506112de6$var$normalizeData(element.getAttribute("data-bs-".concat($2151b58506112de6$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $2151b58506112de6$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Config);
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $2151b58506112de6$var$isElement(element) ? $2151b58506112de6$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $44df43b91545a470$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $6OzBR._)(jsonConfig)) === 'object' ? jsonConfig : {}, $2151b58506112de6$var$isElement(element) ? $2151b58506112de6$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $6OzBR._)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $2151b58506112de6$var$isElement(value) ? 'element' : $2151b58506112de6$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$VERSION = '5.3.8';
/**
 * Class definition
 */ var $2151b58506112de6$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, BaseComponent);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, BaseComponent);
        element = $2151b58506112de6$var$getElement(element);
        if (!element) return (0, $5ccfbdd1e47dee78$export$71511d61b312f219)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $2151b58506112de6$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $2151b58506112de6$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $2151b58506112de6$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // Private
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $2151b58506112de6$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $2151b58506112de6$var$Data.get($2151b58506112de6$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $6OzBR._)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $2151b58506112de6$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($2151b58506112de6$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $2151b58506112de6$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $2151b58506112de6$var$parseSelector(sel);
    }).join(',') : null;
};
var $2151b58506112de6$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$2151b58506112de6$var$isDisabled(el) && $2151b58506112de6$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $2151b58506112de6$var$getSelector(element);
        if (selector) return $2151b58506112de6$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $2151b58506112de6$var$getSelector(element);
        return selector ? $2151b58506112de6$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $2151b58506112de6$var$getSelector(element);
        return selector ? $2151b58506112de6$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $2151b58506112de6$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $2151b58506112de6$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($2151b58506112de6$var$isDisabled(this)) return;
        var target = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$f = 'alert';
var $2151b58506112de6$var$DATA_KEY$a = 'bs.alert';
var $2151b58506112de6$var$EVENT_KEY$b = ".".concat($2151b58506112de6$var$DATA_KEY$a);
var $2151b58506112de6$var$EVENT_CLOSE = "close".concat($2151b58506112de6$var$EVENT_KEY$b);
var $2151b58506112de6$var$EVENT_CLOSED = "closed".concat($2151b58506112de6$var$EVENT_KEY$b);
var $2151b58506112de6$var$CLASS_NAME_FADE$5 = 'fade';
var $2151b58506112de6$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $2151b58506112de6$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Alert, BaseComponent);
    function Alert() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Alert);
        return (0, $3722be982de5a689$export$71511d61b312f219)(this, Alert, arguments);
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$enableDismissTrigger($2151b58506112de6$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$e = 'button';
var $2151b58506112de6$var$DATA_KEY$9 = 'bs.button';
var $2151b58506112de6$var$EVENT_KEY$a = ".".concat($2151b58506112de6$var$DATA_KEY$9);
var $2151b58506112de6$var$DATA_API_KEY$6 = '.data-api';
var $2151b58506112de6$var$CLASS_NAME_ACTIVE$3 = 'active';
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$6 = "click".concat($2151b58506112de6$var$EVENT_KEY$a).concat($2151b58506112de6$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $2151b58506112de6$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Button, BaseComponent);
    function Button() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Button);
        return (0, $3722be982de5a689$export$71511d61b312f219)(this, Button, arguments);
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($2151b58506112de6$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$6, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$5);
    var data = $2151b58506112de6$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$d = 'swipe';
var $2151b58506112de6$var$EVENT_KEY$9 = '.bs.swipe';
var $2151b58506112de6$var$EVENT_TOUCHSTART = "touchstart".concat($2151b58506112de6$var$EVENT_KEY$9);
var $2151b58506112de6$var$EVENT_TOUCHMOVE = "touchmove".concat($2151b58506112de6$var$EVENT_KEY$9);
var $2151b58506112de6$var$EVENT_TOUCHEND = "touchend".concat($2151b58506112de6$var$EVENT_KEY$9);
var $2151b58506112de6$var$EVENT_POINTERDOWN = "pointerdown".concat($2151b58506112de6$var$EVENT_KEY$9);
var $2151b58506112de6$var$EVENT_POINTERUP = "pointerup".concat($2151b58506112de6$var$EVENT_KEY$9);
var $2151b58506112de6$var$POINTER_TYPE_TOUCH = 'touch';
var $2151b58506112de6$var$POINTER_TYPE_PEN = 'pen';
var $2151b58506112de6$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $2151b58506112de6$var$SWIPE_THRESHOLD = 40;
var $2151b58506112de6$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $2151b58506112de6$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $2151b58506112de6$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Swipe, Config);
    function Swipe(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Swipe);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $5ccfbdd1e47dee78$export$71511d61b312f219)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $2151b58506112de6$var$EventHandler.off(this._element, $2151b58506112de6$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $2151b58506112de6$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $2151b58506112de6$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $2151b58506112de6$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($2151b58506112de6$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $2151b58506112de6$var$POINTER_TYPE_PEN || event.pointerType === $2151b58506112de6$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($2151b58506112de6$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$c = 'carousel';
var $2151b58506112de6$var$DATA_KEY$8 = 'bs.carousel';
var $2151b58506112de6$var$EVENT_KEY$8 = ".".concat($2151b58506112de6$var$DATA_KEY$8);
var $2151b58506112de6$var$DATA_API_KEY$5 = '.data-api';
var $2151b58506112de6$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $2151b58506112de6$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $2151b58506112de6$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $2151b58506112de6$var$ORDER_NEXT = 'next';
var $2151b58506112de6$var$ORDER_PREV = 'prev';
var $2151b58506112de6$var$DIRECTION_LEFT = 'left';
var $2151b58506112de6$var$DIRECTION_RIGHT = 'right';
var $2151b58506112de6$var$EVENT_SLIDE = "slide".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_SLID = "slid".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_KEYDOWN$1 = "keydown".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_DRAG_START = "dragstart".concat($2151b58506112de6$var$EVENT_KEY$8);
var $2151b58506112de6$var$EVENT_LOAD_DATA_API$3 = "load".concat($2151b58506112de6$var$EVENT_KEY$8).concat($2151b58506112de6$var$DATA_API_KEY$5);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$5 = "click".concat($2151b58506112de6$var$EVENT_KEY$8).concat($2151b58506112de6$var$DATA_API_KEY$5);
var $2151b58506112de6$var$CLASS_NAME_CAROUSEL = 'carousel';
var $2151b58506112de6$var$CLASS_NAME_ACTIVE$2 = 'active';
var $2151b58506112de6$var$CLASS_NAME_SLIDE = 'slide';
var $2151b58506112de6$var$CLASS_NAME_END = 'carousel-item-end';
var $2151b58506112de6$var$CLASS_NAME_START = 'carousel-item-start';
var $2151b58506112de6$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $2151b58506112de6$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $2151b58506112de6$var$SELECTOR_ACTIVE = '.active';
var $2151b58506112de6$var$SELECTOR_ITEM = '.carousel-item';
var $2151b58506112de6$var$SELECTOR_ACTIVE_ITEM = $2151b58506112de6$var$SELECTOR_ACTIVE + $2151b58506112de6$var$SELECTOR_ITEM;
var $2151b58506112de6$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $2151b58506112de6$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $2151b58506112de6$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $2151b58506112de6$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $2151b58506112de6$var$_obj;
var $2151b58506112de6$var$KEY_TO_DIRECTION = ($2151b58506112de6$var$_obj = {}, (0, $45df9b60364921ae$export$71511d61b312f219)($2151b58506112de6$var$_obj, $2151b58506112de6$var$ARROW_LEFT_KEY$1, $2151b58506112de6$var$DIRECTION_RIGHT), (0, $45df9b60364921ae$export$71511d61b312f219)($2151b58506112de6$var$_obj, $2151b58506112de6$var$ARROW_RIGHT_KEY$1, $2151b58506112de6$var$DIRECTION_LEFT), $2151b58506112de6$var$_obj);
var $2151b58506112de6$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $2151b58506112de6$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Carousel);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $2151b58506112de6$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($2151b58506112de6$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $2151b58506112de6$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($2151b58506112de6$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $2151b58506112de6$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $2151b58506112de6$var$EventHandler.one(this._element, $2151b58506112de6$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $2151b58506112de6$var$EventHandler.one(this._element, $2151b58506112de6$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $2151b58506112de6$var$ORDER_NEXT : $2151b58506112de6$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $2151b58506112de6$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $2151b58506112de6$var$EventHandler.on(img, $2151b58506112de6$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $2151b58506112de6$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($2151b58506112de6$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($2151b58506112de6$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $2151b58506112de6$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $2151b58506112de6$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($2151b58506112de6$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $2151b58506112de6$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $2151b58506112de6$var$ORDER_NEXT;
                var nextElement = element || $2151b58506112de6$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $2151b58506112de6$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($2151b58506112de6$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $2151b58506112de6$var$CLASS_NAME_START : $2151b58506112de6$var$CLASS_NAME_END;
                var orderClassName = isNext ? $2151b58506112de6$var$CLASS_NAME_NEXT : $2151b58506112de6$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $2151b58506112de6$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($2151b58506112de6$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($2151b58506112de6$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($2151b58506112de6$var$isRTL()) return direction === $2151b58506112de6$var$DIRECTION_LEFT ? $2151b58506112de6$var$ORDER_PREV : $2151b58506112de6$var$ORDER_NEXT;
                return direction === $2151b58506112de6$var$DIRECTION_LEFT ? $2151b58506112de6$var$ORDER_NEXT : $2151b58506112de6$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($2151b58506112de6$var$isRTL()) return order === $2151b58506112de6$var$ORDER_PREV ? $2151b58506112de6$var$DIRECTION_LEFT : $2151b58506112de6$var$DIRECTION_RIGHT;
                return order === $2151b58506112de6$var$ORDER_PREV ? $2151b58506112de6$var$DIRECTION_RIGHT : $2151b58506112de6$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$5, $2151b58506112de6$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($2151b58506112de6$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $2151b58506112de6$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($2151b58506112de6$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $2151b58506112de6$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$b = 'collapse';
var $2151b58506112de6$var$DATA_KEY$7 = 'bs.collapse';
var $2151b58506112de6$var$EVENT_KEY$7 = ".".concat($2151b58506112de6$var$DATA_KEY$7);
var $2151b58506112de6$var$DATA_API_KEY$4 = '.data-api';
var $2151b58506112de6$var$EVENT_SHOW$6 = "show".concat($2151b58506112de6$var$EVENT_KEY$7);
var $2151b58506112de6$var$EVENT_SHOWN$6 = "shown".concat($2151b58506112de6$var$EVENT_KEY$7);
var $2151b58506112de6$var$EVENT_HIDE$6 = "hide".concat($2151b58506112de6$var$EVENT_KEY$7);
var $2151b58506112de6$var$EVENT_HIDDEN$6 = "hidden".concat($2151b58506112de6$var$EVENT_KEY$7);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$4 = "click".concat($2151b58506112de6$var$EVENT_KEY$7).concat($2151b58506112de6$var$DATA_API_KEY$4);
var $2151b58506112de6$var$CLASS_NAME_SHOW$7 = 'show';
var $2151b58506112de6$var$CLASS_NAME_COLLAPSE = 'collapse';
var $2151b58506112de6$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $2151b58506112de6$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $2151b58506112de6$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($2151b58506112de6$var$CLASS_NAME_COLLAPSE, " .").concat($2151b58506112de6$var$CLASS_NAME_COLLAPSE);
var $2151b58506112de6$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $2151b58506112de6$var$WIDTH = 'width';
var $2151b58506112de6$var$HEIGHT = 'height';
var $2151b58506112de6$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $2151b58506112de6$var$Default$a = {
    parent: null,
    toggle: true
};
var $2151b58506112de6$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Collapse);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $2151b58506112de6$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $2151b58506112de6$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($2151b58506112de6$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($2151b58506112de6$var$CLASS_NAME_COLLAPSE, $2151b58506112de6$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $2151b58506112de6$var$reflow(this._element);
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_COLLAPSE, $2151b58506112de6$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($2151b58506112de6$var$CLASS_NAME_COLLAPSE);
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            // Private
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($2151b58506112de6$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $2151b58506112de6$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_HORIZONTAL) ? $2151b58506112de6$var$WIDTH : $2151b58506112de6$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $2151b58506112de6$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($2151b58506112de6$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$4, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2151b58506112de6$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $2151b58506112de6$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$a = 'dropdown';
var $2151b58506112de6$var$DATA_KEY$6 = 'bs.dropdown';
var $2151b58506112de6$var$EVENT_KEY$6 = ".".concat($2151b58506112de6$var$DATA_KEY$6);
var $2151b58506112de6$var$DATA_API_KEY$3 = '.data-api';
var $2151b58506112de6$var$ESCAPE_KEY$2 = 'Escape';
var $2151b58506112de6$var$TAB_KEY$1 = 'Tab';
var $2151b58506112de6$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $2151b58506112de6$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $2151b58506112de6$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $2151b58506112de6$var$EVENT_HIDE$5 = "hide".concat($2151b58506112de6$var$EVENT_KEY$6);
var $2151b58506112de6$var$EVENT_HIDDEN$5 = "hidden".concat($2151b58506112de6$var$EVENT_KEY$6);
var $2151b58506112de6$var$EVENT_SHOW$5 = "show".concat($2151b58506112de6$var$EVENT_KEY$6);
var $2151b58506112de6$var$EVENT_SHOWN$5 = "shown".concat($2151b58506112de6$var$EVENT_KEY$6);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$3 = "click".concat($2151b58506112de6$var$EVENT_KEY$6).concat($2151b58506112de6$var$DATA_API_KEY$3);
var $2151b58506112de6$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($2151b58506112de6$var$EVENT_KEY$6).concat($2151b58506112de6$var$DATA_API_KEY$3);
var $2151b58506112de6$var$EVENT_KEYUP_DATA_API = "keyup".concat($2151b58506112de6$var$EVENT_KEY$6).concat($2151b58506112de6$var$DATA_API_KEY$3);
var $2151b58506112de6$var$CLASS_NAME_SHOW$6 = 'show';
var $2151b58506112de6$var$CLASS_NAME_DROPUP = 'dropup';
var $2151b58506112de6$var$CLASS_NAME_DROPEND = 'dropend';
var $2151b58506112de6$var$CLASS_NAME_DROPSTART = 'dropstart';
var $2151b58506112de6$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $2151b58506112de6$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3, ".").concat($2151b58506112de6$var$CLASS_NAME_SHOW$6);
var $2151b58506112de6$var$SELECTOR_MENU = '.dropdown-menu';
var $2151b58506112de6$var$SELECTOR_NAVBAR = '.navbar';
var $2151b58506112de6$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $2151b58506112de6$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $2151b58506112de6$var$PLACEMENT_TOP = $2151b58506112de6$var$isRTL() ? 'top-end' : 'top-start';
var $2151b58506112de6$var$PLACEMENT_TOPEND = $2151b58506112de6$var$isRTL() ? 'top-start' : 'top-end';
var $2151b58506112de6$var$PLACEMENT_BOTTOM = $2151b58506112de6$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $2151b58506112de6$var$PLACEMENT_BOTTOMEND = $2151b58506112de6$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $2151b58506112de6$var$PLACEMENT_RIGHT = $2151b58506112de6$var$isRTL() ? 'left-start' : 'right-start';
var $2151b58506112de6$var$PLACEMENT_LEFT = $2151b58506112de6$var$isRTL() ? 'right-start' : 'left-start';
var $2151b58506112de6$var$PLACEMENT_TOPCENTER = 'top';
var $2151b58506112de6$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $2151b58506112de6$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $2151b58506112de6$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Dropdown);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $2151b58506112de6$var$SelectorEngine.next(_this._element, $2151b58506112de6$var$SELECTOR_MENU)[0] || $2151b58506112de6$var$SelectorEngine.prev(_this._element, $2151b58506112de6$var$SELECTOR_MENU)[0] || $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($2151b58506112de6$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($2151b58506112de6$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $2151b58506112de6$var$EventHandler.on(element, 'mouseover', $2151b58506112de6$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$6);
                $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($2151b58506112de6$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $2151b58506112de6$var$EventHandler.off(element, 'mouseover', $2151b58506112de6$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $2151b58506112de6$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $6OzBR._)(config.reference) === 'object' && !$2151b58506112de6$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($2151b58506112de6$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $5dab71f46b3a9b19$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($2151b58506112de6$var$isElement(this._config.reference)) referenceElement = $2151b58506112de6$var$getElement(this._config.reference);
                else if ((0, $6OzBR._)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $5dab71f46b3a9b19$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($2151b58506112de6$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPEND)) return $2151b58506112de6$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPSTART)) return $2151b58506112de6$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPUP_CENTER)) return $2151b58506112de6$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPDOWN_CENTER)) return $2151b58506112de6$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPUP)) return isEnd ? $2151b58506112de6$var$PLACEMENT_TOPEND : $2151b58506112de6$var$PLACEMENT_TOP;
                return isEnd ? $2151b58506112de6$var$PLACEMENT_BOTTOMEND : $2151b58506112de6$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($2151b58506112de6$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $2151b58506112de6$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $44df43b91545a470$export$71511d61b312f219)({}, defaultBsPopperConfig, $2151b58506112de6$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $2151b58506112de6$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $2151b58506112de6$var$getNextActiveElement(items, target, key === $2151b58506112de6$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $2151b58506112de6$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $2151b58506112de6$var$TAB_KEY$1) return;
                var openToggles = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $2151b58506112de6$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $2151b58506112de6$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $2151b58506112de6$var$ARROW_UP_KEY$1,
                    $2151b58506112de6$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3) ? this : $2151b58506112de6$var$SelectorEngine.prev(this, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3)[0] || $2151b58506112de6$var$SelectorEngine.next(this, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3)[0] || $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_KEYDOWN_DATA_API, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3, $2151b58506112de6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_KEYDOWN_DATA_API, $2151b58506112de6$var$SELECTOR_MENU, $2151b58506112de6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$3, $2151b58506112de6$export$931cbfb6bfb85fc.clearMenus);
$2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_KEYUP_DATA_API, $2151b58506112de6$export$931cbfb6bfb85fc.clearMenus);
$2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$3, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $2151b58506112de6$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$9 = 'backdrop';
var $2151b58506112de6$var$CLASS_NAME_FADE$4 = 'fade';
var $2151b58506112de6$var$CLASS_NAME_SHOW$5 = 'show';
var $2151b58506112de6$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($2151b58506112de6$var$NAME$9);
var $2151b58506112de6$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $2151b58506112de6$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $2151b58506112de6$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Backdrop, Config);
    function Backdrop(config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Backdrop);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $2151b58506112de6$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $2151b58506112de6$var$reflow(element);
                element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $2151b58506112de6$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $2151b58506112de6$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $2151b58506112de6$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $2151b58506112de6$var$EventHandler.off(this._element, $2151b58506112de6$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($2151b58506112de6$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $2151b58506112de6$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $2151b58506112de6$var$EventHandler.on(element, $2151b58506112de6$var$EVENT_MOUSEDOWN, function() {
                    $2151b58506112de6$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $2151b58506112de6$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($2151b58506112de6$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$8 = 'focustrap';
var $2151b58506112de6$var$DATA_KEY$5 = 'bs.focustrap';
var $2151b58506112de6$var$EVENT_KEY$5 = ".".concat($2151b58506112de6$var$DATA_KEY$5);
var $2151b58506112de6$var$EVENT_FOCUSIN$2 = "focusin".concat($2151b58506112de6$var$EVENT_KEY$5);
var $2151b58506112de6$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($2151b58506112de6$var$EVENT_KEY$5);
var $2151b58506112de6$var$TAB_KEY = 'Tab';
var $2151b58506112de6$var$TAB_NAV_FORWARD = 'forward';
var $2151b58506112de6$var$TAB_NAV_BACKWARD = 'backward';
var $2151b58506112de6$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $2151b58506112de6$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $2151b58506112de6$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, FocusTrap);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $2151b58506112de6$var$EventHandler.off(document, $2151b58506112de6$var$EVENT_KEY$5); // guard against infinite focus loop
                $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $2151b58506112de6$var$EventHandler.off(document, $2151b58506112de6$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $2151b58506112de6$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $2151b58506112de6$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $2151b58506112de6$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $2151b58506112de6$var$TAB_NAV_BACKWARD : $2151b58506112de6$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($2151b58506112de6$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $2151b58506112de6$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $2151b58506112de6$var$PROPERTY_PADDING = 'padding-right';
var $2151b58506112de6$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $2151b58506112de6$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $2151b58506112de6$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($2151b58506112de6$var$SELECTOR_FIXED_CONTENT, $2151b58506112de6$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($2151b58506112de6$var$SELECTOR_STICKY_CONTENT, $2151b58506112de6$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $2151b58506112de6$var$PROPERTY_PADDING);
                this._resetElementAttributes($2151b58506112de6$var$SELECTOR_FIXED_CONTENT, $2151b58506112de6$var$PROPERTY_PADDING);
                this._resetElementAttributes($2151b58506112de6$var$SELECTOR_STICKY_CONTENT, $2151b58506112de6$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $2151b58506112de6$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $2151b58506112de6$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $2151b58506112de6$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($2151b58506112de6$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $2151b58506112de6$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$7 = 'modal';
var $2151b58506112de6$var$DATA_KEY$4 = 'bs.modal';
var $2151b58506112de6$var$EVENT_KEY$4 = ".".concat($2151b58506112de6$var$DATA_KEY$4);
var $2151b58506112de6$var$DATA_API_KEY$2 = '.data-api';
var $2151b58506112de6$var$ESCAPE_KEY$1 = 'Escape';
var $2151b58506112de6$var$EVENT_HIDE$4 = "hide".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_HIDDEN$4 = "hidden".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_SHOW$4 = "show".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_SHOWN$4 = "shown".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_RESIZE$1 = "resize".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($2151b58506112de6$var$EVENT_KEY$4);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$2 = "click".concat($2151b58506112de6$var$EVENT_KEY$4).concat($2151b58506112de6$var$DATA_API_KEY$2);
var $2151b58506112de6$var$CLASS_NAME_OPEN = 'modal-open';
var $2151b58506112de6$var$CLASS_NAME_FADE$3 = 'fade';
var $2151b58506112de6$var$CLASS_NAME_SHOW$4 = 'show';
var $2151b58506112de6$var$CLASS_NAME_STATIC = 'modal-static';
var $2151b58506112de6$var$OPEN_SELECTOR$1 = '.modal.show';
var $2151b58506112de6$var$SELECTOR_DIALOG = '.modal-dialog';
var $2151b58506112de6$var$SELECTOR_MODAL_BODY = '.modal-body';
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $2151b58506112de6$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $2151b58506112de6$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Modal);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $2151b58506112de6$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($2151b58506112de6$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $2151b58506112de6$var$EventHandler.off(window, $2151b58506112de6$var$EVENT_KEY$4);
                $2151b58506112de6$var$EventHandler.off(this._dialog, $2151b58506112de6$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $2151b58506112de6$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $2151b58506112de6$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $2151b58506112de6$var$reflow(this._element);
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $2151b58506112de6$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $2151b58506112de6$var$EventHandler.one(_this._element, $2151b58506112de6$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($2151b58506112de6$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $2151b58506112de6$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $2151b58506112de6$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$2, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $2151b58506112de6$var$EventHandler.one(target, $2151b58506112de6$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $2151b58506112de6$var$EventHandler.one(target, $2151b58506112de6$var$EVENT_HIDDEN$4, function() {
            if ($2151b58506112de6$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $2151b58506112de6$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $2151b58506112de6$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$2151b58506112de6$var$enableDismissTrigger($2151b58506112de6$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$6 = 'offcanvas';
var $2151b58506112de6$var$DATA_KEY$3 = 'bs.offcanvas';
var $2151b58506112de6$var$EVENT_KEY$3 = ".".concat($2151b58506112de6$var$DATA_KEY$3);
var $2151b58506112de6$var$DATA_API_KEY$1 = '.data-api';
var $2151b58506112de6$var$EVENT_LOAD_DATA_API$2 = "load".concat($2151b58506112de6$var$EVENT_KEY$3).concat($2151b58506112de6$var$DATA_API_KEY$1);
var $2151b58506112de6$var$ESCAPE_KEY = 'Escape';
var $2151b58506112de6$var$CLASS_NAME_SHOW$3 = 'show';
var $2151b58506112de6$var$CLASS_NAME_SHOWING$1 = 'showing';
var $2151b58506112de6$var$CLASS_NAME_HIDING = 'hiding';
var $2151b58506112de6$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $2151b58506112de6$var$OPEN_SELECTOR = '.offcanvas.show';
var $2151b58506112de6$var$EVENT_SHOW$3 = "show".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_SHOWN$3 = "shown".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_HIDE$3 = "hide".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_HIDDEN$3 = "hidden".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_RESIZE = "resize".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API$1 = "click".concat($2151b58506112de6$var$EVENT_KEY$3).concat($2151b58506112de6$var$DATA_API_KEY$1);
var $2151b58506112de6$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($2151b58506112de6$var$EVENT_KEY$3);
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $2151b58506112de6$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $2151b58506112de6$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Offcanvas);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $2151b58506112de6$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOWING$1);
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$3, $2151b58506112de6$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $2151b58506112de6$var$ScrollBarHelper().reset();
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $2151b58506112de6$var$Backdrop({
                    className: $2151b58506112de6$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $2151b58506112de6$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $2151b58506112de6$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API$1, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($2151b58506112de6$var$isDisabled(this)) return;
    $2151b58506112de6$var$EventHandler.one(target, $2151b58506112de6$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($2151b58506112de6$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $2151b58506112de6$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $2151b58506112de6$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $2151b58506112de6$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2151b58506112de6$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $2151b58506112de6$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$2151b58506112de6$var$enableDismissTrigger($2151b58506112de6$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $2151b58506112de6$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $2151b58506112de6$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $2151b58506112de6$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $2151b58506112de6$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ var $2151b58506112de6$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $2151b58506112de6$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($2151b58506112de6$var$uriAttributes.has(attributeName)) return Boolean($2151b58506112de6$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $2151b58506112de6$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$2151b58506112de6$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$5 = 'TemplateFactory';
var $2151b58506112de6$var$Default$4 = {
    allowList: $2151b58506112de6$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $2151b58506112de6$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $2151b58506112de6$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $2151b58506112de6$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, TemplateFactory);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $44df43b91545a470$export$71511d61b312f219)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $2151b58506112de6$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $2151b58506112de6$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($2151b58506112de6$var$isElement(content)) {
                    this._putElementInTemplate($2151b58506112de6$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $2151b58506112de6$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $2151b58506112de6$var$execute(arg, [
                    undefined,
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($2151b58506112de6$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$4 = 'tooltip';
var $2151b58506112de6$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $2151b58506112de6$var$CLASS_NAME_FADE$2 = 'fade';
var $2151b58506112de6$var$CLASS_NAME_MODAL = 'modal';
var $2151b58506112de6$var$CLASS_NAME_SHOW$2 = 'show';
var $2151b58506112de6$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $2151b58506112de6$var$SELECTOR_MODAL = ".".concat($2151b58506112de6$var$CLASS_NAME_MODAL);
var $2151b58506112de6$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $2151b58506112de6$var$TRIGGER_HOVER = 'hover';
var $2151b58506112de6$var$TRIGGER_FOCUS = 'focus';
var $2151b58506112de6$var$TRIGGER_CLICK = 'click';
var $2151b58506112de6$var$TRIGGER_MANUAL = 'manual';
var $2151b58506112de6$var$EVENT_HIDE$2 = 'hide';
var $2151b58506112de6$var$EVENT_HIDDEN$2 = 'hidden';
var $2151b58506112de6$var$EVENT_SHOW$2 = 'show';
var $2151b58506112de6$var$EVENT_SHOWN$2 = 'shown';
var $2151b58506112de6$var$EVENT_INSERTED = 'inserted';
var $2151b58506112de6$var$EVENT_CLICK$1 = 'click';
var $2151b58506112de6$var$EVENT_FOCUSIN$1 = 'focusin';
var $2151b58506112de6$var$EVENT_FOCUSOUT$1 = 'focusout';
var $2151b58506112de6$var$EVENT_MOUSEENTER = 'mouseenter';
var $2151b58506112de6$var$EVENT_MOUSELEAVE = 'mouseleave';
var $2151b58506112de6$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $2151b58506112de6$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $2151b58506112de6$var$isRTL() ? 'right' : 'left'
};
var $2151b58506112de6$var$Default$3 = {
    allowList: $2151b58506112de6$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $2151b58506112de6$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Tooltip);
        var _this;
        if (typeof $5dab71f46b3a9b19$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $2151b58506112de6$var$EventHandler.off(this._element.closest($2151b58506112de6$var$SELECTOR_MODAL), $2151b58506112de6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, this.constructor.eventName($2151b58506112de6$var$EVENT_SHOW$2));
                var shadowRoot = $2151b58506112de6$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $2151b58506112de6$var$EventHandler.trigger(this._element, this.constructor.eventName($2151b58506112de6$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $2151b58506112de6$var$EventHandler.on(element, 'mouseover', $2151b58506112de6$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, _this.constructor.eventName($2151b58506112de6$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, this.constructor.eventName($2151b58506112de6$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $2151b58506112de6$var$EventHandler.off(element, 'mouseover', $2151b58506112de6$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$2151b58506112de6$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$2151b58506112de6$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$2151b58506112de6$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, _this.constructor.eventName($2151b58506112de6$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($2151b58506112de6$var$CLASS_NAME_FADE$2, $2151b58506112de6$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $2151b58506112de6$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($2151b58506112de6$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $2151b58506112de6$var$TemplateFactory((0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $45df9b60364921ae$export$71511d61b312f219)({}, $2151b58506112de6$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($2151b58506112de6$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($2151b58506112de6$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $2151b58506112de6$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $2151b58506112de6$var$AttachmentMap[placement.toUpperCase()];
                return $5dab71f46b3a9b19$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $2151b58506112de6$var$execute(arg, [
                    this._element,
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $44df43b91545a470$export$71511d61b312f219)({}, defaultBsPopperConfig, $2151b58506112de6$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $2151b58506112de6$var$EventHandler.on(this._element, this.constructor.eventName($2151b58506112de6$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context._activeTrigger[$2151b58506112de6$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$2151b58506112de6$var$TRIGGER_CLICK]);
                            context.toggle();
                        });
                        else if (trigger !== $2151b58506112de6$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $2151b58506112de6$var$TRIGGER_HOVER ? this.constructor.eventName($2151b58506112de6$var$EVENT_MOUSEENTER) : this.constructor.eventName($2151b58506112de6$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $2151b58506112de6$var$TRIGGER_HOVER ? this.constructor.eventName($2151b58506112de6$var$EVENT_MOUSELEAVE) : this.constructor.eventName($2151b58506112de6$var$EVENT_FOCUSOUT$1);
                            $2151b58506112de6$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $2151b58506112de6$var$TRIGGER_FOCUS : $2151b58506112de6$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $2151b58506112de6$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $2151b58506112de6$var$TRIGGER_FOCUS : $2151b58506112de6$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $2151b58506112de6$var$EventHandler.on(this._element.closest($2151b58506112de6$var$SELECTOR_MODAL), $2151b58506112de6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $2151b58506112de6$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($2151b58506112de6$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $44df43b91545a470$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $6OzBR._)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $2151b58506112de6$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $98582fd3a031d57f$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($2151b58506112de6$var$BaseComponent);
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$3 = 'popover';
var $2151b58506112de6$var$SELECTOR_TITLE = '.popover-header';
var $2151b58506112de6$var$SELECTOR_CONTENT = '.popover-body';
var $2151b58506112de6$var$Default$2 = (0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({}, $2151b58506112de6$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $2151b58506112de6$var$DefaultType$2 = (0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({}, $2151b58506112de6$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $2151b58506112de6$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Popover, Tooltip);
    function Popover() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Popover);
        return (0, $3722be982de5a689$export$71511d61b312f219)(this, Popover, arguments);
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $45df9b60364921ae$export$71511d61b312f219)(_obj, $2151b58506112de6$var$SELECTOR_TITLE, this._getTitle()), (0, $45df9b60364921ae$export$71511d61b312f219)(_obj, $2151b58506112de6$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($2151b58506112de6$export$28c660c63b792dea);
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$2 = 'scrollspy';
var $2151b58506112de6$var$DATA_KEY$2 = 'bs.scrollspy';
var $2151b58506112de6$var$EVENT_KEY$2 = ".".concat($2151b58506112de6$var$DATA_KEY$2);
var $2151b58506112de6$var$DATA_API_KEY = '.data-api';
var $2151b58506112de6$var$EVENT_ACTIVATE = "activate".concat($2151b58506112de6$var$EVENT_KEY$2);
var $2151b58506112de6$var$EVENT_CLICK = "click".concat($2151b58506112de6$var$EVENT_KEY$2);
var $2151b58506112de6$var$EVENT_LOAD_DATA_API$1 = "load".concat($2151b58506112de6$var$EVENT_KEY$2).concat($2151b58506112de6$var$DATA_API_KEY);
var $2151b58506112de6$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $2151b58506112de6$var$CLASS_NAME_ACTIVE$1 = 'active';
var $2151b58506112de6$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $2151b58506112de6$var$SELECTOR_TARGET_LINKS = '[href]';
var $2151b58506112de6$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $2151b58506112de6$var$SELECTOR_NAV_LINKS = '.nav-link';
var $2151b58506112de6$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $2151b58506112de6$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $2151b58506112de6$var$SELECTOR_LINK_ITEMS = "".concat($2151b58506112de6$var$SELECTOR_NAV_LINKS, ", ").concat($2151b58506112de6$var$SELECTOR_NAV_ITEMS, " > ").concat($2151b58506112de6$var$SELECTOR_NAV_LINKS, ", ").concat($2151b58506112de6$var$SELECTOR_LIST_ITEMS);
var $2151b58506112de6$var$SELECTOR_DROPDOWN = '.dropdown';
var $2151b58506112de6$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $2151b58506112de6$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $2151b58506112de6$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $2151b58506112de6$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, ScrollSpy);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $2151b58506112de6$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $2151b58506112de6$var$EventHandler.off(this._config.target, $2151b58506112de6$var$EVENT_CLICK);
                $2151b58506112de6$var$EventHandler.on(this._config.target, $2151b58506112de6$var$EVENT_CLICK, $2151b58506112de6$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $2151b58506112de6$var$isDisabled(anchor)) continue;
                        var observableSection = $2151b58506112de6$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($2151b58506112de6$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($2151b58506112de6$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($2151b58506112de6$var$SELECTOR_DROPDOWN)).classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $2151b58506112de6$var$SelectorEngine.parents(target, $2151b58506112de6$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $2151b58506112de6$var$SelectorEngine.prev(listGroup, $2151b58506112de6$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($2151b58506112de6$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $2151b58506112de6$var$SelectorEngine.find("".concat($2151b58506112de6$var$SELECTOR_TARGET_LINKS, ".").concat($2151b58506112de6$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($2151b58506112de6$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $2151b58506112de6$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME$1 = 'tab';
var $2151b58506112de6$var$DATA_KEY$1 = 'bs.tab';
var $2151b58506112de6$var$EVENT_KEY$1 = ".".concat($2151b58506112de6$var$DATA_KEY$1);
var $2151b58506112de6$var$EVENT_HIDE$1 = "hide".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_HIDDEN$1 = "hidden".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_SHOW$1 = "show".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_SHOWN$1 = "shown".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_CLICK_DATA_API = "click".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_KEYDOWN = "keydown".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$EVENT_LOAD_DATA_API = "load".concat($2151b58506112de6$var$EVENT_KEY$1);
var $2151b58506112de6$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $2151b58506112de6$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $2151b58506112de6$var$ARROW_UP_KEY = 'ArrowUp';
var $2151b58506112de6$var$ARROW_DOWN_KEY = 'ArrowDown';
var $2151b58506112de6$var$HOME_KEY = 'Home';
var $2151b58506112de6$var$END_KEY = 'End';
var $2151b58506112de6$var$CLASS_NAME_ACTIVE = 'active';
var $2151b58506112de6$var$CLASS_NAME_FADE$1 = 'fade';
var $2151b58506112de6$var$CLASS_NAME_SHOW$1 = 'show';
var $2151b58506112de6$var$CLASS_DROPDOWN = 'dropdown';
var $2151b58506112de6$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $2151b58506112de6$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $2151b58506112de6$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($2151b58506112de6$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $2151b58506112de6$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $2151b58506112de6$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $2151b58506112de6$var$SELECTOR_INNER = ".nav-link".concat($2151b58506112de6$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($2151b58506112de6$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($2151b58506112de6$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $2151b58506112de6$var$SELECTOR_INNER_ELEM = "".concat($2151b58506112de6$var$SELECTOR_INNER, ", ").concat($2151b58506112de6$var$SELECTOR_DATA_TOGGLE);
var $2151b58506112de6$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($2151b58506112de6$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($2151b58506112de6$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($2151b58506112de6$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $2151b58506112de6$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Tab, BaseComponent);
    function Tab(element) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Tab);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($2151b58506112de6$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $5ccfbdd1e47dee78$export$71511d61b312f219)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $2151b58506112de6$var$EventHandler.on(_this._element, $2151b58506112de6$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $2151b58506112de6$var$EventHandler.trigger(active, $2151b58506112de6$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(innerElem, $2151b58506112de6$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($2151b58506112de6$var$CLASS_NAME_ACTIVE);
                this._activate($2151b58506112de6$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $2151b58506112de6$var$EventHandler.trigger(element, $2151b58506112de6$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($2151b58506112de6$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($2151b58506112de6$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($2151b58506112de6$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $2151b58506112de6$var$EventHandler.trigger(element, $2151b58506112de6$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($2151b58506112de6$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $2151b58506112de6$var$ARROW_LEFT_KEY,
                    $2151b58506112de6$var$ARROW_RIGHT_KEY,
                    $2151b58506112de6$var$ARROW_UP_KEY,
                    $2151b58506112de6$var$ARROW_DOWN_KEY,
                    $2151b58506112de6$var$HOME_KEY,
                    $2151b58506112de6$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$2151b58506112de6$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $2151b58506112de6$var$HOME_KEY,
                    $2151b58506112de6$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $2151b58506112de6$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $2151b58506112de6$var$ARROW_RIGHT_KEY,
                        $2151b58506112de6$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $2151b58506112de6$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $2151b58506112de6$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($2151b58506112de6$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $2151b58506112de6$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($2151b58506112de6$var$SELECTOR_DROPDOWN_TOGGLE, $2151b58506112de6$var$CLASS_NAME_ACTIVE);
                toggle($2151b58506112de6$var$SELECTOR_DROPDOWN_MENU, $2151b58506112de6$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($2151b58506112de6$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($2151b58506112de6$var$SELECTOR_INNER_ELEM) ? elem : $2151b58506112de6$var$SelectorEngine.findOne($2151b58506112de6$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($2151b58506112de6$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$EventHandler.on(document, $2151b58506112de6$var$EVENT_CLICK_DATA_API, $2151b58506112de6$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($2151b58506112de6$var$isDisabled(this)) return;
    $2151b58506112de6$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $2151b58506112de6$var$EventHandler.on(window, $2151b58506112de6$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2151b58506112de6$var$SelectorEngine.find($2151b58506112de6$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $2151b58506112de6$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $2151b58506112de6$var$NAME = 'toast';
var $2151b58506112de6$var$DATA_KEY = 'bs.toast';
var $2151b58506112de6$var$EVENT_KEY = ".".concat($2151b58506112de6$var$DATA_KEY);
var $2151b58506112de6$var$EVENT_MOUSEOVER = "mouseover".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_MOUSEOUT = "mouseout".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_FOCUSIN = "focusin".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_FOCUSOUT = "focusout".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_HIDE = "hide".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_HIDDEN = "hidden".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_SHOW = "show".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$EVENT_SHOWN = "shown".concat($2151b58506112de6$var$EVENT_KEY);
var $2151b58506112de6$var$CLASS_NAME_FADE = 'fade';
var $2151b58506112de6$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $2151b58506112de6$var$CLASS_NAME_SHOW = 'show';
var $2151b58506112de6$var$CLASS_NAME_SHOWING = 'showing';
var $2151b58506112de6$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $2151b58506112de6$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $2151b58506112de6$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $d480bdf13d98d111$export$71511d61b312f219)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Toast);
        var _this;
        _this = (0, $3722be982de5a689$export$71511d61b312f219)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($2151b58506112de6$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOWING);
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_HIDE); // @deprecated
                $2151b58506112de6$var$reflow(this._element);
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOW, $2151b58506112de6$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $2151b58506112de6$var$EventHandler.trigger(this._element, $2151b58506112de6$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($2151b58506112de6$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOWING, $2151b58506112de6$var$CLASS_NAME_SHOW);
                    $2151b58506112de6$var$EventHandler.trigger(_this._element, $2151b58506112de6$var$EVENT_HIDDEN);
                };
                this._element.classList.add($2151b58506112de6$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($2151b58506112de6$var$CLASS_NAME_SHOW);
                (0, $4795c936fe204129$export$71511d61b312f219)((0, $12b282aa76ba0d84$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($2151b58506112de6$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $2151b58506112de6$var$EventHandler.on(this._element, $2151b58506112de6$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $2151b58506112de6$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $2151b58506112de6$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $2151b58506112de6$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($2151b58506112de6$var$BaseComponent);
/**
 * Data API implementation
 */ $2151b58506112de6$var$enableDismissTrigger($2151b58506112de6$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $2151b58506112de6$var$defineJQueryPlugin($2151b58506112de6$export$8d8dc7d5f743331b);


var $9d763a0e8ba22644$export$1b00a204b1f1aa92 = 16;
var $9d763a0e8ba22644$export$8b0894f4c14eda03 = 1272;
var $9d763a0e8ba22644$export$d37404c264af2f19 = 1181;
var $9d763a0e8ba22644$export$7c20e21b18d14832 = 'MBS';
var $9d763a0e8ba22644$export$7a948dda2e5abcb7 = {
    terms: 'http://www.goodgamestudios.com/terms_{{lang}}/#terms',
    legal: 'https://www.goodgamestudios.com/terms_{{lang}}/#imprint',
    support: 'https://support.goodgamestudios.com/',
    getTermsLink: function(lang) {
        return this.terms.replace('{{lang}}', lang);
    },
    getLegalLink: function(lang) {
        return this.legal.replace('{{lang}}', lang);
    },
    getSupportLink: function(lang, gameId) {
        return "".concat(this.support, "?lang=").concat(lang, "&g=").concat(gameId);
    }
};
var $9d763a0e8ba22644$export$7b541698c79bb80a = {
    PAGE_LOADED: 0,
    WRONG_CODE_ENTRY: 1,
    CORRECT_CODE_ENTRY: 2,
    CORRECT_CODE_ENTRY_BANNED: 3,
    ERROR_RESPONSE: 4
};







// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $46ca8c62aa8165a7$var$getRandomValues;
var $46ca8c62aa8165a7$var$rnds8 = new Uint8Array(16);
function $46ca8c62aa8165a7$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$46ca8c62aa8165a7$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $46ca8c62aa8165a7$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$46ca8c62aa8165a7$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $46ca8c62aa8165a7$var$getRandomValues($46ca8c62aa8165a7$var$rnds8);
}


var $3d8e00b9fcd72283$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $6636c6176542356f$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $3d8e00b9fcd72283$export$2e2bcd8739ae039).test(uuid);
}
var $6636c6176542356f$export$2e2bcd8739ae039 = $6636c6176542356f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $720d12ba163d02cb$var$byteToHex = [];
for(var $720d12ba163d02cb$var$i = 0; $720d12ba163d02cb$var$i < 256; ++$720d12ba163d02cb$var$i)$720d12ba163d02cb$var$byteToHex.push(($720d12ba163d02cb$var$i + 0x100).toString(16).substr(1));
function $720d12ba163d02cb$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($720d12ba163d02cb$var$byteToHex[arr[offset + 0]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 1]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 2]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 3]] + '-' + $720d12ba163d02cb$var$byteToHex[arr[offset + 4]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 5]] + '-' + $720d12ba163d02cb$var$byteToHex[arr[offset + 6]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 7]] + '-' + $720d12ba163d02cb$var$byteToHex[arr[offset + 8]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 9]] + '-' + $720d12ba163d02cb$var$byteToHex[arr[offset + 10]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 11]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 12]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 13]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 14]] + $720d12ba163d02cb$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $6636c6176542356f$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $720d12ba163d02cb$export$2e2bcd8739ae039 = $720d12ba163d02cb$var$stringify;


function $a513f127468cfa5a$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $46ca8c62aa8165a7$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $720d12ba163d02cb$export$2e2bcd8739ae039)(rnds);
}
var $a513f127468cfa5a$export$2e2bcd8739ae039 = $a513f127468cfa5a$var$v4;


var $37b4db63c35f7018$exports = {};
(function(global, factory) {
    $37b4db63c35f7018$exports = factory();
})($37b4db63c35f7018$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});




var $8100c937ef40f57c$exports = {};

$8100c937ef40f57c$exports = (parcelRequire("946Tx"));




var $6OzBR = parcelRequire("6OzBR");
'use strict';
function $5446f15cb3e1db63$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $066199d925baca9c$exports = {};
// shim for using process in browser
var $066199d925baca9c$var$process = $066199d925baca9c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $066199d925baca9c$var$cachedSetTimeout;
var $066199d925baca9c$var$cachedClearTimeout;
function $066199d925baca9c$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $066199d925baca9c$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $066199d925baca9c$var$cachedSetTimeout = setTimeout;
        else $066199d925baca9c$var$cachedSetTimeout = $066199d925baca9c$var$defaultSetTimout;
    } catch (e) {
        $066199d925baca9c$var$cachedSetTimeout = $066199d925baca9c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $066199d925baca9c$var$cachedClearTimeout = clearTimeout;
        else $066199d925baca9c$var$cachedClearTimeout = $066199d925baca9c$var$defaultClearTimeout;
    } catch (e) {
        $066199d925baca9c$var$cachedClearTimeout = $066199d925baca9c$var$defaultClearTimeout;
    }
})();
function $066199d925baca9c$var$runTimeout(fun) {
    if ($066199d925baca9c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($066199d925baca9c$var$cachedSetTimeout === $066199d925baca9c$var$defaultSetTimout || !$066199d925baca9c$var$cachedSetTimeout) && setTimeout) {
        $066199d925baca9c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $066199d925baca9c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $066199d925baca9c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $066199d925baca9c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $066199d925baca9c$var$runClearTimeout(marker) {
    if ($066199d925baca9c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($066199d925baca9c$var$cachedClearTimeout === $066199d925baca9c$var$defaultClearTimeout || !$066199d925baca9c$var$cachedClearTimeout) && clearTimeout) {
        $066199d925baca9c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $066199d925baca9c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $066199d925baca9c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $066199d925baca9c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $066199d925baca9c$var$queue = [];
var $066199d925baca9c$var$draining = false;
var $066199d925baca9c$var$currentQueue;
var $066199d925baca9c$var$queueIndex = -1;
function $066199d925baca9c$var$cleanUpNextTick() {
    if (!$066199d925baca9c$var$draining || !$066199d925baca9c$var$currentQueue) return;
    $066199d925baca9c$var$draining = false;
    if ($066199d925baca9c$var$currentQueue.length) $066199d925baca9c$var$queue = $066199d925baca9c$var$currentQueue.concat($066199d925baca9c$var$queue);
    else $066199d925baca9c$var$queueIndex = -1;
    if ($066199d925baca9c$var$queue.length) $066199d925baca9c$var$drainQueue();
}
function $066199d925baca9c$var$drainQueue() {
    if ($066199d925baca9c$var$draining) return;
    var timeout = $066199d925baca9c$var$runTimeout($066199d925baca9c$var$cleanUpNextTick);
    $066199d925baca9c$var$draining = true;
    var len = $066199d925baca9c$var$queue.length;
    while(len){
        $066199d925baca9c$var$currentQueue = $066199d925baca9c$var$queue;
        $066199d925baca9c$var$queue = [];
        while(++$066199d925baca9c$var$queueIndex < len)if ($066199d925baca9c$var$currentQueue) $066199d925baca9c$var$currentQueue[$066199d925baca9c$var$queueIndex].run();
        $066199d925baca9c$var$queueIndex = -1;
        len = $066199d925baca9c$var$queue.length;
    }
    $066199d925baca9c$var$currentQueue = null;
    $066199d925baca9c$var$draining = false;
    $066199d925baca9c$var$runClearTimeout(timeout);
}
$066199d925baca9c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $066199d925baca9c$var$queue.push(new $066199d925baca9c$var$Item(fun, args));
    if ($066199d925baca9c$var$queue.length === 1 && !$066199d925baca9c$var$draining) $066199d925baca9c$var$runTimeout($066199d925baca9c$var$drainQueue);
};
// v8 likes predictible objects
function $066199d925baca9c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$066199d925baca9c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$066199d925baca9c$var$process.title = 'browser';
$066199d925baca9c$var$process.browser = true;
$066199d925baca9c$var$process.env = {};
$066199d925baca9c$var$process.argv = [];
$066199d925baca9c$var$process.version = ''; // empty string to avoid regexp issues
$066199d925baca9c$var$process.versions = {};
function $066199d925baca9c$var$noop() {}
$066199d925baca9c$var$process.on = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.addListener = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.once = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.off = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.removeListener = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.removeAllListeners = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.emit = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.prependListener = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.prependOnceListener = $066199d925baca9c$var$noop;
$066199d925baca9c$var$process.listeners = function(name) {
    return [];
};
$066199d925baca9c$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$066199d925baca9c$var$process.cwd = function() {
    return '/';
};
$066199d925baca9c$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$066199d925baca9c$var$process.umask = function() {
    return 0;
};


'use strict';
// utils is a library of generic helper functions non-specific to axios
var $4df68d4872fe2c8b$var$toString = Object.prototype.toString;
var $4df68d4872fe2c8b$var$getPrototypeOf = Object.getPrototypeOf;
var $4df68d4872fe2c8b$var$iterator = Symbol.iterator, $4df68d4872fe2c8b$var$toStringTag = Symbol.toStringTag;
var $4df68d4872fe2c8b$var$kindOf = function(cache) {
    return function(thing) {
        var str = $4df68d4872fe2c8b$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $4df68d4872fe2c8b$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $4df68d4872fe2c8b$var$kindOf(thing) === type;
    };
};
var $4df68d4872fe2c8b$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $6OzBR._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $4df68d4872fe2c8b$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $4df68d4872fe2c8b$var$isUndefined = $4df68d4872fe2c8b$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4df68d4872fe2c8b$var$isBuffer(val) {
    return val !== null && !$4df68d4872fe2c8b$var$isUndefined(val) && val.constructor !== null && !$4df68d4872fe2c8b$var$isUndefined(val.constructor) && $4df68d4872fe2c8b$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $4df68d4872fe2c8b$var$isArrayBuffer = $4df68d4872fe2c8b$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4df68d4872fe2c8b$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4df68d4872fe2c8b$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $4df68d4872fe2c8b$var$isString = $4df68d4872fe2c8b$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $4df68d4872fe2c8b$var$isFunction = $4df68d4872fe2c8b$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $4df68d4872fe2c8b$var$isNumber = $4df68d4872fe2c8b$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $4df68d4872fe2c8b$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $6OzBR._)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $4df68d4872fe2c8b$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $4df68d4872fe2c8b$var$isPlainObject = function(val) {
    if ($4df68d4872fe2c8b$var$kindOf(val) !== 'object') return false;
    var prototype = $4df68d4872fe2c8b$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($4df68d4872fe2c8b$var$toStringTag in val) && !($4df68d4872fe2c8b$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ var $4df68d4872fe2c8b$var$isEmptyObject = function(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$4df68d4872fe2c8b$var$isObject(val) || $4df68d4872fe2c8b$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $4df68d4872fe2c8b$var$isDate = $4df68d4872fe2c8b$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $4df68d4872fe2c8b$var$isFile = $4df68d4872fe2c8b$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $4df68d4872fe2c8b$var$isBlob = $4df68d4872fe2c8b$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $4df68d4872fe2c8b$var$isFileList = $4df68d4872fe2c8b$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $4df68d4872fe2c8b$var$isStream = function(val) {
    return $4df68d4872fe2c8b$var$isObject(val) && $4df68d4872fe2c8b$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $4df68d4872fe2c8b$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $4df68d4872fe2c8b$var$isFunction(thing.append) && ((kind = $4df68d4872fe2c8b$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $4df68d4872fe2c8b$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $4df68d4872fe2c8b$var$isURLSearchParams = $4df68d4872fe2c8b$var$kindOfTest('URLSearchParams');
var $4df68d4872fe2c8b$var$_map = (0, $98582fd3a031d57f$export$71511d61b312f219)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4df68d4872fe2c8b$var$kindOfTest), 4), $4df68d4872fe2c8b$var$isReadableStream = $4df68d4872fe2c8b$var$_map[0], $4df68d4872fe2c8b$var$isRequest = $4df68d4872fe2c8b$var$_map[1], $4df68d4872fe2c8b$var$isResponse = $4df68d4872fe2c8b$var$_map[2], $4df68d4872fe2c8b$var$isHeaders = $4df68d4872fe2c8b$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $4df68d4872fe2c8b$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4df68d4872fe2c8b$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $6OzBR._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4df68d4872fe2c8b$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($4df68d4872fe2c8b$var$isBuffer(obj)) return;
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4df68d4872fe2c8b$var$findKey(obj, key) {
    if ($4df68d4872fe2c8b$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $4df68d4872fe2c8b$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $4df68d4872fe2c8b$var$isContextDefined = function(context) {
    return !$4df68d4872fe2c8b$var$isUndefined(context) && context !== $4df68d4872fe2c8b$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4df68d4872fe2c8b$var$merge() {
    var _ref = $4df68d4872fe2c8b$var$isContextDefined(this) && this || {}, caseless = _ref.caseless, skipUndefined = _ref.skipUndefined;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $4df68d4872fe2c8b$var$findKey(result, key) || key;
        if ($4df68d4872fe2c8b$var$isPlainObject(result[targetKey]) && $4df68d4872fe2c8b$var$isPlainObject(val)) result[targetKey] = $4df68d4872fe2c8b$var$merge(result[targetKey], val);
        else if ($4df68d4872fe2c8b$var$isPlainObject(val)) result[targetKey] = $4df68d4872fe2c8b$var$merge({}, val);
        else if ($4df68d4872fe2c8b$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$4df68d4872fe2c8b$var$isUndefined(val)) result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $4df68d4872fe2c8b$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $4df68d4872fe2c8b$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $4df68d4872fe2c8b$var$forEach(b, function(val, key) {
        if (thisArg && $4df68d4872fe2c8b$var$isFunction(val)) a[key] = (0, $5446f15cb3e1db63$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $4df68d4872fe2c8b$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $4df68d4872fe2c8b$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $4df68d4872fe2c8b$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4df68d4872fe2c8b$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $4df68d4872fe2c8b$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $4df68d4872fe2c8b$var$toArray = function(thing) {
    if (!thing) return null;
    if ($4df68d4872fe2c8b$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$4df68d4872fe2c8b$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $4df68d4872fe2c8b$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $4df68d4872fe2c8b$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $4df68d4872fe2c8b$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[$4df68d4872fe2c8b$var$iterator];
    var _iterator = generator.call(obj);
    var result;
    while((result = _iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $4df68d4872fe2c8b$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $4df68d4872fe2c8b$var$isHTMLForm = $4df68d4872fe2c8b$var$kindOfTest('HTMLFormElement');
var $4df68d4872fe2c8b$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $4df68d4872fe2c8b$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $4df68d4872fe2c8b$var$isRegExp = $4df68d4872fe2c8b$var$kindOfTest('RegExp');
var $4df68d4872fe2c8b$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $4df68d4872fe2c8b$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $4df68d4872fe2c8b$var$freezeMethods = function(obj) {
    $4df68d4872fe2c8b$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($4df68d4872fe2c8b$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$4df68d4872fe2c8b$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
var $4df68d4872fe2c8b$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $4df68d4872fe2c8b$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $4df68d4872fe2c8b$var$noop = function() {};
var $4df68d4872fe2c8b$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4df68d4872fe2c8b$var$isSpecCompliantForm(thing) {
    return !!(thing && $4df68d4872fe2c8b$var$isFunction(thing.append) && thing[$4df68d4872fe2c8b$var$toStringTag] === 'FormData' && thing[$4df68d4872fe2c8b$var$iterator]);
}
var $4df68d4872fe2c8b$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($4df68d4872fe2c8b$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($4df68d4872fe2c8b$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                var target = $4df68d4872fe2c8b$var$isArray(source) ? [] : {};
                $4df68d4872fe2c8b$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$4df68d4872fe2c8b$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $4df68d4872fe2c8b$var$isAsyncFn = $4df68d4872fe2c8b$var$kindOfTest('AsyncFunction');
var $4df68d4872fe2c8b$var$isThenable = function(thing) {
    return thing && ($4df68d4872fe2c8b$var$isObject(thing) || $4df68d4872fe2c8b$var$isFunction(thing)) && $4df68d4872fe2c8b$var$isFunction(thing.then) && $4df68d4872fe2c8b$var$isFunction(thing.catch);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $4df68d4872fe2c8b$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $4df68d4872fe2c8b$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $4df68d4872fe2c8b$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $4df68d4872fe2c8b$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $4df68d4872fe2c8b$var$isFunction($4df68d4872fe2c8b$var$_global.postMessage));
var $4df68d4872fe2c8b$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4df68d4872fe2c8b$var$_global) : typeof $066199d925baca9c$exports !== 'undefined' && $066199d925baca9c$exports.nextTick || $4df68d4872fe2c8b$var$_setImmediate;
// *********************
var $4df68d4872fe2c8b$var$isIterable = function(thing) {
    return thing != null && $4df68d4872fe2c8b$var$isFunction(thing[$4df68d4872fe2c8b$var$iterator]);
};
var $4df68d4872fe2c8b$export$2e2bcd8739ae039 = {
    isArray: $4df68d4872fe2c8b$var$isArray,
    isArrayBuffer: $4df68d4872fe2c8b$var$isArrayBuffer,
    isBuffer: $4df68d4872fe2c8b$var$isBuffer,
    isFormData: $4df68d4872fe2c8b$var$isFormData,
    isArrayBufferView: $4df68d4872fe2c8b$var$isArrayBufferView,
    isString: $4df68d4872fe2c8b$var$isString,
    isNumber: $4df68d4872fe2c8b$var$isNumber,
    isBoolean: $4df68d4872fe2c8b$var$isBoolean,
    isObject: $4df68d4872fe2c8b$var$isObject,
    isPlainObject: $4df68d4872fe2c8b$var$isPlainObject,
    isEmptyObject: $4df68d4872fe2c8b$var$isEmptyObject,
    isReadableStream: $4df68d4872fe2c8b$var$isReadableStream,
    isRequest: $4df68d4872fe2c8b$var$isRequest,
    isResponse: $4df68d4872fe2c8b$var$isResponse,
    isHeaders: $4df68d4872fe2c8b$var$isHeaders,
    isUndefined: $4df68d4872fe2c8b$var$isUndefined,
    isDate: $4df68d4872fe2c8b$var$isDate,
    isFile: $4df68d4872fe2c8b$var$isFile,
    isBlob: $4df68d4872fe2c8b$var$isBlob,
    isRegExp: $4df68d4872fe2c8b$var$isRegExp,
    isFunction: $4df68d4872fe2c8b$var$isFunction,
    isStream: $4df68d4872fe2c8b$var$isStream,
    isURLSearchParams: $4df68d4872fe2c8b$var$isURLSearchParams,
    isTypedArray: $4df68d4872fe2c8b$var$isTypedArray,
    isFileList: $4df68d4872fe2c8b$var$isFileList,
    forEach: $4df68d4872fe2c8b$var$forEach,
    merge: $4df68d4872fe2c8b$var$merge,
    extend: $4df68d4872fe2c8b$var$extend,
    trim: $4df68d4872fe2c8b$var$trim,
    stripBOM: $4df68d4872fe2c8b$var$stripBOM,
    inherits: $4df68d4872fe2c8b$var$inherits,
    toFlatObject: $4df68d4872fe2c8b$var$toFlatObject,
    kindOf: $4df68d4872fe2c8b$var$kindOf,
    kindOfTest: $4df68d4872fe2c8b$var$kindOfTest,
    endsWith: $4df68d4872fe2c8b$var$endsWith,
    toArray: $4df68d4872fe2c8b$var$toArray,
    forEachEntry: $4df68d4872fe2c8b$var$forEachEntry,
    matchAll: $4df68d4872fe2c8b$var$matchAll,
    isHTMLForm: $4df68d4872fe2c8b$var$isHTMLForm,
    hasOwnProperty: $4df68d4872fe2c8b$var$hasOwnProperty,
    hasOwnProp: $4df68d4872fe2c8b$var$hasOwnProperty,
    reduceDescriptors: $4df68d4872fe2c8b$var$reduceDescriptors,
    freezeMethods: $4df68d4872fe2c8b$var$freezeMethods,
    toObjectSet: $4df68d4872fe2c8b$var$toObjectSet,
    toCamelCase: $4df68d4872fe2c8b$var$toCamelCase,
    noop: $4df68d4872fe2c8b$var$noop,
    toFiniteNumber: $4df68d4872fe2c8b$var$toFiniteNumber,
    findKey: $4df68d4872fe2c8b$var$findKey,
    global: $4df68d4872fe2c8b$var$_global,
    isContextDefined: $4df68d4872fe2c8b$var$isContextDefined,
    isSpecCompliantForm: $4df68d4872fe2c8b$var$isSpecCompliantForm,
    toJSONObject: $4df68d4872fe2c8b$var$toJSONObject,
    isAsyncFn: $4df68d4872fe2c8b$var$isAsyncFn,
    isThenable: $4df68d4872fe2c8b$var$isThenable,
    setImmediate: $4df68d4872fe2c8b$var$_setImmediate,
    asap: $4df68d4872fe2c8b$var$asap,
    isIterable: $4df68d4872fe2c8b$var$isIterable
};











var $6OzBR = parcelRequire("6OzBR");


'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $878f001d6f173f24$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).inherits($878f001d6f173f24$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $878f001d6f173f24$var$prototype = $878f001d6f173f24$var$AxiosError.prototype;
var $878f001d6f173f24$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach(function(code) {
    $878f001d6f173f24$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($878f001d6f173f24$var$AxiosError, $878f001d6f173f24$var$descriptors);
Object.defineProperty($878f001d6f173f24$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$878f001d6f173f24$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($878f001d6f173f24$var$prototype);
    (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== 'isAxiosError';
    });
    var msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    var errCode = code == null && error ? error.code : code;
    $878f001d6f173f24$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $878f001d6f173f24$export$2e2bcd8739ae039 = $878f001d6f173f24$var$AxiosError;


// eslint-disable-next-line strict
var $7dfaf15844b7c3ed$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $6OzBR = parcelRequire("6OzBR");
var $36637d27de07e99a$export$a143d493d941bafc;
var $36637d27de07e99a$export$e4cf37d7f6fb9e0a;
var $36637d27de07e99a$export$f99ded8fe4b79145;
var $36637d27de07e99a$export$599f31c3813fae4d;
'use strict';
var $143d9be170261cd5$export$a48f0734ac7c2329;
var $143d9be170261cd5$export$d622b2ad8d90c771;
var $143d9be170261cd5$export$6100ba28696e12de;
'use strict';
$143d9be170261cd5$export$a48f0734ac7c2329 = $143d9be170261cd5$var$byteLength;
$143d9be170261cd5$export$d622b2ad8d90c771 = $143d9be170261cd5$var$toByteArray;
$143d9be170261cd5$export$6100ba28696e12de = $143d9be170261cd5$var$fromByteArray;
var $143d9be170261cd5$var$lookup = [];
var $143d9be170261cd5$var$revLookup = [];
var $143d9be170261cd5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $143d9be170261cd5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $143d9be170261cd5$var$i = 0, $143d9be170261cd5$var$len = $143d9be170261cd5$var$code.length; $143d9be170261cd5$var$i < $143d9be170261cd5$var$len; ++$143d9be170261cd5$var$i){
    $143d9be170261cd5$var$lookup[$143d9be170261cd5$var$i] = $143d9be170261cd5$var$code[$143d9be170261cd5$var$i];
    $143d9be170261cd5$var$revLookup[$143d9be170261cd5$var$code.charCodeAt($143d9be170261cd5$var$i)] = $143d9be170261cd5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$143d9be170261cd5$var$revLookup['-'.charCodeAt(0)] = 62;
$143d9be170261cd5$var$revLookup['_'.charCodeAt(0)] = 63;
function $143d9be170261cd5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $143d9be170261cd5$var$byteLength(b64) {
    var lens = $143d9be170261cd5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $143d9be170261cd5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $143d9be170261cd5$var$toByteArray(b64) {
    var tmp;
    var lens = $143d9be170261cd5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $143d9be170261cd5$var$Arr($143d9be170261cd5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $143d9be170261cd5$var$revLookup[b64.charCodeAt(i)] << 18 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $143d9be170261cd5$var$revLookup[b64.charCodeAt(i)] << 2 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $143d9be170261cd5$var$revLookup[b64.charCodeAt(i)] << 10 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $143d9be170261cd5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $143d9be170261cd5$var$tripletToBase64(num) {
    return $143d9be170261cd5$var$lookup[num >> 18 & 0x3F] + $143d9be170261cd5$var$lookup[num >> 12 & 0x3F] + $143d9be170261cd5$var$lookup[num >> 6 & 0x3F] + $143d9be170261cd5$var$lookup[num & 0x3F];
}
function $143d9be170261cd5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($143d9be170261cd5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $143d9be170261cd5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($143d9be170261cd5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($143d9be170261cd5$var$lookup[tmp >> 2] + $143d9be170261cd5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($143d9be170261cd5$var$lookup[tmp >> 10] + $143d9be170261cd5$var$lookup[tmp >> 4 & 0x3F] + $143d9be170261cd5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $3ef967566cd8305d$export$aafa59e2e03f2942;
var $3ef967566cd8305d$export$68d8715fc104d294;
$3ef967566cd8305d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$3ef967566cd8305d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $36637d27de07e99a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$36637d27de07e99a$export$a143d493d941bafc = $36637d27de07e99a$var$Buffer;
$36637d27de07e99a$export$e4cf37d7f6fb9e0a = $36637d27de07e99a$var$SlowBuffer;
$36637d27de07e99a$export$f99ded8fe4b79145 = 50;
var $36637d27de07e99a$var$K_MAX_LENGTH = 0x7fffffff;
$36637d27de07e99a$export$599f31c3813fae4d = $36637d27de07e99a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $36637d27de07e99a$var$Buffer.TYPED_ARRAY_SUPPORT = $36637d27de07e99a$var$typedArraySupport();
if (!$36637d27de07e99a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $36637d27de07e99a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($36637d27de07e99a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$36637d27de07e99a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($36637d27de07e99a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$36637d27de07e99a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $36637d27de07e99a$var$createBuffer(length) {
    if (length > $36637d27de07e99a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $36637d27de07e99a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $36637d27de07e99a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $36637d27de07e99a$var$allocUnsafe(arg);
    }
    return $36637d27de07e99a$var$from(arg, encodingOrOffset, length);
}
$36637d27de07e99a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $36637d27de07e99a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $36637d27de07e99a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $36637d27de07e99a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)));
    if ($36637d27de07e99a$var$isInstance(value, ArrayBuffer) || value && $36637d27de07e99a$var$isInstance(value.buffer, ArrayBuffer)) return $36637d27de07e99a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($36637d27de07e99a$var$isInstance(value, SharedArrayBuffer) || value && $36637d27de07e99a$var$isInstance(value.buffer, SharedArrayBuffer))) return $36637d27de07e99a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $36637d27de07e99a$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $36637d27de07e99a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $36637d27de07e99a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $36637d27de07e99a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $36637d27de07e99a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($36637d27de07e99a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($36637d27de07e99a$var$Buffer, Uint8Array);
function $36637d27de07e99a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $36637d27de07e99a$var$alloc(size, fill, encoding) {
    $36637d27de07e99a$var$assertSize(size);
    if (size <= 0) return $36637d27de07e99a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $36637d27de07e99a$var$createBuffer(size).fill(fill, encoding) : $36637d27de07e99a$var$createBuffer(size).fill(fill);
    return $36637d27de07e99a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $36637d27de07e99a$var$Buffer.alloc = function(size, fill, encoding) {
    return $36637d27de07e99a$var$alloc(size, fill, encoding);
};
function $36637d27de07e99a$var$allocUnsafe(size) {
    $36637d27de07e99a$var$assertSize(size);
    return $36637d27de07e99a$var$createBuffer(size < 0 ? 0 : $36637d27de07e99a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $36637d27de07e99a$var$Buffer.allocUnsafe = function(size) {
    return $36637d27de07e99a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $36637d27de07e99a$var$Buffer.allocUnsafeSlow = function(size) {
    return $36637d27de07e99a$var$allocUnsafe(size);
};
function $36637d27de07e99a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$36637d27de07e99a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $36637d27de07e99a$var$byteLength(string, encoding) | 0;
    var buf = $36637d27de07e99a$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $36637d27de07e99a$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $36637d27de07e99a$var$checked(array.length) | 0;
    var buf = $36637d27de07e99a$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $36637d27de07e99a$var$fromArrayView(arrayView) {
    if ($36637d27de07e99a$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $36637d27de07e99a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $36637d27de07e99a$var$fromArrayLike(arrayView);
}
function $36637d27de07e99a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $36637d27de07e99a$var$Buffer.prototype);
    return buf;
}
function $36637d27de07e99a$var$fromObject(obj) {
    if ($36637d27de07e99a$var$Buffer.isBuffer(obj)) {
        var len = $36637d27de07e99a$var$checked(obj.length) | 0;
        var buf = $36637d27de07e99a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $36637d27de07e99a$var$numberIsNaN(obj.length)) return $36637d27de07e99a$var$createBuffer(0);
        return $36637d27de07e99a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $36637d27de07e99a$var$fromArrayLike(obj.data);
}
function $36637d27de07e99a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $36637d27de07e99a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $36637d27de07e99a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $36637d27de07e99a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $36637d27de07e99a$var$Buffer.alloc(+length);
}
$36637d27de07e99a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $36637d27de07e99a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$36637d27de07e99a$var$Buffer.compare = function compare(a, b) {
    if ($36637d27de07e99a$var$isInstance(a, Uint8Array)) a = $36637d27de07e99a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($36637d27de07e99a$var$isInstance(b, Uint8Array)) b = $36637d27de07e99a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$36637d27de07e99a$var$Buffer.isBuffer(a) || !$36637d27de07e99a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$36637d27de07e99a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$36637d27de07e99a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $36637d27de07e99a$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $36637d27de07e99a$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($36637d27de07e99a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $36637d27de07e99a$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$36637d27de07e99a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $36637d27de07e99a$var$byteLength(string, encoding) {
    if ($36637d27de07e99a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $36637d27de07e99a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $6OzBR._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $36637d27de07e99a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $36637d27de07e99a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $36637d27de07e99a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$36637d27de07e99a$var$Buffer.byteLength = $36637d27de07e99a$var$byteLength;
function $36637d27de07e99a$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $36637d27de07e99a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $36637d27de07e99a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $36637d27de07e99a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $36637d27de07e99a$var$latin1Slice(this, start, end);
        case 'base64':
            return $36637d27de07e99a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $36637d27de07e99a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$36637d27de07e99a$var$Buffer.prototype._isBuffer = true;
function $36637d27de07e99a$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$36637d27de07e99a$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$36637d27de07e99a$var$swap(this, i, i + 1);
    return this;
};
$36637d27de07e99a$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $36637d27de07e99a$var$swap(this, i, i + 3);
        $36637d27de07e99a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$36637d27de07e99a$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $36637d27de07e99a$var$swap(this, i, i + 7);
        $36637d27de07e99a$var$swap(this, i + 1, i + 6);
        $36637d27de07e99a$var$swap(this, i + 2, i + 5);
        $36637d27de07e99a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$36637d27de07e99a$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $36637d27de07e99a$var$utf8Slice(this, 0, length);
    return $36637d27de07e99a$var$slowToString.apply(this, arguments);
};
$36637d27de07e99a$var$Buffer.prototype.toLocaleString = $36637d27de07e99a$var$Buffer.prototype.toString;
$36637d27de07e99a$var$Buffer.prototype.equals = function equals(b) {
    if (!$36637d27de07e99a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $36637d27de07e99a$var$Buffer.compare(this, b) === 0;
};
$36637d27de07e99a$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $36637d27de07e99a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($36637d27de07e99a$var$customInspectSymbol) $36637d27de07e99a$var$Buffer.prototype[$36637d27de07e99a$var$customInspectSymbol] = $36637d27de07e99a$var$Buffer.prototype.inspect;
$36637d27de07e99a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($36637d27de07e99a$var$isInstance(target, Uint8Array)) target = $36637d27de07e99a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$36637d27de07e99a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $6OzBR._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $36637d27de07e99a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($36637d27de07e99a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $36637d27de07e99a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($36637d27de07e99a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $36637d27de07e99a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $36637d27de07e99a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $36637d27de07e99a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$36637d27de07e99a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$36637d27de07e99a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $36637d27de07e99a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$36637d27de07e99a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $36637d27de07e99a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $36637d27de07e99a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($36637d27de07e99a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $36637d27de07e99a$var$utf8Write(buf, string, offset, length) {
    return $36637d27de07e99a$var$blitBuffer($36637d27de07e99a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $36637d27de07e99a$var$asciiWrite(buf, string, offset, length) {
    return $36637d27de07e99a$var$blitBuffer($36637d27de07e99a$var$asciiToBytes(string), buf, offset, length);
}
function $36637d27de07e99a$var$base64Write(buf, string, offset, length) {
    return $36637d27de07e99a$var$blitBuffer($36637d27de07e99a$var$base64ToBytes(string), buf, offset, length);
}
function $36637d27de07e99a$var$ucs2Write(buf, string, offset, length) {
    return $36637d27de07e99a$var$blitBuffer($36637d27de07e99a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$36637d27de07e99a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $36637d27de07e99a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $36637d27de07e99a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $36637d27de07e99a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $36637d27de07e99a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $36637d27de07e99a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$36637d27de07e99a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $36637d27de07e99a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $143d9be170261cd5$export$6100ba28696e12de(buf);
    else return $143d9be170261cd5$export$6100ba28696e12de(buf.slice(start, end));
}
function $36637d27de07e99a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $36637d27de07e99a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $36637d27de07e99a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $36637d27de07e99a$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $36637d27de07e99a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $36637d27de07e99a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $36637d27de07e99a$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $36637d27de07e99a$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $36637d27de07e99a$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $36637d27de07e99a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $36637d27de07e99a$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$36637d27de07e99a$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $36637d27de07e99a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $36637d27de07e99a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$36637d27de07e99a$var$Buffer.prototype.readUintLE = $36637d27de07e99a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$36637d27de07e99a$var$Buffer.prototype.readUintBE = $36637d27de07e99a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$36637d27de07e99a$var$Buffer.prototype.readUint8 = $36637d27de07e99a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$36637d27de07e99a$var$Buffer.prototype.readUint16LE = $36637d27de07e99a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$36637d27de07e99a$var$Buffer.prototype.readUint16BE = $36637d27de07e99a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$36637d27de07e99a$var$Buffer.prototype.readUint32LE = $36637d27de07e99a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$36637d27de07e99a$var$Buffer.prototype.readUint32BE = $36637d27de07e99a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$36637d27de07e99a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$36637d27de07e99a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$36637d27de07e99a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$36637d27de07e99a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$36637d27de07e99a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$36637d27de07e99a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$36637d27de07e99a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$36637d27de07e99a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return $3ef967566cd8305d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$36637d27de07e99a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 4, this.length);
    return $3ef967566cd8305d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$36637d27de07e99a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 8, this.length);
    return $3ef967566cd8305d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$36637d27de07e99a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkOffset(offset, 8, this.length);
    return $3ef967566cd8305d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $36637d27de07e99a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$36637d27de07e99a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$36637d27de07e99a$var$Buffer.prototype.writeUintLE = $36637d27de07e99a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $36637d27de07e99a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$36637d27de07e99a$var$Buffer.prototype.writeUintBE = $36637d27de07e99a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $36637d27de07e99a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$36637d27de07e99a$var$Buffer.prototype.writeUint8 = $36637d27de07e99a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$36637d27de07e99a$var$Buffer.prototype.writeUint16LE = $36637d27de07e99a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$36637d27de07e99a$var$Buffer.prototype.writeUint16BE = $36637d27de07e99a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$36637d27de07e99a$var$Buffer.prototype.writeUint32LE = $36637d27de07e99a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$36637d27de07e99a$var$Buffer.prototype.writeUint32BE = $36637d27de07e99a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$36637d27de07e99a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $36637d27de07e99a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$36637d27de07e99a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $36637d27de07e99a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$36637d27de07e99a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$36637d27de07e99a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$36637d27de07e99a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$36637d27de07e99a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$36637d27de07e99a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $36637d27de07e99a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $36637d27de07e99a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3ef967566cd8305d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$36637d27de07e99a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $36637d27de07e99a$var$writeFloat(this, value, offset, true, noAssert);
};
$36637d27de07e99a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $36637d27de07e99a$var$writeFloat(this, value, offset, false, noAssert);
};
function $36637d27de07e99a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36637d27de07e99a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3ef967566cd8305d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$36637d27de07e99a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $36637d27de07e99a$var$writeDouble(this, value, offset, true, noAssert);
};
$36637d27de07e99a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $36637d27de07e99a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$36637d27de07e99a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$36637d27de07e99a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$36637d27de07e99a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$36637d27de07e99a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $36637d27de07e99a$var$Buffer.isBuffer(val) ? val : $36637d27de07e99a$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $36637d27de07e99a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $36637d27de07e99a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($36637d27de07e99a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $36637d27de07e99a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $36637d27de07e99a$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $36637d27de07e99a$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $36637d27de07e99a$var$base64ToBytes(str) {
    return $143d9be170261cd5$export$d622b2ad8d90c771($36637d27de07e99a$var$base64clean(str));
}
function $36637d27de07e99a$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $36637d27de07e99a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $36637d27de07e99a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $36637d27de07e99a$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $030ce6fd6cc48110$require$Buffer = $36637d27de07e99a$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $030ce6fd6cc48110$var$isVisitable(thing) {
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $030ce6fd6cc48110$var$removeBrackets(key) {
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $030ce6fd6cc48110$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $030ce6fd6cc48110$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $030ce6fd6cc48110$var$isFlatArray(arr) {
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(arr) && !arr.some($030ce6fd6cc48110$var$isVisitable);
}
var $030ce6fd6cc48110$var$predicates = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toFlatObject((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $030ce6fd6cc48110$var$toFormData(obj, formData, options) {
    if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $7dfaf15844b7c3ed$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var useBlob = _Blob && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $030ce6fd6cc48110$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)) === 'object') {
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(value) && $030ce6fd6cc48110$var$isFlatArray(value) || ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFileList(value) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $030ce6fd6cc48110$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $030ce6fd6cc48110$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($030ce6fd6cc48110$var$isVisitable(value)) return true;
        formData.append($030ce6fd6cc48110$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($030ce6fd6cc48110$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $030ce6fd6cc48110$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $030ce6fd6cc48110$export$2e2bcd8739ae039 = $030ce6fd6cc48110$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7255dfd5eca27d85$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7255dfd5eca27d85$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $030ce6fd6cc48110$export$2e2bcd8739ae039)(params, this, options);
}
var $7255dfd5eca27d85$var$prototype = $7255dfd5eca27d85$var$AxiosURLSearchParams.prototype;
$7255dfd5eca27d85$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7255dfd5eca27d85$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $7255dfd5eca27d85$var$encode);
    } : $7255dfd5eca27d85$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $7255dfd5eca27d85$export$2e2bcd8739ae039 = $7255dfd5eca27d85$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $78490d87bdad7b44$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $78490d87bdad7b44$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $78490d87bdad7b44$var$encode;
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7255dfd5eca27d85$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}





'use strict';
var $30dfdc95e71ef864$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $30dfdc95e71ef864$export$2e2bcd8739ae039 = $30dfdc95e71ef864$var$InterceptorManager;





'use strict';
var $e572036bfbc169a0$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};








'use strict';
var $521ca6b7b95e5811$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $7255dfd5eca27d85$export$2e2bcd8739ae039);


'use strict';
var $34047de8fb432214$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $b4775d0f62a56c3d$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $9e0cf9c900f214c2$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $521ca6b7b95e5811$export$2e2bcd8739ae039),
        FormData: (0, $34047de8fb432214$export$2e2bcd8739ae039),
        Blob: (0, $b4775d0f62a56c3d$export$2e2bcd8739ae039)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $37beebc178694352$exports = {};

$parcel$export($37beebc178694352$exports, "hasBrowserEnv", function () { return $37beebc178694352$export$c4996c4b7b93b0bf; });
$parcel$export($37beebc178694352$exports, "navigator", function () { return $37beebc178694352$export$ec7c8efa7f5790ae; });
$parcel$export($37beebc178694352$exports, "hasStandardBrowserEnv", function () { return $37beebc178694352$export$c0bcc9250309d66; });
$parcel$export($37beebc178694352$exports, "hasStandardBrowserWebWorkerEnv", function () { return $37beebc178694352$export$c81692cf5af97dac; });
$parcel$export($37beebc178694352$exports, "origin", function () { return $37beebc178694352$export$f710a83a91838a36; });

var $6OzBR = parcelRequire("6OzBR");
var $37beebc178694352$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $37beebc178694352$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $6OzBR._)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $37beebc178694352$export$c0bcc9250309d66 = $37beebc178694352$export$c4996c4b7b93b0bf && (!$37beebc178694352$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($37beebc178694352$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $37beebc178694352$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $37beebc178694352$export$f710a83a91838a36 = $37beebc178694352$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $4f3ca76a66380e1c$export$2e2bcd8739ae039 = (0, $44df43b91545a470$export$71511d61b312f219)({}, $37beebc178694352$exports, (0, $9e0cf9c900f214c2$export$2e2bcd8739ae039));


'use strict';
function $253a33d3b65e8a21$export$2e2bcd8739ae039(data, options) {
    return (0, $030ce6fd6cc48110$export$2e2bcd8739ae039)(data, new (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $44df43b91545a470$export$71511d61b312f219)({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).isNode && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $0403eba3b9f630a4$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $0403eba3b9f630a4$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $0403eba3b9f630a4$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $0403eba3b9f630a4$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFormData(formData) && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($0403eba3b9f630a4$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $0403eba3b9f630a4$export$2e2bcd8739ae039 = $0403eba3b9f630a4$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $b120dba93c8b885e$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $b120dba93c8b885e$var$defaults = {
    transitional: (0, $e572036bfbc169a0$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $0403eba3b9f630a4$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBuffer(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isStream(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFile(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBlob(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $253a33d3b65e8a21$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $030ce6fd6cc48110$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $b120dba93c8b885e$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $b120dba93c8b885e$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isResponse(data) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $878f001d6f173f24$export$2e2bcd8739ae039).from(e, (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], function(method) {
    $b120dba93c8b885e$var$defaults.headers[method] = {};
});
var $b120dba93c8b885e$export$2e2bcd8739ae039 = $b120dba93c8b885e$var$defaults;








'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $8d8b62df2966b9d4$var$ignoreDuplicateOf = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $8d8b62df2966b9d4$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $8d8b62df2966b9d4$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
var $a2a154a4394c28e9$var$$internals = Symbol('internals');
function $a2a154a4394c28e9$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a2a154a4394c28e9$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(value) ? value.map($a2a154a4394c28e9$var$normalizeValue) : String(value);
}
function $a2a154a4394c28e9$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $a2a154a4394c28e9$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $a2a154a4394c28e9$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $a2a154a4394c28e9$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function $a2a154a4394c28e9$var$buildAccessors(obj, header) {
    var accessorName = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $a2a154a4394c28e9$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $a2a154a4394c28e9$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error('header name must be a non-empty string');
                    var key = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a2a154a4394c28e9$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$a2a154a4394c28e9$var$isValidHeaderName(header)) setHeaders((0, $8d8b62df2966b9d4$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(header) && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isIterable(header)) {
                    var obj = {}, dest, key;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                            obj[key = entry[0]] = (dest = obj[key]) ? (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(dest) ? (0, $f3a38006ec5aeddb$export$71511d61b312f219)(dest).concat([
                                entry[1]
                            ]) : [
                                dest,
                                entry[1]
                            ] : entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setHeaders(obj, valueOrRewrite);
                } else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $a2a154a4394c28e9$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $a2a154a4394c28e9$var$parseTokens(value);
                        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $a2a154a4394c28e9$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $a2a154a4394c28e9$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $a2a154a4394c28e9$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $a2a154a4394c28e9$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $a2a154a4394c28e9$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $a2a154a4394c28e9$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $a2a154a4394c28e9$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $a2a154a4394c28e9$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $f3a38006ec5aeddb$export$71511d61b312f219)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $98582fd3a031d57f$export$71511d61b312f219)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: "getSetCookie",
            value: function getSetCookie() {
                return this.get("set-cookie") || [];
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$a2a154a4394c28e9$var$$internals] = this[$a2a154a4394c28e9$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $a2a154a4394c28e9$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $a2a154a4394c28e9$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$a2a154a4394c28e9$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).reduceDescriptors($a2a154a4394c28e9$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).freezeMethods($a2a154a4394c28e9$var$AxiosHeaders);
var $a2a154a4394c28e9$export$2e2bcd8739ae039 = $a2a154a4394c28e9$var$AxiosHeaders;


'use strict';
function $beb284ab8340b796$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $b120dba93c8b885e$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $f0dcc63d778f7c6a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $aa6732ab19742e0c$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $878f001d6f173f24$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).inherits($aa6732ab19742e0c$var$CanceledError, (0, $878f001d6f173f24$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $aa6732ab19742e0c$export$2e2bcd8739ae039 = $aa6732ab19742e0c$var$CanceledError;









'use strict';
function $00ece89c21f52106$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $84bb23425ae222c5$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}






'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0ae1be6f5d8c5721$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0ae1be6f5d8c5721$export$2e2bcd8739ae039 = $0ae1be6f5d8c5721$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ 
function $83883ace03b48129$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(void 0, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(args));
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $83883ace03b48129$export$2e2bcd8739ae039 = $83883ace03b48129$var$throttle;



var $a87662b48986ade6$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $0ae1be6f5d8c5721$export$2e2bcd8739ae039)(50, 250);
    return (0, $83883ace03b48129$export$2e2bcd8739ae039)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $45df9b60364921ae$export$71511d61b312f219)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $a87662b48986ade6$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $a87662b48986ade6$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(args));
        });
    };
};






var $afc368dd7ce6c04d$export$2e2bcd8739ae039 = (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).origin), (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).navigator.userAgent)) : function() {
    return true;
};




var $34c701a7dc44e928$export$2e2bcd8739ae039 = (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        var cookie = [
            "".concat(name, "=").concat(encodeURIComponent(value))
        ];
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=".concat(new Date(expires).toUTCString()));
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(path)) cookie.push("path=".concat(path));
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=".concat(domain));
        if (secure === true) cookie.push('secure');
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(sameSite)) cookie.push("SameSite=".concat(sameSite));
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        if (typeof document === 'undefined') return null;
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


'use strict';
function $4ba529e369abd33a$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $ac2077ee62fc6de5$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $fd7c3123abffe297$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeUrl = !(0, $4ba529e369abd33a$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $ac2077ee62fc6de5$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
var $6a209c272eb13c92$var$headersToObject = function(thing) {
    return thing instanceof (0, $a2a154a4394c28e9$export$2e2bcd8739ae039) ? (0, $44df43b91545a470$export$71511d61b312f219)({}, thing) : thing;
};
function $6a209c272eb13c92$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($6a209c272eb13c92$var$headersToObject(a), $6a209c272eb13c92$var$headersToObject(b), prop, true);
        }
    };
    (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(Object.keys((0, $44df43b91545a470$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $3054c99f16c111fe$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $6a209c272eb13c92$export$2e2bcd8739ae039)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $78490d87bdad7b44$export$2e2bcd8739ae039)((0, $fd7c3123abffe297$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            var formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            var allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(function(param) {
                var _param = (0, $98582fd3a031d57f$export$71511d61b312f219)(param, 2), key = _param[0], val = _param[1];
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $afc368dd7ce6c04d$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $34c701a7dc44e928$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


var $65a123d6e22e5401$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $65a123d6e22e5401$export$2e2bcd8739ae039 = $65a123d6e22e5401$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $3054c99f16c111fe$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $00ece89c21f52106$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Request aborted', (0, $878f001d6f173f24$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            var msg = event && event.message ? event.message : 'Network Error';
            var err = new (0, $878f001d6f173f24$export$2e2bcd8739ae039)(msg, (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $e572036bfbc169a0$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $878f001d6f173f24$export$2e2bcd8739ae039).ETIMEDOUT : (0, $878f001d6f173f24$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $98582fd3a031d57f$export$71511d61b312f219)((0, $a87662b48986ade6$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $98582fd3a031d57f$export$71511d61b312f219)((0, $a87662b48986ade6$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $aa6732ab19742e0c$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $84bb23425ae222c5$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};














var $ef69e60f863fe7a7$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $878f001d6f173f24$export$2e2bcd8739ae039) ? err : new (0, $aa6732ab19742e0c$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)("timeout ".concat(timeout, " of ms exceeded"), (0, $878f001d6f173f24$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener('abort', onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).asap(unsubscribe);
        };
        return signal;
    }
};
var $ef69e60f863fe7a7$export$2e2bcd8739ae039 = $ef69e60f863fe7a7$var$composeSignals;


function $9d458c79cc805a57$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}


function $a8ccc09652cf6c5a$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $9d458c79cc805a57$export$71511d61b312f219)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}


function $332de40c74579c27$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $332de40c74579c27$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $332de40c74579c27$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $332de40c74579c27$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $332de40c74579c27$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $332de40c74579c27$var$AsyncFromSyncIterator(s);
}




function $dd74b6a70cb3eab4$export$71511d61b312f219(value) {
    return new (0, $9d458c79cc805a57$export$71511d61b312f219)(value, /* kind: await */ 0);
}



function $7cb4336ae040b3e9$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $9d458c79cc805a57$export$71511d61b312f219);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$7cb4336ae040b3e9$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$7cb4336ae040b3e9$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$7cb4336ae040b3e9$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$7cb4336ae040b3e9$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $b459d26ccf3e5f48$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $7cb4336ae040b3e9$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $6OzBR = parcelRequire("6OzBR");
var $5bbf16ce4ea4219b$var$extendStatics = function extendStatics1(d, b) {
    $5bbf16ce4ea4219b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5bbf16ce4ea4219b$var$extendStatics(d, b);
};
function $5bbf16ce4ea4219b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5bbf16ce4ea4219b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5bbf16ce4ea4219b$export$18ce0697a983be9b = function __assign1() {
    $5bbf16ce4ea4219b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5bbf16ce4ea4219b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5bbf16ce4ea4219b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5bbf16ce4ea4219b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6OzBR._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5bbf16ce4ea4219b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5bbf16ce4ea4219b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $6OzBR._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5bbf16ce4ea4219b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5bbf16ce4ea4219b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $6OzBR._)(x)) === "symbol" ? x : "".concat(x);
}
function $5bbf16ce4ea4219b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $6OzBR._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5bbf16ce4ea4219b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6OzBR._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5bbf16ce4ea4219b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5bbf16ce4ea4219b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5bbf16ce4ea4219b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5bbf16ce4ea4219b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5bbf16ce4ea4219b$export$45d3717a4c69092e(o, m, p);
}
function $5bbf16ce4ea4219b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5bbf16ce4ea4219b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5bbf16ce4ea4219b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5bbf16ce4ea4219b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5bbf16ce4ea4219b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5bbf16ce4ea4219b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5bbf16ce4ea4219b$export$10c90e4f7922046c(v) {
    return this instanceof $5bbf16ce4ea4219b$export$10c90e4f7922046c ? (this.v = v, this) : new $5bbf16ce4ea4219b$export$10c90e4f7922046c(v);
}
function $5bbf16ce4ea4219b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5bbf16ce4ea4219b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5bbf16ce4ea4219b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5bbf16ce4ea4219b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5bbf16ce4ea4219b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5bbf16ce4ea4219b$export$19a8beecd37a4c45 === "function" ? $5bbf16ce4ea4219b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5bbf16ce4ea4219b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5bbf16ce4ea4219b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5bbf16ce4ea4219b$var$ownKeys = function ownKeys1(o) {
    $5bbf16ce4ea4219b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5bbf16ce4ea4219b$var$ownKeys(o);
};
function $5bbf16ce4ea4219b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5bbf16ce4ea4219b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5bbf16ce4ea4219b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5bbf16ce4ea4219b$var$__setModuleDefault(result, mod);
    return result;
}
function $5bbf16ce4ea4219b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5bbf16ce4ea4219b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5bbf16ce4ea4219b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5bbf16ce4ea4219b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $6OzBR._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5bbf16ce4ea4219b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $6OzBR._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5bbf16ce4ea4219b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5bbf16ce4ea4219b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5bbf16ce4ea4219b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5bbf16ce4ea4219b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5bbf16ce4ea4219b$export$2e2bcd8739ae039 = {
    __extends: $5bbf16ce4ea4219b$export$a8ba968b8961cb8a,
    __assign: $5bbf16ce4ea4219b$export$18ce0697a983be9b,
    __rest: $5bbf16ce4ea4219b$export$3c9a16f847548506,
    __decorate: $5bbf16ce4ea4219b$export$29e00dfd3077644b,
    __param: $5bbf16ce4ea4219b$export$d5ad3fd78186038f,
    __esDecorate: $5bbf16ce4ea4219b$export$3a84e1ae4e97e9b0,
    __runInitializers: $5bbf16ce4ea4219b$export$d831c04e792af3d,
    __propKey: $5bbf16ce4ea4219b$export$6a2a36740a146cb8,
    __setFunctionName: $5bbf16ce4ea4219b$export$d1a06452d3489bc7,
    __metadata: $5bbf16ce4ea4219b$export$f1db080c865becb9,
    __awaiter: $5bbf16ce4ea4219b$export$1050f835b63b671e,
    __generator: $5bbf16ce4ea4219b$export$67ebef60e6f28a6,
    __createBinding: $5bbf16ce4ea4219b$export$45d3717a4c69092e,
    __exportStar: $5bbf16ce4ea4219b$export$f33643c0debef087,
    __values: $5bbf16ce4ea4219b$export$19a8beecd37a4c45,
    __read: $5bbf16ce4ea4219b$export$8d051b38c9118094,
    __spread: $5bbf16ce4ea4219b$export$afc72e2116322959,
    __spreadArrays: $5bbf16ce4ea4219b$export$6388937ca91ccae8,
    __spreadArray: $5bbf16ce4ea4219b$export$1216008129fb82ed,
    __await: $5bbf16ce4ea4219b$export$10c90e4f7922046c,
    __asyncGenerator: $5bbf16ce4ea4219b$export$e427f37a30a4de9b,
    __asyncDelegator: $5bbf16ce4ea4219b$export$bbd80228419bb833,
    __asyncValues: $5bbf16ce4ea4219b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5bbf16ce4ea4219b$export$4fb47efe1390b86f,
    __importStar: $5bbf16ce4ea4219b$export$c21735bcef00d192,
    __importDefault: $5bbf16ce4ea4219b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5bbf16ce4ea4219b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5bbf16ce4ea4219b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5bbf16ce4ea4219b$export$81fdc39f203e4e04,
    __addDisposableResource: $5bbf16ce4ea4219b$export$88ac25d8e944e405,
    __disposeResources: $5bbf16ce4ea4219b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5bbf16ce4ea4219b$export$889dfb5d17574b0b
};


var $784839acd0a251a3$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $784839acd0a251a3$export$f9f241124ee3198e = /*#__PURE__*/ function() {
    var _ref = (0, $b459d26ccf3e5f48$export$71511d61b312f219)(function(iterable, chunkSize) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $332de40c74579c27$export$71511d61b312f219)($784839acd0a251a3$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dd74b6a70cb3eab4$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $5bbf16ce4ea4219b$export$19a8beecd37a4c45)((0, $a8ccc09652cf6c5a$export$71511d61b312f219)((0, $332de40c74579c27$export$71511d61b312f219)($784839acd0a251a3$export$71b051935044bd5d(chunk, chunkSize)), (0, $dd74b6a70cb3eab4$export$71511d61b312f219)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $dd74b6a70cb3eab4$export$71511d61b312f219)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize) {
        return _ref.apply(this, arguments);
    };
}();
var $784839acd0a251a3$var$readStream = /*#__PURE__*/ function() {
    var _ref = (0, $b459d26ccf3e5f48$export$71511d61b312f219)(function(stream) {
        var reader, _ref, done, value;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $5bbf16ce4ea4219b$export$19a8beecd37a4c45)((0, $a8ccc09652cf6c5a$export$71511d61b312f219)((0, $332de40c74579c27$export$71511d61b312f219)(stream), (0, $dd74b6a70cb3eab4$export$71511d61b312f219)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $dd74b6a70cb3eab4$export$71511d61b312f219)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $dd74b6a70cb3eab4$export$71511d61b312f219)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function readStream(stream) {
        return _ref.apply(this, arguments);
    };
}();
var $784839acd0a251a3$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $784839acd0a251a3$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, $61e1cd97499a53aa$export$71511d61b312f219)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






var $9aa2d49467a75e2a$var$DEFAULT_CHUNK_SIZE = 65536;
var $9aa2d49467a75e2a$var$isFunction = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction;
var $9aa2d49467a75e2a$var$globalFetchAPI = function(param) {
    var Request = param.Request, Response = param.Response;
    return {
        Request: Request,
        Response: Response
    };
}((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).global);
var $9aa2d49467a75e2a$var$_utils_global = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).global, $9aa2d49467a75e2a$var$ReadableStream = $9aa2d49467a75e2a$var$_utils_global.ReadableStream, $9aa2d49467a75e2a$var$TextEncoder = $9aa2d49467a75e2a$var$_utils_global.TextEncoder;
var $9aa2d49467a75e2a$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(args));
    } catch (e) {
        return false;
    }
};
var $9aa2d49467a75e2a$var$factory = function(env) {
    env = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $9aa2d49467a75e2a$var$globalFetchAPI, env);
    var envFetch = env.fetch, Request = env.Request, Response = env.Response;
    var isFetchSupported = envFetch ? $9aa2d49467a75e2a$var$isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = $9aa2d49467a75e2a$var$isFunction(Request);
    var isResponseSupported = $9aa2d49467a75e2a$var$isFunction(Response);
    if (!isFetchSupported) return false;
    var isReadableStreamSupported = isFetchSupported && $9aa2d49467a75e2a$var$isFunction($9aa2d49467a75e2a$var$ReadableStream);
    var encodeText = isFetchSupported && (typeof $9aa2d49467a75e2a$var$TextEncoder === 'function' ? function(encoder) {
        return function(str) {
            return encoder.encode(str);
        };
    }(new $9aa2d49467a75e2a$var$TextEncoder()) : /*#__PURE__*/ function() {
        var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(str) {
            var _;
            return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            new Request(str).arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        });
        return function(str) {
            return _ref.apply(this, arguments);
        };
    }());
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && $9aa2d49467a75e2a$var$test(function() {
        var duplexAccessed = false;
        var hasContentType = new Request((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).origin, {
            body: new $9aa2d49467a75e2a$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && $9aa2d49467a75e2a$var$test(function() {
        return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isReadableStream(new Response('').body);
    });
    var resolvers = {
        stream: supportsResponseStream && function(res) {
            return res.body;
        }
    };
    isFetchSupported && function() {
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach(function(type) {
            !resolvers[type] && (resolvers[type] = function(res, config) {
                var method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    }();
    var getBodyLength = /*#__PURE__*/ function() {
        var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(body) {
            var _request;
            return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (body == null) return [
                            2,
                            0
                        ];
                        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isBlob(body)) return [
                            2,
                            body.size
                        ];
                        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                            3,
                            2
                        ];
                        _request = new Request((0, $4f3ca76a66380e1c$export$2e2bcd8739ae039).origin, {
                            method: 'POST',
                            body: body
                        });
                        return [
                            4,
                            _request.arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 2:
                        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                            2,
                            body.byteLength
                        ];
                        if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
                        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(body)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            encodeText(body)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBodyLength(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var resolveBodyLength = /*#__PURE__*/ function() {
        var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(headers, body) {
            var length;
            return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                length = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
                return [
                    2,
                    length == null ? getBodyLength(body) : length
                ];
            });
        });
        return function resolveBodyLength(headers, body) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ function() {
        var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(config) {
            var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, _fetch, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, resolvedOptions, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
            return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _resolveConfig = (0, $3054c99f16c111fe$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                        _fetch = envFetch || fetch;
                        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                        composedSignal = (0, $ef69e60f863fe7a7$export$2e2bcd8739ae039)([
                            signal,
                            cancelToken && cancelToken.toAbortSignal()
                        ], timeout);
                        request = null;
                        unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                            composedSignal.unsubscribe();
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        _tmp = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 2:
                        _tmp = (requestContentLength = _state.sent()) !== 0;
                        _state.label = 3;
                    case 3:
                        if (_tmp) {
                            _request = new Request(url, {
                                method: 'POST',
                                body: data,
                                duplex: "half"
                            });
                            ;
                            if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                            if (_request.body) {
                                _progressEventDecorator = (0, $98582fd3a031d57f$export$71511d61b312f219)((0, $a87662b48986ade6$export$d9fadd12586c18d6)(requestContentLength, (0, $a87662b48986ade6$export$c1b28109d46c3592)((0, $a87662b48986ade6$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                                data = (0, $784839acd0a251a3$export$b0119225647bd83)(_request.body, $9aa2d49467a75e2a$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                            }
                        }
                        if (!(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                        // Cloudflare Workers throws when credentials are defined
                        // see https://github.com/cloudflare/workerd/issues/902
                        isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
                        resolvedOptions = (0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({}, fetchOptions), {
                            signal: composedSignal,
                            method: method.toUpperCase(),
                            headers: headers.normalize().toJSON(),
                            body: data,
                            duplex: "half",
                            credentials: isCredentialsSupported ? withCredentials : undefined
                        });
                        request = isRequestSupported && new Request(url, resolvedOptions);
                        return [
                            4,
                            isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions)
                        ];
                    case 4:
                        response = _state.sent();
                        isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                        if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                            options = {};
                            [
                                'status',
                                'statusText',
                                'headers'
                            ].forEach(function(prop) {
                                options[prop] = response[prop];
                            });
                            responseContentLength = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                            _ref = (0, $98582fd3a031d57f$export$71511d61b312f219)(onDownloadProgress && (0, $a87662b48986ade6$export$d9fadd12586c18d6)(responseContentLength, (0, $a87662b48986ade6$export$c1b28109d46c3592)((0, $a87662b48986ade6$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                            response = new Response((0, $784839acd0a251a3$export$b0119225647bd83)(response.body, $9aa2d49467a75e2a$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                                flush1 && flush1();
                                unsubscribe && unsubscribe();
                            }), options);
                        }
                        responseType = responseType || 'text';
                        return [
                            4,
                            resolvers[(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config)
                        ];
                    case 5:
                        responseData = _state.sent();
                        !isStreamResponse && unsubscribe && unsubscribe();
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                (0, $00ece89c21f52106$export$2e2bcd8739ae039)(resolve, reject, {
                                    data: responseData,
                                    headers: (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(response.headers),
                                    status: response.status,
                                    statusText: response.statusText,
                                    config: config,
                                    request: request
                                });
                            })
                        ];
                    case 6:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 7:
                        err = _state.sent();
                        unsubscribe && unsubscribe();
                        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Network Error', (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                            cause: err.cause || err
                        });
                        throw (0, $878f001d6f173f24$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(config) {
            return _ref.apply(this, arguments);
        };
    }();
};
var $9aa2d49467a75e2a$var$seedCache = new Map();
var $9aa2d49467a75e2a$export$3105c6651375d4fa = function(config) {
    var env = config && config.env || {};
    var fetch1 = env.fetch, Request = env.Request, Response = env.Response;
    var seeds = [
        Request,
        Response,
        fetch1
    ];
    var len = seeds.length, i = len, seed, target, map = $9aa2d49467a75e2a$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $9aa2d49467a75e2a$var$factory(env));
        map = target;
    }
    return target;
};
var $9aa2d49467a75e2a$var$adapter = $9aa2d49467a75e2a$export$3105c6651375d4fa();
var $9aa2d49467a75e2a$export$2e2bcd8739ae039 = $9aa2d49467a75e2a$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ var $f5c86535c96204ca$var$knownAdapters = {
    http: (0, $7dfaf15844b7c3ed$export$2e2bcd8739ae039),
    xhr: (0, $65a123d6e22e5401$export$2e2bcd8739ae039),
    fetch: {
        get: $9aa2d49467a75e2a$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach($f5c86535c96204ca$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ var $f5c86535c96204ca$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ var $f5c86535c96204ca$var$isResolvedHandle = function(adapter) {
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $f5c86535c96204ca$var$getAdapter(adapters, config) {
    adapters = (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    var length = adapters.length;
    var nameOrAdapter;
    var adapter;
    var rejectedReasons = {};
    for(var i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        var id = void 0;
        adapter = nameOrAdapter;
        if (!$f5c86535c96204ca$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $f5c86535c96204ca$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
        }
        if (adapter && ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        var reasons = Object.entries(rejectedReasons).map(function(param) {
            var _param = (0, $98582fd3a031d57f$export$71511d61b312f219)(param, 2), id = _param[0], state = _param[1];
            return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
        });
        var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($f5c86535c96204ca$var$renderReason).join('\n') : ' ' + $f5c86535c96204ca$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $f5c86535c96204ca$export$2e2bcd8739ae039 = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter: $f5c86535c96204ca$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $f5c86535c96204ca$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $76f369a989db885f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $aa6732ab19742e0c$export$2e2bcd8739ae039)(null, config);
}
function $76f369a989db885f$export$2e2bcd8739ae039(config) {
    $76f369a989db885f$var$throwIfCancellationRequested(config);
    config.headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $beb284ab8340b796$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $f5c86535c96204ca$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $b120dba93c8b885e$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $76f369a989db885f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $beb284ab8340b796$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $f0dcc63d778f7c6a$export$2e2bcd8739ae039)(reason)) {
            $76f369a989db885f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $beb284ab8340b796$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}





var $6OzBR = parcelRequire("6OzBR");
var $67061ea088ebe445$export$a4ad2735b021c132 = "1.13.2";



'use strict';
var $220b6ec139b3eddb$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $220b6ec139b3eddb$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $6OzBR._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $220b6ec139b3eddb$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $220b6ec139b3eddb$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $67061ea088ebe445$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$220b6ec139b3eddb$var$deprecatedWarnings[opt]) {
            $220b6ec139b3eddb$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$220b6ec139b3eddb$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $220b6ec139b3eddb$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $6OzBR._)(options)) !== 'object') throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('options must be an object', (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $878f001d6f173f24$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $878f001d6f173f24$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $220b6ec139b3eddb$export$2e2bcd8739ae039 = {
    assertOptions: $220b6ec139b3eddb$var$assertOptions,
    validators: $220b6ec139b3eddb$var$validators
};



'use strict';
var $6487c40a7da97fe5$var$validators = (0, $220b6ec139b3eddb$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $6487c40a7da97fe5$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, Axios);
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $30dfdc95e71ef864$export$2e2bcd8739ae039)(),
            response: new (0, $30dfdc95e71ef864$export$2e2bcd8739ae039)()
        };
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, $61e1cd97499a53aa$export$71511d61b312f219)(function() {
                    var err, dummy, stack;
                    return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $6a209c272eb13c92$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $220b6ec139b3eddb$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $6487c40a7da97fe5$var$validators.transitional($6487c40a7da97fe5$var$validators.boolean),
                    forcedJSONParsing: $6487c40a7da97fe5$var$validators.transitional($6487c40a7da97fe5$var$validators.boolean),
                    clarifyTimeoutError: $6487c40a7da97fe5$var$validators.transitional($6487c40a7da97fe5$var$validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $220b6ec139b3eddb$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $6487c40a7da97fe5$var$validators.function,
                        serialize: $6487c40a7da97fe5$var$validators.function
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $220b6ec139b3eddb$export$2e2bcd8739ae039).assertOptions(config, {
                    baseUrl: $6487c40a7da97fe5$var$validators.spelling('baseURL'),
                    withXsrfToken: $6487c40a7da97fe5$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = (config.method || this.defaults.method || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach([
                    'delete',
                    'get',
                    'head',
                    'post',
                    'put',
                    'patch',
                    'common'
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var _chain, _chain1;
                    var chain = [
                        (0, $76f369a989db885f$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    (_chain = chain).unshift.apply(_chain, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(requestInterceptorChain));
                    (_chain1 = chain).push.apply(_chain1, (0, $f3a38006ec5aeddb$export$71511d61b312f219)(responseInterceptorChain));
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $76f369a989db885f$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $6a209c272eb13c92$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $fd7c3123abffe297$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
                return (0, $78490d87bdad7b44$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6487c40a7da97fe5$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $6a209c272eb13c92$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $6a209c272eb13c92$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6487c40a7da97fe5$var$Axios.prototype[method] = generateHTTPMethod();
    $6487c40a7da97fe5$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $6487c40a7da97fe5$export$2e2bcd8739ae039 = $6487c40a7da97fe5$var$Axios;









'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $640bef66fb66164a$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $66bb170d32c3ecf5$export$71511d61b312f219)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $aa6732ab19742e0c$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $6264c620e50e2a26$export$71511d61b312f219)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $640bef66fb66164a$export$2e2bcd8739ae039 = $640bef66fb66164a$var$CancelToken;






'use strict';
function $4d148dffd9e993ca$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $95d5d9c90d3ed94e$export$2e2bcd8739ae039(payload) {
    return (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $aae436c3a31e59d2$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($aae436c3a31e59d2$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $98582fd3a031d57f$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
    $aae436c3a31e59d2$var$HttpStatusCode[value] = key;
});
var $aae436c3a31e59d2$export$2e2bcd8739ae039 = $aae436c3a31e59d2$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $589e2229d6251b1f$var$createInstance(defaultConfig) {
    var context = new (0, $6487c40a7da97fe5$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $5446f15cb3e1db63$export$2e2bcd8739ae039)((0, $6487c40a7da97fe5$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).extend(instance, (0, $6487c40a7da97fe5$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $589e2229d6251b1f$var$createInstance((0, $6a209c272eb13c92$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $589e2229d6251b1f$var$axios = $589e2229d6251b1f$var$createInstance((0, $b120dba93c8b885e$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$589e2229d6251b1f$var$axios.Axios = (0, $6487c40a7da97fe5$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$589e2229d6251b1f$var$axios.CanceledError = (0, $aa6732ab19742e0c$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.CancelToken = (0, $640bef66fb66164a$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.isCancel = (0, $f0dcc63d778f7c6a$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.VERSION = (0, $67061ea088ebe445$export$a4ad2735b021c132);
$589e2229d6251b1f$var$axios.toFormData = (0, $030ce6fd6cc48110$export$2e2bcd8739ae039);
// Expose AxiosError class
$589e2229d6251b1f$var$axios.AxiosError = (0, $878f001d6f173f24$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$589e2229d6251b1f$var$axios.Cancel = $589e2229d6251b1f$var$axios.CanceledError;
// Expose all/spread
$589e2229d6251b1f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$589e2229d6251b1f$var$axios.spread = (0, $4d148dffd9e993ca$export$2e2bcd8739ae039);
// Expose isAxiosError
$589e2229d6251b1f$var$axios.isAxiosError = (0, $95d5d9c90d3ed94e$export$2e2bcd8739ae039);
// Expose mergeConfig
$589e2229d6251b1f$var$axios.mergeConfig = (0, $6a209c272eb13c92$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.AxiosHeaders = (0, $a2a154a4394c28e9$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.formToJSON = function(thing) {
    return (0, $0403eba3b9f630a4$export$2e2bcd8739ae039)((0, $4df68d4872fe2c8b$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$589e2229d6251b1f$var$axios.getAdapter = (0, $f5c86535c96204ca$export$2e2bcd8739ae039).getAdapter;
$589e2229d6251b1f$var$axios.HttpStatusCode = (0, $aae436c3a31e59d2$export$2e2bcd8739ae039);
$589e2229d6251b1f$var$axios.default = $589e2229d6251b1f$var$axios;
var // this module should only have a default export
$589e2229d6251b1f$export$2e2bcd8739ae039 = $589e2229d6251b1f$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $70e0fa552dd2b88d$export$1c00760e9e5a4e95 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).Axios, $70e0fa552dd2b88d$export$c1fbed17c2f6a328 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).AxiosError, $70e0fa552dd2b88d$export$1ab0c6b20d94fa14 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).CanceledError, $70e0fa552dd2b88d$export$3b22524397b493c6 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).isCancel, $70e0fa552dd2b88d$export$fd08e3cb425f0d61 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).CancelToken, $70e0fa552dd2b88d$export$a4ad2735b021c132 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).VERSION, $70e0fa552dd2b88d$export$84bf76cd7afc7469 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).all, $70e0fa552dd2b88d$export$848c9b7ead0df967 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).Cancel, $70e0fa552dd2b88d$export$fbafdbe06a5b5a9a = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).isAxiosError, $70e0fa552dd2b88d$export$3ae0fd4797ed47c8 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).spread, $70e0fa552dd2b88d$export$10ae0d317ea97f8b = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).toFormData, $70e0fa552dd2b88d$export$4e7d6ff0f3e6520 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).AxiosHeaders, $70e0fa552dd2b88d$export$a972f69c851492b3 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).HttpStatusCode, $70e0fa552dd2b88d$export$86d7c59254d6a2c9 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).formToJSON, $70e0fa552dd2b88d$export$17ddc20a97d669e2 = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).getAdapter, $70e0fa552dd2b88d$export$7ec1ebcfa9d8bd6a = (0, $589e2229d6251b1f$export$2e2bcd8739ae039).mergeConfig;


(0, (/*@__PURE__*/$parcel$interopDefault($8100c937ef40f57c$exports))).start({
    apiKey: "3e71707dda51c37549f2db4752ef8670",
    releaseStage: "production"
});
var $a672116401b1250a$export$74584b47fd40751e = /*#__PURE__*/ function() {
    var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(trackingData) {
        var response;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $589e2229d6251b1f$export$2e2bcd8739ae039).post("https://shop-client-tracking.goodgamestudios.com", trackingData).catch(function(error) {
                            $a672116401b1250a$export$275a2173e9d84865(error);
                            return error;
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.status === 200
                    ];
            }
        });
    });
    return function tracking(trackingData) {
        return _ref.apply(this, arguments);
    };
}();
var $a672116401b1250a$export$275a2173e9d84865 = function(error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($8100c937ef40f57c$exports))).notify(error);
};
var $a672116401b1250a$export$180605366c04f0cd = function() {
    var queryParameters = new URLSearchParams(window.location.search);
    var userLang = queryParameters.has('lang') && queryParameters.get('lang') || navigator.language;
    return userLang;
};
var $a672116401b1250a$export$3447b803a5f9c7a0 = function(texts) {
    var elements = document.querySelectorAll('[data-lang-tag]');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var langTagName = element.dataset.langTag;
            if (texts[langTagName]) element.innerHTML = texts[langTagName];
            if (langTagName === '@year') element.textContent = new Date().getFullYear().toString();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var $a672116401b1250a$export$dfe04b9b30f4004a = function(name, value, formElement) {
    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    formElement.append(input);
};
var $a672116401b1250a$export$a0db4953bb08f589 = function(href) {
    var element = document.createElement('link');
    element.href = href;
    document.head.append(element);
};



var $4bcd68f87cb5541e$exports = {};
$4bcd68f87cb5541e$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Zad\xe1n spr\xe1vn\xfd k\xf3d","webShop_howToFindId_desc":"Sv\xe9 osobn\xed ID najdete na sv\xe9m hr\xe1\u010Dsk\xe9m profilu.","webShop_howToFindId_link":"Kde najdu sv\xe9 osobn\xed ID?","webshop_offer_voucher_codeIsIncorrect":"Nespr\xe1vn\xfd k\xf3d","webshop_offer_voucher_enterYourCode":"Zadejte sv\xe9 osobn\xed ID","webShop_unexpectedError_desc":"Do\u0161lo k neo\u010Dek\xe1van\xe9 chyb\u011B, zkuste to pros\xedm pozd\u011Bji.","webShop_accountBanned_desc":"\xda\u010Det zablokov\xe1n!","webshop_confirm":"Ok","webshop_termsConditions_1":"V\u0161eobecn\xe9 obchodn\xed podm\xednky","webshop_purchase_privacyPolicy":"Ochrana \xfadaj\u016F","webshop_legal_1":"Pr\xe1vn\xed informace","webshop_support_1":"Podpora","mbs_access_welcome_desc":"V\xedtejte, hr\xe1\u010Di {0}","btn_login":"P\u0159ihl\xe1sit se","mbs_access_error_sessionExpired_desc":"Relace vypr\u0161ela. Zadejte pros\xedm ID \xfa\u010Dtu ru\u010Dn\u011B."}');


var $c02c946e91d0078e$exports = {};
$c02c946e91d0078e$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Korrekt kode indtastet","webShop_howToFindId_desc":"Du kan finde og kopiere dit personlige ID under din spillerprofil.","webShop_howToFindId_link":"Hvor finder jeg mit personlige ID?","webshop_offer_voucher_codeIsIncorrect":"Koden er forkert","webshop_offer_voucher_enterYourCode":"Indtast dit personlige ID","webShop_unexpectedError_desc":"Der opstod en uventet fejl. Pr\xf8v igen senere.","webShop_accountBanned_desc":"Konto sp\xe6rret!","webshop_confirm":"OK","webshop_termsConditions_1":"Brugsbetingelser","webshop_purchase_privacyPolicy":"Fortrolighedspolitik","webshop_legal_1":"Juridisk","webshop_support_1":"Support","mbs_access_welcome_desc":"Velkommen, {0}","btn_login":"Log ind","mbs_access_error_sessionExpired_desc":"Din session er udl\xf8bet. Indtast dit konto-ID manuelt."}');


var $d211ef626005c971$exports = {};
$d211ef626005c971$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Korrekten Code eingegeben","webShop_howToFindId_desc":"Ihr k\xf6nnt Eure pers\xf6nliche ID in Eurem Spielerprofil finden und kopieren.","webShop_howToFindId_link":"Wo finde ich meine pers\xf6nliche ID?","webshop_offer_voucher_codeIsIncorrect":"Code stimmt nicht","webshop_offer_voucher_enterYourCode":"Gebt Eure pers\xf6nliche ID ein.","webShop_unexpectedError_desc":"Ein unerwarteter Fehler ist aufgetreten. Bitte versucht es sp\xe4ter erneut.","webShop_accountBanned_desc":"Account gesperrt!","webshop_confirm":"OK","webshop_termsConditions_1":"AGB","webshop_purchase_privacyPolicy":"Datenschutzerkl\xe4rung","webshop_legal_1":"Rechtliches","webshop_support_1":"Support","mbs_access_welcome_desc":"Willkommen, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Eure Sitzung ist abgelaufen, bitte die Account-ID manuell eingeben."}');


var $7a92fae384ee5a0a$exports = {};
$7a92fae384ee5a0a$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C9\u03C3\u03C4\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","webShop_howToFindId_desc":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C2 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03B9\u03C2 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03BF\u03C5 ID \u03C3\u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C0\u03B1\u03AF\u03BA\u03C4\u03B7 \u03C3\u03BF\u03C5.","webShop_howToFindId_link":"\u03A0\u03BF\u03CD \u03BC\u03C0\u03BF\u03C1\u03CE \u03BD\u03B1 \u03B2\u03C1\u03C9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03BC\u03BF\u03C5 \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC;","webshop_offer_voucher_codeIsIncorrect":"\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BB\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2","webshop_offer_voucher_enterYourCode":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03BF\u03C5 \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC","webShop_unexpectedError_desc":"\u03A0\u03C1\u03BF\u03AD\u03BA\u03C5\u03C8\u03B5 \u03BC\u03B7 \u03B1\u03BD\u03B1\u03BC\u03B5\u03BD\u03CC\u03BC\u03B5\u03BD\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1, \u03B4\u03BF\u03BA\u03AF\u03BC\u03B1\u03C3\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1.","webShop_accountBanned_desc":"\u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B1\u03C0\u03BF\u03BA\u03BB\u03B5\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5!","webshop_confirm":"OK","webshop_termsConditions_1":"\u038C\u03C1\u03BF\u03B9 &amp; \u03A0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2","webshop_purchase_privacyPolicy":"\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5","webshop_legal_1":"\u039D\u03BF\u03BC\u03B9\u03BA\u03AD\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","webshop_support_1":"\u03A5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7","mbs_access_welcome_desc":"\u039A\u03B1\u03BB\u03CE\u03C2 \u03CC\u03C1\u03B9\u03C3\u03B5\u03C2, {0}","btn_login":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","mbs_access_error_sessionExpired_desc":"\u0397 \u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 \u03AD\u03BB\u03B7\u03BE\u03B5. \u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B5 \u03C4\u03BF ID \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03BF\u03C5 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1."}');


var $5cf60591f4a0753c$exports = {};
$5cf60591f4a0753c$exports = JSON.parse("{\"webshop_offer_voucher_correctCode\":\"Correct code entered\",\"webShop_howToFindId_desc\":\"You can find and copy your personal ID in your player profile.\",\"webShop_howToFindId_link\":\"Where do I find my personal ID?\",\"webshop_offer_voucher_codeIsIncorrect\":\"Code is incorrect\",\"webshop_offer_voucher_enterYourCode\":\"Enter your personal ID\",\"webShop_unexpectedError_desc\":\"An unexpected error occurred, please try again later.\",\"webShop_accountBanned_desc\":\"Account banned!\",\"webshop_confirm\":\"OK\",\"webshop_termsConditions_1\":\"Terms &amp; Conditions\",\"webshop_purchase_privacyPolicy\":\"Privacy Policy\",\"webshop_legal_1\":\"Legal\",\"webshop_support_1\":\"Support\",\"mbs_access_welcome_desc\":\"Welcome, {0}\",\"btn_login\":\"Login\",\"mbs_access_error_sessionExpired_desc\":\"Your session has expired. Please enter your account ID manually.\"}");


var $a07e3f52307762ae$exports = {};
$a07e3f52307762ae$exports = JSON.parse("{\"webshop_offer_voucher_correctCode\":\"Correct code entered\",\"webShop_howToFindId_desc\":\"You can find and copy your personal ID in your player profile.\",\"webShop_howToFindId_link\":\"Where do I find my personal ID?\",\"webshop_offer_voucher_codeIsIncorrect\":\"Code is incorrect\",\"webshop_offer_voucher_enterYourCode\":\"Enter your personal ID\",\"webShop_unexpectedError_desc\":\"An unexpected error occurred, please try again later.\",\"webShop_accountBanned_desc\":\"Account banned!\",\"webshop_confirm\":\"OK\",\"webshop_termsConditions_1\":\"Terms &amp; Conditions\",\"webshop_purchase_privacyPolicy\":\"Privacy Policy\",\"webshop_legal_1\":\"Legal\",\"webshop_support_1\":\"Support\",\"mbs_access_welcome_desc\":\"Welcome, {0}\",\"btn_login\":\"Login\",\"mbs_access_error_sessionExpired_desc\":\"Your session has expired. Please enter your account ID manually.\"}");


var $484eee5044d12c48$exports = {};
$484eee5044d12c48$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correcto","webShop_howToFindId_desc":"Puedes buscar y copiar tu ID personal en el perfil.","webShop_howToFindId_link":"\xbfD\xf3nde puedo ver mi ID personal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorrecto","webshop_offer_voucher_enterYourCode":"Escribe tu ID personal...","webShop_unexpectedError_desc":"Se ha producido un error inesperado. Int\xe9ntalo de nuevo m\xe1s tarde.","webShop_accountBanned_desc":"\xa1Cuenta bloqueada!","webshop_confirm":"OK","webshop_termsConditions_1":"Condiciones de uso","webshop_purchase_privacyPolicy":"Pol\xedtica de privacidad","webshop_legal_1":"Legal","webshop_support_1":"Asistencia","mbs_access_welcome_desc":"\xa1Hola, {0}!","btn_login":"Iniciar sesi\xf3n","mbs_access_error_sessionExpired_desc":"La sesi\xf3n ha caducado. Introduce tu ID de cuenta de forma manual."}');


var $9bcce1046c4c7a54$exports = {};
$9bcce1046c4c7a54$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Annettu koodi on oikea","webShop_howToFindId_desc":"Voit kopioida oman tunnuksesi pelaajaprofiilistasi.","webShop_howToFindId_link":"Mist\xe4 l\xf6yd\xe4n oman tunnukseni?","webshop_offer_voucher_codeIsIncorrect":"Koodi on virheellinen","webshop_offer_voucher_enterYourCode":"Sy\xf6t\xe4 henkil\xf6kohtainen tunnuksesi","webShop_unexpectedError_desc":"Tapahtui odottamaton virhe. Yrit\xe4 my\xf6hemmin uudelleen.","webShop_accountBanned_desc":"Tili on k\xe4ytt\xf6kiellossa!","webshop_confirm":"OK","webshop_termsConditions_1":"K\xe4ytt\xf6ehdot","webshop_purchase_privacyPolicy":"Tietosuojak\xe4yt\xe4nt\xf6","webshop_legal_1":"Juridiset tiedot","webshop_support_1":"Tuki","mbs_access_welcome_desc":"Tervetuloa, {0}","btn_login":"Kirjaudu","mbs_access_error_sessionExpired_desc":"Sessiosi on vanhentunut. Kirjoita tilitunnuksesi."}');


var $7a642158738ee737$exports = {};
$7a642158738ee737$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Code correct saisi","webShop_howToFindId_desc":"Vous pouvez retrouver et copier votre ID personnel \xe0 partir de votre profil.","webShop_howToFindId_link":"O\xf9 trouver mon ID personnel\xa0?","webshop_offer_voucher_codeIsIncorrect":"Le code est incorrect","webshop_offer_voucher_enterYourCode":"Saisissez votre ID personnel","webShop_unexpectedError_desc":"Une erreur inattendue s\'est produite. Veuillez r\xe9essayer ult\xe9rieurement.","webShop_accountBanned_desc":"Compte banni\xa0!","webshop_confirm":"OK","webshop_termsConditions_1":"Conditions g\xe9n\xe9rales d\'utilisation","webshop_purchase_privacyPolicy":"Protection des donn\xe9es","webshop_legal_1":"Mentions l\xe9gales","webshop_support_1":"Support","mbs_access_welcome_desc":"Bienvenue, {0}","btn_login":"Connexion","mbs_access_error_sessionExpired_desc":"Votre session a expir\xe9. Veuillez saisir manuellement l\'ID de votre compte."}');


var $0b5367613600586c$exports = {};
$0b5367613600586c$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"A megadott k\xf3d helyes","webShop_howToFindId_desc":"A szem\xe9lyi azonos\xedt\xf3dat a j\xe1t\xe9kosprofilodban tal\xe1lhatod meg \xe9s m\xe1solhatod ki.","webShop_howToFindId_link":"Hol tal\xe1lhat\xf3 a szem\xe9lyes azonos\xedt\xf3m?","webshop_offer_voucher_codeIsIncorrect":"Helytelen k\xf3d","webshop_offer_voucher_enterYourCode":"Add meg a szem\xe9lyes azonos\xedt\xf3dat","webShop_unexpectedError_desc":"V\xe1ratlan hiba t\xf6rt\xe9nt, pr\xf3b\xe1ld \xfajra k\xe9s\u0151bb.","webShop_accountBanned_desc":"Fi\xf3k kitiltva!","webshop_confirm":"OK","webshop_termsConditions_1":"Felhaszn\xe1l\xe1si felt\xe9telek","webshop_purchase_privacyPolicy":"Adatv\xe9delmi szab\xe1lyzat","webshop_legal_1":"Jogi","webshop_support_1":"\xdcgyf\xe9lszolg\xe1lat","mbs_access_welcome_desc":"\xdcdv, {0}!","btn_login":"Bejelentkez\xe9s","mbs_access_error_sessionExpired_desc":"A munkamenet lej\xe1rt. Add meg manu\xe1lisan a fi\xf3kazonos\xedt\xf3dat."}');


var $d839a12d92977d0b$exports = {};
$d839a12d92977d0b$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Codice immesso corretto","webShop_howToFindId_desc":"Puoi trovare e copiare il tuo ID personale nel tuo profilo giocatore.","webShop_howToFindId_link":"Dove trovo il mio ID personale?","webshop_offer_voucher_codeIsIncorrect":"Il codice \xe8 errato","webshop_offer_voucher_enterYourCode":"Immetti il tuo ID personale","webShop_unexpectedError_desc":"Si \xe8 verificato un errore imprevisto, riprova pi\xf9 tardi.","webShop_accountBanned_desc":"Account bannato!","webshop_confirm":"OK","webshop_termsConditions_1":"Termini e condizioni","webshop_purchase_privacyPolicy":"Privacy","webshop_legal_1":"Legale","webshop_support_1":"Assistenza","mbs_access_welcome_desc":"Ciao, {0}","btn_login":"Accedi","mbs_access_error_sessionExpired_desc":"La tua sessione \xe8 scaduta. Immetti manualmente il tuo ID account."}');


var $a4a173a4cc86ad76$exports = {};
$a4a173a4cc86ad76$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u6B63\u3057\u3044\u30B3\u30FC\u30C9\u304C\u5165\u529B\u3055\u308C\u307E\u3057\u305F","webShop_howToFindId_desc":"\u500B\u4EBAID\u306F\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u304B\u3089\u30B3\u30D4\u30FC\u3067\u304D\u307E\u3059\u3002","webShop_howToFindId_link":"\u500B\u4EBAID\u306F\u3069\u3053\u306B\u3042\u308A\u307E\u3059\u304B\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u30B3\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","webshop_offer_voucher_enterYourCode":"\u500B\u4EBAID\u3092\u5165\u529B\u3059\u308B","webShop_unexpectedError_desc":"\u4E88\u671F\u3057\u306A\u3044\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","webShop_accountBanned_desc":"\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u505C\u6B62\u3055\u308C\u307E\u3057\u305F\uFF01","webshop_confirm":"OK","webshop_termsConditions_1":"\u5229\u7528\u898F\u7D04","webshop_purchase_privacyPolicy":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC","webshop_legal_1":"\u6CD5\u7684\u4E8B\u9805","webshop_support_1":"\u30B5\u30DD\u30FC\u30C8","mbs_access_welcome_desc":"{0}\u3055\u3093\u3001\u3088\u3046\u3053\u305D\u3002","btn_login":"\u30ED\u30B0\u30A4\u30F3","mbs_access_error_sessionExpired_desc":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u5931\u52B9\u3057\u307E\u3057\u305F\u3002\u30A2\u30AB\u30A6\u30F3\u30C8ID\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}');


var $8c5c1b2b46b0a35d$exports = {};
$8c5c1b2b46b0a35d$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\uC62C\uBC14\uB978 \uCF54\uB4DC\uAC00 \uC785\uB825\uB428","webShop_howToFindId_desc":"\uD50C\uB808\uC774\uC5B4 \uD504\uB85C\uD544\uC5D0\uC11C \uAC1C\uC778 ID\uB97C \uD655\uC778\uD558\uACE0 \uBCF5\uC0AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","webShop_howToFindId_link":"\uAC1C\uC778 ID\uB97C \uC5B4\uB514\uC11C \uCC3E\uC744 \uC218 \uC788\uB098\uC694?","webshop_offer_voucher_codeIsIncorrect":"\uCF54\uB4DC\uAC00 \uC798\uBABB\uB428","webshop_offer_voucher_enterYourCode":"\uAC1C\uC778 ID \uC785\uB825","webShop_unexpectedError_desc":"\uC608\uAE30\uCE58 \uBABB\uD55C \uC624\uB958 \uBC1C\uC0DD, \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.","webShop_accountBanned_desc":"\uACC4\uC815\uC774 \uC815\uC9C0\uB428!","webshop_confirm":"\uD655\uC778","webshop_termsConditions_1":"\uC57D\uAD00","webshop_purchase_privacyPolicy":"\uAC1C\uC778\uC815\uBCF4\uCDE8\uAE09\uBC29\uCE68","webshop_legal_1":"\uBC95\uB960","webshop_support_1":"\uC9C0\uC6D0","mbs_access_welcome_desc":"\uD658\uC601\uD569\uB2C8\uB2E4, {0} \uB2D8","btn_login":"\uB85C\uADF8\uC778","mbs_access_error_sessionExpired_desc":"\uC138\uC158\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uACC4\uC815 ID\uB97C \uC9C1\uC811 \uC785\uB825\uD574 \uC8FC\uC2ED\uC2DC\uC624."}');


var $b70dd56ff13386c6$exports = {};
$b70dd56ff13386c6$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Juiste code ingevuld","webShop_howToFindId_desc":"Je persoonlijke ID vind je en kun je kopi\xebren in je spelersprofiel.","webShop_howToFindId_link":"Waar vind ik mijn persoonlijke ID?","webshop_offer_voucher_codeIsIncorrect":"Code is onjuist","webshop_offer_voucher_enterYourCode":"Voer je persoonlijke ID in","webShop_unexpectedError_desc":"Er is een onverwachte fout opgetreden. Probeer het later opnieuw.","webShop_accountBanned_desc":"Account verbannen!","webshop_confirm":"OK","webshop_termsConditions_1":"Algemene voorwaarden","webshop_purchase_privacyPolicy":"Privacybeleid","webshop_legal_1":"Juridisch","webshop_support_1":"Ondersteuning","mbs_access_welcome_desc":"Welkom, {0}","btn_login":"Aanmelden","mbs_access_error_sessionExpired_desc":"Je sessie is verlopen. Voer je account-ID handmatig in."}');


var $035726c8f424da73$exports = {};
$035726c8f424da73$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Gyldig kode","webShop_howToFindId_desc":"I spillerprofilen din finner du ID-en din, og du kan kopiere den derfra.","webShop_howToFindId_link":"Hvor finner jeg min personlige ID?","webshop_offer_voucher_codeIsIncorrect":"Feil kode","webshop_offer_voucher_enterYourCode":"Skriv inn din personlige ID","webShop_unexpectedError_desc":"Det har oppst\xe5tt en uventet feil. Pr\xf8v igjen senere.","webShop_accountBanned_desc":"Kontoen er utestengt!","webshop_confirm":"OK","webshop_termsConditions_1":"Bruksvilk\xe5r","webshop_purchase_privacyPolicy":"Retningslinjer for personvern","webshop_legal_1":"Juridisk","webshop_support_1":"Kundest\xf8tte","mbs_access_welcome_desc":"Velkommen, {0}","btn_login":"Logg inn","mbs_access_error_sessionExpired_desc":"\xd8kten har utl\xf8pt. Skriv inn konto-ID manuelt."}');


var $5ee7d0661059a459$exports = {};
$5ee7d0661059a459$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Wprowadzono poprawny kod","webShop_howToFindId_desc":"Sw\xf3j identyfikator osobisty znajdziesz i skopiujesz na ekranie swojego profilu gracza.","webShop_howToFindId_link":"Gdzie znajd\u0119 moje osobiste ID?","webshop_offer_voucher_codeIsIncorrect":"Kod jest niew\u0142a\u015Bciwy","webshop_offer_voucher_enterYourCode":"Wprowad\u017A sw\xf3j identyfikator osobisty","webShop_unexpectedError_desc":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d. Prosimy spr\xf3bowa\u0107 ponownie p\xf3\u017Aniej.","webShop_accountBanned_desc":"Konto zablokowane!","webshop_confirm":"OK","webshop_termsConditions_1":"Warunki u\u017Cytkowania","webshop_purchase_privacyPolicy":"Ochrona danych osobowych","webshop_legal_1":"Informacje prawne","webshop_support_1":"Wsparcie","mbs_access_welcome_desc":"Witaj, {0}!","btn_login":"Logowanie","mbs_access_error_sessionExpired_desc":"Sesja wygas\u0142a. Prosimy o r\u0119czne wprowadzenie ID konta."}');


var $0ad123486c85379e$exports = {};
$0ad123486c85379e$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correto inserido","webShop_howToFindId_desc":"Voc\xea pode encontrar e copiar sua ID pessoal no seu perfil de jogador.","webShop_howToFindId_link":"Onde encontro minha ID pessoal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorreto","webshop_offer_voucher_enterYourCode":"Insira sua ID pessoal","webShop_unexpectedError_desc":"Erro inesperado. Tente novamente mais tarde.","webShop_accountBanned_desc":"Conta banida!","webshop_confirm":"OK","webshop_termsConditions_1":"Termos e Condi\xe7\xf5es","webshop_purchase_privacyPolicy":"Pol\xedtica de Privacidade","webshop_legal_1":"Legal","webshop_support_1":"Suporte","mbs_access_welcome_desc":"Bem-vindo, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Sua sess\xe3o expirou. Insira sua ID de conta manualmente."}');


var $bf82f97c21f2521a$exports = {};
$bf82f97c21f2521a$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correto inserido","webShop_howToFindId_desc":"Voc\xea pode encontrar e copiar sua ID pessoal no seu perfil de jogador.","webShop_howToFindId_link":"Onde encontro minha ID pessoal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorreto","webshop_offer_voucher_enterYourCode":"Insira sua ID pessoal","webShop_unexpectedError_desc":"Erro inesperado. Tente novamente mais tarde.","webShop_accountBanned_desc":"Conta banida!","webshop_confirm":"OK","webshop_termsConditions_1":"Termos e Condi\xe7\xf5es","webshop_purchase_privacyPolicy":"Pol\xedtica de Privacidade","webshop_legal_1":"Legal","webshop_support_1":"Suporte","mbs_access_welcome_desc":"Bem-vindo, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Sua sess\xe3o expirou. Insira sua ID de conta manualmente."}');


var $b0323ef77148e2ca$exports = {};
$b0323ef77148e2ca$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Cod corect introdus","webShop_howToFindId_desc":"Po\u021Bi g\u0103si \u0219i copia ID-ul personal din profilul t\u0103u de juc\u0103tor.","webShop_howToFindId_link":"Unde g\u0103sesc ID-ul meu personal?","webshop_offer_voucher_codeIsIncorrect":"Codul este incorect","webshop_offer_voucher_enterYourCode":"Introdu ID-ul personal","webShop_unexpectedError_desc":"A ap\u0103rut o eroare nea\u0219teptat\u0103, \xeencearc\u0103 din nou mai t\xe2rziu.","webShop_accountBanned_desc":"Cont blocat!","webshop_confirm":"OK","webshop_termsConditions_1":"Termeni \u0219i Condi\u021Bii","webshop_purchase_privacyPolicy":"Politica de confiden\u0163ialitate","webshop_legal_1":"Juridic","webshop_support_1":"Asisten\u0163\u0103","mbs_access_welcome_desc":"Bun venit, {0}","btn_login":"Conectare","mbs_access_error_sessionExpired_desc":"Sesiunea ta a expirat. Introdu manual ID-ul contului."}');


var $c0fb8691d691f942$exports = {};
$c0fb8691d691f942$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u0412\u0432\u0435\u0434\u0435\u043D \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434","webShop_howToFindId_desc":"\u0422\u044B \u043C\u043E\u0436\u0435\u0448\u044C \u043D\u0430\u0439\u0442\u0438 \u0438 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0432 \u0441\u0432\u043E\u0435\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435 \u0438\u0433\u0440\u043E\u043A\u0430.","webShop_howToFindId_link":"\u0413\u0434\u0435 \u044F \u043C\u043E\u0433\u0443 \u043D\u0430\u0439\u0442\u0438 \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440?","webshop_offer_voucher_codeIsIncorrect":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434","webshop_offer_voucher_enterYourCode":"\u0412\u0432\u0435\u0434\u0438 \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440","webShop_unexpectedError_desc":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430; \u043F\u043E\u0432\u0442\u043E\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0447\u0443\u0442\u044C \u043F\u043E\u0437\u0436\u0435.","webShop_accountBanned_desc":"\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430!","webshop_confirm":"OK","webshop_termsConditions_1":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435","webshop_purchase_privacyPolicy":"\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438","webshop_legal_1":"\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","webshop_support_1":"\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430","mbs_access_welcome_desc":"\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C, {0}!","btn_login":"\u0412\u0445\u043E\u0434","mbs_access_error_sessionExpired_desc":"\u0412\u0440\u0435\u043C\u044F \u0441\u0435\u0430\u043D\u0441\u0430 \u0438\u0441\u0442\u0435\u043A\u043B\u043E. \u0412\u0432\u0435\u0434\u0438 \u0441\u0432\u043E\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0432\u0440\u0443\u0447\u043D\u0443\u044E."}');


var $70e4239e197b5c63$exports = {};
$70e4239e197b5c63$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Zadal si spr\xe1vny k\xf3d","webShop_howToFindId_desc":"Svoje osobn\xe9 ID n\xe1jde\u0161 v profile hr\xe1\u010Da, kde ho m\xf4\u017Ee\u0161 skop\xedrova\u0165.","webShop_howToFindId_link":"Kde n\xe1jdem svoje osobn\xe9 ID?","webshop_offer_voucher_codeIsIncorrect":"K\xf3d nie je spr\xe1vny","webshop_offer_voucher_enterYourCode":"Zadaj svoje osobn\xe9 ID","webShop_unexpectedError_desc":"Vyskytla sa neo\u010Dak\xe1van\xe1 chyba, sk\xfas to znova nesk\xf4r.","webShop_accountBanned_desc":"Konto je zablokovan\xe9!","webshop_confirm":"OK","webshop_termsConditions_1":"Zmluvn\xe9 podmienky","webshop_purchase_privacyPolicy":"Ochrana osobn\xfdch \xfadajov","webshop_legal_1":"Pr\xe1vne inform\xe1cie","webshop_support_1":"Podpora","mbs_access_welcome_desc":"Vitaj, {0}","btn_login":"Prihl\xe1senie","mbs_access_error_sessionExpired_desc":"\u010Cas tejto rel\xe1cie uplynul. Zadaj ID svojho konta ru\u010Dne."}');


var $b57f0d81a87b8f28$exports = {};
$b57f0d81a87b8f28$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Du angav en giltig kod","webShop_howToFindId_desc":"Du kan hitta och kopiera ditt personliga ID i din spelarprofil.","webShop_howToFindId_link":"Var hittar jag mitt personliga ID?","webshop_offer_voucher_codeIsIncorrect":"Koden \xe4r felaktig","webshop_offer_voucher_enterYourCode":"Ange ditt personliga ID","webShop_unexpectedError_desc":"Ett ov\xe4ntat fel har intr\xe4ffat. F\xf6rs\xf6k igen senare.","webShop_accountBanned_desc":"Konto avst\xe4ngt!","webshop_confirm":"OK","webshop_termsConditions_1":"Villkor och krav","webshop_purchase_privacyPolicy":"Integritetspolicy","webshop_legal_1":"Juridiskt","webshop_support_1":"Kontakta supporten","mbs_access_welcome_desc":"V\xe4lkommen, {0}","btn_login":"Logga in","mbs_access_error_sessionExpired_desc":"Din session har g\xe5tt ut. Ange ditt konto-ID manuellt."}');


var $6cf8a646974ee09a$exports = {};
$6cf8a646974ee09a$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Girilen kod do\u011Fru","webShop_howToFindId_desc":"Oyuncu profilindeki ki\u015Fisel kimli\u011Fini bulabilir ve kopyalayabilirsin.","webShop_howToFindId_link":"Ki\u015Fisel kimli\u011Fimi nerede bulabilirim?","webshop_offer_voucher_codeIsIncorrect":"Kod yanl\u0131\u015F","webshop_offer_voucher_enterYourCode":"Ki\u015Fisel Kimli\u011Fini gir","webShop_unexpectedError_desc":"Beklenmedik bir hata ger\xe7ekle\u015Fti, l\xfctfen daha sonra tekrar dene.","webShop_accountBanned_desc":"Hesap engellendi!","webshop_confirm":"OK","webshop_termsConditions_1":"\u015Eart ve Ko\u015Fullar","webshop_purchase_privacyPolicy":"Gizlilik Politikas\u0131","webshop_legal_1":"Yasal","webshop_support_1":"Destek","mbs_access_welcome_desc":"Ho\u015F geldin {0}","btn_login":"Oturum a\xe7","mbs_access_error_sessionExpired_desc":"Oturumunun s\xfcresi doldu. L\xfctfen hesap kimli\u011Fini manuel olarak gir."}');


var $97de95611d9e69e4$exports = {};
$97de95611d9e69e4$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u6B63\u786E","webShop_howToFindId_desc":"\u4F60\u53EF\u4EE5\u5728\u73A9\u5BB6\u8D44\u6599\u4E2D\u627E\u5230\u5E76\u590D\u5236\u4F60\u7684\u4E2A\u4EBA ID","webShop_howToFindId_link":"\u6211\u7684\u4E2A\u4EBA ID \u5728\u54EA\u91CC\u53EF\u4EE5\u627E\u5230\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u7801\u4E0D\u6B63\u786E","webshop_offer_voucher_enterYourCode":"\u8F93\u5165\u60A8\u7684\u4EE3\u7801","webShop_unexpectedError_desc":"An unexpected error occurred, please try again later.","webShop_accountBanned_desc":"Account banned!","webshop_confirm":"\u786E\u5B9A","mbs_access_welcome_desc":"Welcome, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Your session has expired. Please enter your account ID manually."}');


var $3903fd297f3a0896$exports = {};
$3903fd297f3a0896$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u6B63\u786E","webShop_howToFindId_desc":"\u60A8\u53EF\u4EE5\u5728\u73A9\u5BB6\u4E2A\u4EBA\u8D44\u6599\u4E2D\u627E\u5230\u5E76\u590D\u5236\u4E2A\u4EBA ID\u3002","webShop_howToFindId_link":"\u54EA\u91CC\u53EF\u4EE5\u627E\u5230\u6211\u7684\u4E2A\u4EBA ID\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u7801\u4E0D\u6B63\u786E","webshop_offer_voucher_enterYourCode":"\u8F93\u5165\u60A8\u7684\u4E2A\u4EBA ID","webShop_unexpectedError_desc":"\u53D1\u751F\u610F\u5916\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002","webShop_accountBanned_desc":"\u5E10\u6237\u88AB\u5C01\uFF01","webshop_confirm":"\u786E\u5B9A","webshop_termsConditions_1":"\u6761\u6B3E\u548C\u6761\u4EF6","webshop_purchase_privacyPolicy":"\u9690\u79C1\u653F\u7B56","webshop_legal_1":"\u6CD5\u5F8B","webshop_support_1":"\u652F\u6301","mbs_access_welcome_desc":"\u6B22\u8FCE\uFF0C{0}","btn_login":"\u767B\u5F55","mbs_access_error_sessionExpired_desc":"\u60A8\u672C\u6B21\u6E38\u620F\u5DF2\u8FC7\u671F\u3002\u8BF7\u624B\u52A8\u8F93\u5165\u60A8\u7684\u5E10\u6237 ID\u3002"}');


var $f5e8b9c3aff94b8a$exports = {};
$f5e8b9c3aff94b8a$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F38\u5165\u7684\u4EE3\u78BC\u6B63\u78BA","webShop_howToFindId_desc":"\u4F60\u53EF\u4EE5\u5728\u4F60\u7684\u73A9\u5BB6\u500B\u4EBA\u8CC7\u6599\u4E2D\u627E\u5230\u4E26\u8907\u88FD\u4F60\u7684\u500B\u4EBA ID\u3002","webShop_howToFindId_link":"\u5728\u54EA\u88E1\u627E\u5230\u6211\u7684\u500B\u4EBA ID\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u78BC\u4E0D\u6B63\u78BA","webshop_offer_voucher_enterYourCode":"\u8F38\u5165\u4F60\u7684\u500B\u4EBA ID","webShop_unexpectedError_desc":"\u767C\u751F\u672A\u9810\u671F\u7684\u932F\u8AA4\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","webShop_accountBanned_desc":"\u5E33\u865F\u5DF2\u88AB\u7981\u7528\uFF01","webshop_confirm":"\u597D","webshop_termsConditions_1":"\u670D\u52D9\u689D\u6B3E","webshop_purchase_privacyPolicy":"\u96B1\u79C1\u653F\u7B56","webshop_legal_1":"\u5408\u6CD5","webshop_support_1":"\u6280\u8853\u652F\u63F4","mbs_access_welcome_desc":"\u6B61\u8FCE\uFF0C{0}","btn_login":"\u767B\u5165","mbs_access_error_sessionExpired_desc":"\u4F60\u7684\u8F38\u5165\u968E\u6BB5\u5DF2\u7D93\u903E\u6642\u3002\u8ACB\u624B\u52D5\u8F38\u5165\u4F60\u7684\u5E33\u865F ID\u3002"}');


var $9aa2e31f53977813$exports = {};
$9aa2e31f53977813$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F38\u5165\u7684\u4EE3\u78BC\u6B63\u78BA","webShop_howToFindId_desc":"You can find and copy your personal ID in your player profile.","webShop_howToFindId_link":"Where do I find my personal ID?","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u78BC\u4E0D\u6B63\u78BA","webshop_offer_voucher_enterYourCode":"\u8F38\u5165\u4F60\u7684\u4EE3\u78BC","webShop_unexpectedError_desc":"An unexpected error occurred, please try again later.","webShop_accountBanned_desc":"Account banned!","webshop_confirm":"\u597D","webshop_offer_voucher_welcome_title":"Welcome, {{playername}}","webshop_continue":"Continue"}');


var $dbce29165e166102$var$availableLanguages = {
    cs: (0, (/*@__PURE__*/$parcel$interopDefault($4bcd68f87cb5541e$exports))),
    da: (0, (/*@__PURE__*/$parcel$interopDefault($c02c946e91d0078e$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($d211ef626005c971$exports))),
    el: (0, (/*@__PURE__*/$parcel$interopDefault($7a92fae384ee5a0a$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($5cf60591f4a0753c$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($484eee5044d12c48$exports))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($9bcce1046c4c7a54$exports))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($7a642158738ee737$exports))),
    hu: (0, (/*@__PURE__*/$parcel$interopDefault($0b5367613600586c$exports))),
    it: (0, (/*@__PURE__*/$parcel$interopDefault($d839a12d92977d0b$exports))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($a4a173a4cc86ad76$exports))),
    ko: (0, (/*@__PURE__*/$parcel$interopDefault($8c5c1b2b46b0a35d$exports))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($b70dd56ff13386c6$exports))),
    no: (0, (/*@__PURE__*/$parcel$interopDefault($035726c8f424da73$exports))),
    pl: (0, (/*@__PURE__*/$parcel$interopDefault($5ee7d0661059a459$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($0ad123486c85379e$exports))),
    ro: (0, (/*@__PURE__*/$parcel$interopDefault($b0323ef77148e2ca$exports))),
    ru: (0, (/*@__PURE__*/$parcel$interopDefault($c0fb8691d691f942$exports))),
    sk: (0, (/*@__PURE__*/$parcel$interopDefault($70e4239e197b5c63$exports))),
    sv: (0, (/*@__PURE__*/$parcel$interopDefault($b57f0d81a87b8f28$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($6cf8a646974ee09a$exports))),
    zh: (0, (/*@__PURE__*/$parcel$interopDefault($3903fd297f3a0896$exports))),
    'en-us': (0, (/*@__PURE__*/$parcel$interopDefault($a07e3f52307762ae$exports))),
    'pt-br': (0, (/*@__PURE__*/$parcel$interopDefault($bf82f97c21f2521a$exports))),
    'zh-cn': (0, (/*@__PURE__*/$parcel$interopDefault($97de95611d9e69e4$exports))),
    'zh-hans': (0, (/*@__PURE__*/$parcel$interopDefault($3903fd297f3a0896$exports))),
    'zh-hant': (0, (/*@__PURE__*/$parcel$interopDefault($f5e8b9c3aff94b8a$exports))),
    'zh-tw': (0, (/*@__PURE__*/$parcel$interopDefault($9aa2e31f53977813$exports)))
};
var $dbce29165e166102$export$c2d6918ee454df48 = Object.keys($dbce29165e166102$var$availableLanguages);
var $dbce29165e166102$export$e715429495646215 = {
    webshop_offer_voucher_correctCode: '',
    webShop_howToFindId_desc: '',
    webShop_howToFindId_link: '',
    webshop_offer_voucher_codeIsIncorrect: '',
    webshop_offer_voucher_enterYourCode: '',
    webShop_unexpectedError_desc: '',
    webShop_accountBanned_desc: '',
    webshop_confirm: '',
    webshop_termsConditions_1: '',
    webshop_purchase_privacyPolicy: '',
    webshop_legal_1: '',
    webshop_support_1: '',
    mbs_access_welcome_desc: '',
    btn_login: '',
    mbs_access_error_sessionExpired_desc: ''
};
var $dbce29165e166102$export$2e2bcd8739ae039 = $dbce29165e166102$var$availableLanguages;


var $982b88ab7c902538$export$a984e488de492859 = {
    defaultLanguage: 'en',
    get language () {
        var userLocale = (0, $a672116401b1250a$export$180605366c04f0cd)();
        var formattedUserLocale = userLocale.toLowerCase().replace('_', '-');
        if ((0, $dbce29165e166102$export$c2d6918ee454df48).includes(formattedUserLocale)) return formattedUserLocale;
        var userLocaleWithoutRegion = formattedUserLocale.slice(0, 2);
        if ((0, $dbce29165e166102$export$c2d6918ee454df48).includes(userLocaleWithoutRegion)) return userLocaleWithoutRegion;
        return this.defaultLanguage;
    },
    get languageWithoutRegion () {
        return this.language.slice(0, 2);
    },
    get texts () {
        var isLanguageAvailable = this.language in (0, $dbce29165e166102$export$2e2bcd8739ae039);
        // There's already a validation to handle unsupported languages
        // This one is just one more fallback to english
        if (isLanguageAvailable) return (0, $dbce29165e166102$export$2e2bcd8739ae039)[this.language];
        return (0, $dbce29165e166102$export$2e2bcd8739ae039)[this.defaultLanguage];
    },
    init: function() {
        (0, $a672116401b1250a$export$3447b803a5f9c7a0)(this.texts);
        this.translateLegalLinks();
    },
    getTranslatedText: function(label) {
        return this.texts[label];
    },
    translateLegalLinks: function() {
        $982b88ab7c902538$export$7a5d735b2ab6389d.termsLink.href = (0, $9d763a0e8ba22644$export$7a948dda2e5abcb7).getTermsLink(this.languageWithoutRegion);
        $982b88ab7c902538$export$7a5d735b2ab6389d.legalLink.href = (0, $9d763a0e8ba22644$export$7a948dda2e5abcb7).getLegalLink(this.languageWithoutRegion);
        $982b88ab7c902538$export$7a5d735b2ab6389d.supportLink.href = (0, $9d763a0e8ba22644$export$7a948dda2e5abcb7).getSupportLink(this.languageWithoutRegion, (0, $9d763a0e8ba22644$export$1b00a204b1f1aa92));
    }
};
var $982b88ab7c902538$var$getSessionId = function() {
    var queryParameters = new URLSearchParams(window.location.search);
    var sid = queryParameters.get('sid');
    return sid !== null && sid !== void 0 ? sid : (0, $a513f127468cfa5a$export$2e2bcd8739ae039)();
};
/*
    Session ID priority order:
    1. mbsSession cookie
    2. sid query parameter
    3. uuid
*/ var $982b88ab7c902538$var$SESSION_ID = $982b88ab7c902538$var$getSessionId();
var $982b88ab7c902538$var$sharedTrackingData = {
    zoneId: -1,
    networkId: -1,
    instanceId: -1,
    playerId: -1
};
var $982b88ab7c902538$export$593fa4e2a48c3c25 = /*#__PURE__*/ function() {
    var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(trackingData) {
        var formattedTrackingData;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            formattedTrackingData = (0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)((0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({
                gameId: (0, $9d763a0e8ba22644$export$1b00a204b1f1aa92)
            }, $982b88ab7c902538$var$sharedTrackingData), {
                isAutoLoggedIn: 0
            }), trackingData), {
                eventId: (0, $9d763a0e8ba22644$export$8b0894f4c14eda03),
                date: new Date().toUTCString(),
                microtime: Date.now(),
                sessionId: $982b88ab7c902538$var$SESSION_ID
            });
            return [
                2,
                (0, $a672116401b1250a$export$74584b47fd40751e)(formattedTrackingData)
            ];
        });
    });
    return function trackingMBS(trackingData) {
        return _ref.apply(this, arguments);
    };
}();
var $982b88ab7c902538$export$e4771ae2bc0f2ca2 = /*#__PURE__*/ function() {
    var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function() {
        var formattedTrackingData;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            formattedTrackingData = (0, $0e36c637278130e7$export$71511d61b312f219)((0, $44df43b91545a470$export$71511d61b312f219)({
                gameId: (0, $9d763a0e8ba22644$export$1b00a204b1f1aa92)
            }, $982b88ab7c902538$var$sharedTrackingData), {
                sessionId: $982b88ab7c902538$var$SESSION_ID,
                eventId: (0, $9d763a0e8ba22644$export$d37404c264af2f19),
                date: new Date().toUTCString(),
                microtime: Date.now(),
                unixtimeMS: Date.now(),
                sourceId: 'MBS'
            });
            return [
                2,
                (0, $a672116401b1250a$export$74584b47fd40751e)(formattedTrackingData)
            ];
        });
    });
    return function trackingRanch() {
        return _ref.apply(this, arguments);
    };
}();
var $982b88ab7c902538$export$4adfdf36e0b63527 = function() {
    sessionStorage.setItem('autologin', 'false');
    var mbsSessionCookie = (0, (/*@__PURE__*/$parcel$interopDefault($37b4db63c35f7018$exports))).get('mbsSession');
    if (!mbsSessionCookie) return false;
    var mbsSessionData = JSON.parse(decodeURIComponent(mbsSessionCookie));
    var playerName = mbsSessionData.playerName, zoneId = mbsSessionData.zoneId, criteria = mbsSessionData.criteria, sid = mbsSessionData.sid, playerId = mbsSessionData.playerId, networkId = mbsSessionData.networkId, instanceId = mbsSessionData.instanceId, isTempserver = mbsSessionData.isTempserver;
    $982b88ab7c902538$var$sharedTrackingData = {
        zoneId: Number(zoneId),
        playerId: playerId,
        networkId: networkId,
        instanceId: instanceId
    };
    $982b88ab7c902538$var$SESSION_ID = sid;
    $982b88ab7c902538$export$23acd045a5f13e20(playerName, zoneId, criteria, isTempserver);
    sessionStorage.setItem('autologin', 'true');
    return true;
};
var $982b88ab7c902538$export$34a12a01a131b126 = function() {
    var sessionCode = sessionStorage.getItem('code');
    if (sessionCode) $982b88ab7c902538$export$7a5d735b2ab6389d.input.value = sessionCode;
};
var $982b88ab7c902538$export$e6e61eb911209324 = function() {
    var queryParameters = new URLSearchParams(window.location.search);
    var hasError = queryParameters.has('errorStatusCode');
    if (!hasError) return false;
    var errorMessage;
    var _queryParameters_get;
    var errorStatusCode = (_queryParameters_get = queryParameters.get('errorStatusCode')) !== null && _queryParameters_get !== void 0 ? _queryParameters_get : '';
    switch(errorStatusCode){
        case '404':
            errorMessage = $982b88ab7c902538$export$a984e488de492859.getTranslatedText('webshop_offer_voucher_codeIsIncorrect');
            break;
        case '423':
            errorMessage = $982b88ab7c902538$export$a984e488de492859.getTranslatedText('webShop_accountBanned_desc');
            break;
        case '498':
            errorMessage = $982b88ab7c902538$export$a984e488de492859.getTranslatedText('mbs_access_error_sessionExpired_desc');
            break;
        default:
            (0, $a672116401b1250a$export$275a2173e9d84865)("Error returned from validate API: ".concat(errorStatusCode));
            errorMessage = $982b88ab7c902538$export$a984e488de492859.getTranslatedText('webShop_unexpectedError_desc');
            break;
    }
    $982b88ab7c902538$export$ef8e8b39ab9323e1(true, errorMessage, true);
    return true;
};
var $982b88ab7c902538$export$7a5d735b2ab6389d = {
    feedbackMessage: document.querySelector('#feedback-message'),
    feedbackMessageBox: document.querySelector('#feedback-message-box'),
    input: document.querySelector('#shoppingCode'),
    btnOk: document.querySelector('#btn-ok'),
    btnContinue: document.querySelector('#btn-continue'),
    codeForm: document.querySelector('#code-form'),
    autoLoginForm: document.querySelector('#autologin-form'),
    btnFindCode: document.querySelector('#btn-find-code'),
    findCodeModal: document.querySelector('#find-code-modal'),
    termsLink: document.querySelector('#terms-link'),
    legalLink: document.querySelector('#legal-link'),
    supportLink: document.querySelector('#support-link'),
    welcomeTitle: document.querySelector('#welcome-title')
};
var $982b88ab7c902538$export$23acd045a5f13e20 = function(playerName, zoneId, criteria, isTempserver) {
    $982b88ab7c902538$export$7a5d735b2ab6389d.welcomeTitle.textContent = $982b88ab7c902538$export$a984e488de492859.getTranslatedText('mbs_access_welcome_desc').replace('{0}', playerName);
    $982b88ab7c902538$export$7a5d735b2ab6389d.autoLoginForm.classList.toggle('d-none', false);
    window.addEventListener('load', function() {
        var _window_CanvasAgent;
        if (typeof ((_window_CanvasAgent = window.CanvasAgent) === null || _window_CanvasAgent === void 0 ? void 0 : _window_CanvasAgent.create) === 'function') {
            var tokenCookie = (0, (/*@__PURE__*/$parcel$interopDefault($37b4db63c35f7018$exports))).get('token');
            if (!tokenCookie) return false;
            window.CanvasAgent.create({
                authClientId: 'lemonstand',
                canvasAppId: "SET_CORRECT_ID",
                token: tokenCookie,
                debug: "false",
                locale: $982b88ab7c902538$var$getSupportedIgsLocale($982b88ab7c902538$export$a984e488de492859.language)
            }).then(function(res) {
                $982b88ab7c902538$export$bef1f36f5486a6a3('Canvas agent initiated');
                window.CanvasAgent.instance = res;
                $982b88ab7c902538$export$7a5d735b2ab6389d.btnContinue.addEventListener('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    res.show();
                    return false;
                });
            }).catch(function(error) {
                console.error('Cannot create instance of Canvas', error);
            });
        } else {
            // Store the success URL for navigation after tracking
            var successUrl = $982b88ab7c902538$export$ce5a0e3c9b89f8c9({
                zoneId: zoneId,
                criteria: criteria,
                isTempserver: isTempserver
            });
            $982b88ab7c902538$export$7a5d735b2ab6389d.autoLoginForm.dataset.successUrl = successUrl;
        }
    });
};
var $982b88ab7c902538$export$f5bae168354f5b42 = function() {
    $982b88ab7c902538$export$7a5d735b2ab6389d.codeForm.classList.toggle('d-none', false);
};
var $982b88ab7c902538$export$ef8e8b39ab9323e1 = function(doDisplay) {
    var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', isError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    $982b88ab7c902538$export$7a5d735b2ab6389d.input.style.color = isError ? '#FF5666' : '#9FFFCB';
    $982b88ab7c902538$export$7a5d735b2ab6389d.feedbackMessage.textContent = message;
    $982b88ab7c902538$export$7a5d735b2ab6389d.feedbackMessageBox.classList.toggle('d-none', !doDisplay);
};
var $982b88ab7c902538$export$d675b3969e4857cb = {
    enable: function() {
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.removeAttribute('disabled');
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.classList.remove('disabled');
    },
    disable: function() {
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.setAttribute('disabled', 'true');
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.classList.add('disabled');
    },
    toggle: function() {
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.toggleAttribute('disabled');
        $982b88ab7c902538$export$7a5d735b2ab6389d.btnOk.classList.toggle('disabled');
    }
};
var $982b88ab7c902538$var$getSupportedIgsLocale = function(language) {
    // Supported chinese variations
    // 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW'
    // TODO: after PMT-2369 is done, we dont need to worry about formatting the locale before sending to IGS
    var igsSpecificLocaleMapper = new Map([
        [
            'zh',
            'zh-Hans'
        ],
        [
            'zh-cn',
            'zh-Hans'
        ],
        [
            'zh-hans',
            'zh-Hans'
        ],
        [
            'zh-tw',
            'zh-Hant'
        ],
        [
            'zh-hant',
            'zh-Hant'
        ]
    ]);
    if (igsSpecificLocaleMapper.has(language)) return igsSpecificLocaleMapper.get(language);
    return $982b88ab7c902538$export$a984e488de492859.languageWithoutRegion;
};
var $982b88ab7c902538$export$ce5a0e3c9b89f8c9 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_zoneId = _ref.zoneId, zoneId = _ref_zoneId === void 0 ? '' : _ref_zoneId, _ref_criteria = _ref.criteria, criteria = _ref_criteria === void 0 ? '' : _ref_criteria, _ref_isTempserver = _ref.isTempserver, isTempserver = _ref_isTempserver === void 0 ? false : _ref_isTempserver;
    var supportedIgsLocale = $982b88ab7c902538$var$getSupportedIgsLocale($982b88ab7c902538$export$a984e488de492859.language);
    var queryParameters = (0, $44df43b91545a470$export$71511d61b312f219)({
        locale: supportedIgsLocale,
        sid: $982b88ab7c902538$var$SESSION_ID,
        standalone: '1',
        callOrigin: window.location.href,
        'lemonstand.customization.url': isTempserver ? "https://cdn.jsdelivr.net/npm/@lemonstand.org/config-goodgamestudios@ef/dist/goodgamestudios-mbs-temp.json" : "https://cdn.jsdelivr.net/npm/@lemonstand.org/config-goodgamestudios@ef/dist/goodgamestudios-mbs.json"
    }, zoneId ? {
        zoneId: zoneId
    } : {}, criteria ? {
        criteria: criteria
    } : {});
    var formattedParameters = new URLSearchParams(queryParameters).toString();
    // Choose webshop link based on current domain
    // goodgamestudios.com uses _GGS URLs, ggs-ep.com uses _EP URLs
    var isGoodGameDomain = window.location.origin.includes('goodgamestudios.com');
    var baseUrl = isGoodGameDomain ? "https://ef-canvas.public.ggs-ep.com" : "https://ef-canvas.public.ggs-ep.com";
    var webshopLink = "".concat(baseUrl, "?").concat(formattedParameters);
    return webshopLink;
};
var $982b88ab7c902538$export$50b7a8a7b6f81872 = function() {
    var queryParameters = {
        lang: $982b88ab7c902538$export$a984e488de492859.language,
        sid: $982b88ab7c902538$var$SESSION_ID
    };
    var formattedParameters = new URLSearchParams(queryParameters).toString();
    var webshopLink = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(formattedParameters);
    return webshopLink;
};
var $982b88ab7c902538$export$d097bb02eb6577bb = function() {
    // Choose accounts service based on current domain to maintain domain consistency
    // goodgamestudios.com uses _GGS URLs, ggs-ep.com uses _EP URLs
    var isGoodGameDomain = window.location.origin.includes('goodgamestudios.com');
    var accountsServiceUrl = isGoodGameDomain ? "https://accounts.public.ggs-ep.com/login/lemonstand" : "https://accounts.public.ggs-ep.com/login/lemonstand";
    $982b88ab7c902538$export$7a5d735b2ab6389d.codeForm.setAttribute('action', accountsServiceUrl);
    (0, $a672116401b1250a$export$dfe04b9b30f4004a)('errorUrl', $982b88ab7c902538$export$50b7a8a7b6f81872(), $982b88ab7c902538$export$7a5d735b2ab6389d.codeForm);
};
var $982b88ab7c902538$export$6a874b7a74007875 = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($37b4db63c35f7018$exports))).remove('mbsSession', {
        path: '/',
        domain: '.ggs-ep.com'
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($37b4db63c35f7018$exports))).remove('mbsSession', {
        path: '/',
        domain: '.goodgamestudios.com'
    });
};
var $982b88ab7c902538$export$bef1f36f5486a6a3 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).debug.apply(_console, [
        '%c CANVAS ->',
        'background: pink; color: #bada55, font-size:20px'
    ].concat((0, $f3a38006ec5aeddb$export$71511d61b312f219)(args)));
};
var $982b88ab7c902538$export$2241d74381e8e4f2 = function(src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.type = 'module';
    script.async = false;
    script.blocking = true;
    script.src = src;
    var head = document.head;
    head.insertBefore(script, head.firstElementChild);
    $982b88ab7c902538$export$bef1f36f5486a6a3('loadScript done');
};


// TODO: delete `if` during a permanent switch from Lemonstand to Canvas
// Check localstore for special flags (temporary until total Lemonstand replacement)
if (localStorage.getItem('cxf_canvas') === 'enabled') (0, $982b88ab7c902538$export$2241d74381e8e4f2)("https://app.canvas.stillfront.com/agent.js");
document.addEventListener('DOMContentLoaded', /*#__PURE__*/ (0, $61e1cd97499a53aa$export$71511d61b312f219)(function() {
    var _elements_input_value, wasErrorHandled, isAutoLoggedIn, isFirstLoad;
    return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
        switch(_state.label){
            case 0:
                (0, $982b88ab7c902538$export$a984e488de492859).init();
                wasErrorHandled = (0, $982b88ab7c902538$export$e6e61eb911209324)();
                isAutoLoggedIn = (0, $982b88ab7c902538$export$4adfdf36e0b63527)();
                // With this we are able to identify the loading from the user and ignore those from the error url
                isFirstLoad = !wasErrorHandled;
                if (!isAutoLoggedIn || !isFirstLoad) (0, $982b88ab7c902538$export$f5bae168354f5b42)();
                if (!isFirstLoad) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0, $982b88ab7c902538$export$593fa4e2a48c3c25)({
                        actionType: (0, $9d763a0e8ba22644$export$7b541698c79bb80a).PAGE_LOADED,
                        isAutoLoggedIn: isAutoLoggedIn ? 1 : 0
                    })
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                if (!isAutoLoggedIn) (0, $982b88ab7c902538$export$34a12a01a131b126)();
                if ((_elements_input_value = (0, $982b88ab7c902538$export$7a5d735b2ab6389d).input.value) === null || _elements_input_value === void 0 ? void 0 : _elements_input_value.trim()) (0, $982b88ab7c902538$export$d675b3969e4857cb).enable();
                return [
                    2
                ];
        }
    });
}));
(0, $982b88ab7c902538$export$7a5d735b2ab6389d).input.addEventListener('input', function() {
    (0, $982b88ab7c902538$export$ef8e8b39ab9323e1)(false);
    var code = (0, $982b88ab7c902538$export$7a5d735b2ab6389d).input.value;
    if (code.trim()) (0, $982b88ab7c902538$export$d675b3969e4857cb).enable();
    else (0, $982b88ab7c902538$export$d675b3969e4857cb).disable();
});
(0, $982b88ab7c902538$export$7a5d735b2ab6389d).codeForm.addEventListener('submit', function(event) {
    var code = (0, $982b88ab7c902538$export$7a5d735b2ab6389d).input.value;
    if (!code) {
        event.preventDefault();
        (0, $982b88ab7c902538$export$d675b3969e4857cb).disable();
        return;
    }
    sessionStorage.setItem('code', code);
    (0, $982b88ab7c902538$export$d097bb02eb6577bb)();
});
(0, $982b88ab7c902538$export$7a5d735b2ab6389d).autoLoginForm.addEventListener('submit', /*#__PURE__*/ function() {
    var _ref = (0, $61e1cd97499a53aa$export$71511d61b312f219)(function(event) {
        var successUrl;
        return (0, $6b96e7964ace224b$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Prevent default form submission to preserve query parameters
                    event.preventDefault();
                    sessionStorage.removeItem('autologin');
                    (0, $982b88ab7c902538$export$6a874b7a74007875)();
                    return [
                        4,
                        Promise.all([
                            (0, $982b88ab7c902538$export$593fa4e2a48c3c25)({
                                actionType: (0, $9d763a0e8ba22644$export$7b541698c79bb80a).CORRECT_CODE_ENTRY,
                                isAutoLoggedIn: 1
                            }),
                            (0, $982b88ab7c902538$export$e4771ae2bc0f2ca2)()
                        ])
                    ];
                case 1:
                    _state.sent();
                    // Get the success URL stored in the form's dataset
                    successUrl = (0, $982b88ab7c902538$export$7a5d735b2ab6389d).autoLoginForm.dataset.successUrl;
                    // Navigate to the success URL with all query parameters preserved
                    if (successUrl) window.location.href = successUrl;
                    return [
                        2
                    ];
            }
        });
    });
    return function(event) {
        return _ref.apply(this, arguments);
    };
}());
(0, $982b88ab7c902538$export$7a5d735b2ab6389d).btnFindCode.addEventListener('click', function() {
    var findCodeModal = new $2151b58506112de6$export$2b77a92f1a5ad772((0, $982b88ab7c902538$export$7a5d735b2ab6389d).findCodeModal);
    findCodeModal.show();
});

})();
//# sourceMappingURL=index.752045e6.js.map
